import { GraphQLClient } from 'graphql-request';
import { RequestInit } from 'graphql-request/dist/types.dom';
import { useQuery, useMutation, UseQueryOptions, UseMutationOptions } from 'react-query';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };

function fetcher<TData, TVariables extends { [key: string]: any }>(client: GraphQLClient, query: string, variables?: TVariables, requestHeaders?: RequestInit['headers']) {
  return async (): Promise<TData> => client.request({
    document: query,
    variables,
    requestHeaders
  });
}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BigInt: any;
  Date: any;
  DateTime: any;
  JSON: any;
  JSONObject: any;
  Upload: any;
};

export type AccountUserType = {
  __typename?: 'AccountUserType';
  accountId?: Maybe<Scalars['BigInt']>;
  emailId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  isAccountAdmin?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type AddAccountAccessInput = {
  message?: InputMaybe<Scalars['String']>;
};

export type AddAccountInput = {
  isAdmin: Scalars['Boolean'];
  name?: InputMaybe<Scalars['String']>;
  userEmailId?: InputMaybe<Scalars['String']>;
};

export type AddAnotherUserToAccountInput = {
  accountId?: InputMaybe<Scalars['BigInt']>;
  companies?: InputMaybe<Scalars['JSON']>;
  investorName?: InputMaybe<Scalars['String']>;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  role?: InputMaybe<Scalars['String']>;
  userEmailId?: InputMaybe<Scalars['String']>;
};

export type AddBeneficiaryInput = {
  beneficiaries?: InputMaybe<Array<InputMaybe<Beneficiary>>>;
  investmentId?: InputMaybe<Scalars['BigInt']>;
  investorId?: InputMaybe<Scalars['BigInt']>;
};

export type AddCompaniesToGroupInput = {
  companies?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  id?: InputMaybe<Scalars['BigInt']>;
};

export type AddCompanyInput = {
  cin?: InputMaybe<Scalars['String']>;
  currency: Scalars['String'];
  dba?: InputMaybe<Scalars['String']>;
  hissaCompanyId?: InputMaybe<Scalars['String']>;
  industry?: InputMaybe<Scalars['String']>;
  jurisdiction: Scalars['String'];
  name: Scalars['String'];
  sharePrice?: InputMaybe<Scalars['Float']>;
  valuation?: InputMaybe<Scalars['Float']>;
};

export type AddCompanyToListInput = {
  cin?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  name?: InputMaybe<Scalars['String']>;
};

export type AddDealTemplateInput = {
  description?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['Upload']>;
  investorId?: InputMaybe<Scalars['BigInt']>;
  jsonData?: InputMaybe<Scalars['JSON']>;
  name?: InputMaybe<Scalars['String']>;
  sections?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type AddDirectTransactionBulkUpload = {
  filename?: InputMaybe<Scalars['Upload']>;
};

export type AddDocumentToTransactionInput = {
  cin?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['BigInt']>;
  filename?: InputMaybe<Scalars['Upload']>;
  hissaCompanyId?: InputMaybe<Scalars['String']>;
  hissaRecordId?: InputMaybe<Scalars['String']>;
  hissaVerified?: InputMaybe<Scalars['Boolean']>;
  indirectInvestmentId?: InputMaybe<Scalars['BigInt']>;
  investmentId?: InputMaybe<Scalars['BigInt']>;
  investorId?: InputMaybe<Scalars['BigInt']>;
  isIndirect?: InputMaybe<Scalars['Boolean']>;
  key?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['BigInt']>;
  tags?: InputMaybe<Scalars['String']>;
  transaction?: InputMaybe<Scalars['Boolean']>;
};

export type AddEeCompanyMetricInput = {
  cin: Scalars['String'];
  compId: Scalars['BigInt'];
  metricId: Scalars['BigInt'];
  name: Scalars['String'];
  tags?: InputMaybe<Scalars['JSON']>;
  value: Scalars['String'];
};

export type AddEeFilterInput = {
  formula: Scalars['String'];
  group: Scalars['String'];
  name: Scalars['String'];
  type: FilterType;
};

export type AddEeMetricInput = {
  moniker: Scalars['String'];
  name: Scalars['String'];
  tags?: InputMaybe<Scalars['String']>;
  type: MetricType;
};

export type AddEePortfolioInput = {
  companies: Scalars['JSON'];
  expAmount: Scalars['Float'];
  minAmount: Scalars['Float'];
  name: Scalars['String'];
  numBuckets: Scalars['BigInt'];
  type: Scalars['String'];
};

export type AddEeThemeInput = {
  filterId: Scalars['BigInt'];
  inList?: InputMaybe<Scalars['String']>;
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
};

export type AddExitManualInvestment = {
  companyName?: InputMaybe<Scalars['String']>;
  exchangeRate?: InputMaybe<Scalars['Float']>;
  exitDate?: InputMaybe<Scalars['DateTime']>;
  exitType?: InputMaybe<Scalars['String']>;
  investmentId?: InputMaybe<Scalars['BigInt']>;
  investorName?: InputMaybe<Scalars['String']>;
  noOfShares?: InputMaybe<Scalars['BigInt']>;
  roundName?: InputMaybe<Scalars['String']>;
  sharePrice?: InputMaybe<Scalars['Float']>;
};

export type AddGroupInput = {
  companies?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  name?: InputMaybe<Scalars['String']>;
};

export type AddHissaCompanyInput = {
  companyId?: InputMaybe<Scalars['String']>;
  investorId?: InputMaybe<Scalars['BigInt']>;
  name?: InputMaybe<Scalars['String']>;
};

export type AddIndirectInvestmentInput = {
  cin?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  currentNAV?: InputMaybe<Scalars['Float']>;
  drawDown?: InputMaybe<Scalars['Float']>;
  estimatedFMV?: InputMaybe<Scalars['Float']>;
  hissaCompanyId?: InputMaybe<Scalars['String']>;
  indirectInvestorName?: InputMaybe<Scalars['String']>;
  industry?: InputMaybe<Scalars['String']>;
  investedAmount?: InputMaybe<Scalars['Float']>;
  investmentDate?: InputMaybe<Scalars['DateTime']>;
  investorId?: InputMaybe<Scalars['BigInt']>;
  noOfUnits?: InputMaybe<Scalars['Float']>;
  setupFee?: InputMaybe<Scalars['Float']>;
  unitType?: InputMaybe<Scalars['String']>;
};

export type AddIndirectTransactionsInput = {
  cin?: InputMaybe<Scalars['String']>;
  companyCurrency: Scalars['String'];
  companyValuation: Scalars['Float'];
  currentNAV: Scalars['Float'];
  currentSharePrice: Scalars['Float'];
  drawDown: Scalars['Float'];
  estimatedFMV: Scalars['Float'];
  exchangeRate?: InputMaybe<Scalars['Float']>;
  hissaCompanyId?: InputMaybe<Scalars['String']>;
  indirectInvestorName: Scalars['String'];
  industry?: InputMaybe<Scalars['String']>;
  investmentNav: Scalars['Float'];
  investorId: Scalars['BigInt'];
  jurisdiction: Scalars['String'];
  name: Scalars['String'];
  noOfUnits: Scalars['Float'];
  setupFee: Scalars['Float'];
  transactionAmount: Scalars['Float'];
  transactionCurrency: Scalars['String'];
  transactionDate: Scalars['DateTime'];
  unitType?: InputMaybe<Scalars['String']>;
};

export type AddInvestmentBulkUpload = {
  filename?: InputMaybe<Scalars['Upload']>;
};

export type AddInvestmentImportCaptable = {
  filename?: InputMaybe<Scalars['Upload']>;
};

export type AddInvestmentInput = {
  accountId?: InputMaybe<Scalars['BigInt']>;
  cin?: InputMaybe<Scalars['String']>;
  companyCurrency?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  currentExchangeRate?: InputMaybe<Scalars['Float']>;
  currentSharePrice?: InputMaybe<Scalars['Float']>;
  currentValuation?: InputMaybe<Scalars['Float']>;
  exchangeRate?: InputMaybe<Scalars['Float']>;
  industry?: InputMaybe<Scalars['String']>;
  investmentDate?: InputMaybe<Scalars['DateTime']>;
  investorId?: InputMaybe<Scalars['BigInt']>;
  jurisdiction?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  noOfShares?: InputMaybe<Scalars['BigInt']>;
  round?: InputMaybe<Scalars['String']>;
  shareDistinctiveRange?: InputMaybe<Scalars['JSON']>;
  sharePrice?: InputMaybe<Scalars['Float']>;
  valuation?: InputMaybe<Scalars['Float']>;
};

export type AddInvestorInput = {
  accountId?: InputMaybe<Scalars['BigInt']>;
  globalInvestorId: Scalars['String'];
  hissaId?: InputMaybe<Scalars['BigInt']>;
  isDirectInvestor?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  source: Source;
  type?: InputMaybe<Scalars['String']>;
};

export type AddInvestorToUserInput = {
  fundName?: InputMaybe<Scalars['String']>;
  fundType?: InputMaybe<Scalars['String']>;
  userId: Scalars['BigInt'];
};

export type AddLinkInput = {
  cin?: InputMaybe<Scalars['String']>;
  folder?: InputMaybe<Scalars['String']>;
  investorId?: InputMaybe<Scalars['BigInt']>;
  link?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type AddMisReportInput = {
  companyCurrency: Scalars['String'];
  companyCurrentSharePrice: Scalars['Float'];
  companyId?: InputMaybe<Scalars['BigInt']>;
  companyName: Scalars['String'];
  companyType: CompanyTypes;
  currency: Scalars['String'];
  file: Scalars['Upload'];
  hissaCompanyId?: InputMaybe<Scalars['String']>;
  jurisdiction: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  reportDate?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type AddMultipleInvestorToMultipleUserInput = {
  investorIds: Array<Scalars['BigInt']>;
  userIds: Array<Scalars['BigInt']>;
};

export type AddRolesToInvestorInput = {
  investorId?: InputMaybe<Scalars['BigInt']>;
  roleName?: InputMaybe<RoleName>;
};

export type AddSignatureInput = {
  fileName?: InputMaybe<Scalars['Upload']>;
  sign?: InputMaybe<Scalars['String']>;
};

export type AddTagsToCompanyInput = {
  companyId?: InputMaybe<Scalars['BigInt']>;
  companyName: Scalars['String'];
  companyType: CompanyTypes;
  currency: Scalars['String'];
  currentSharePrice: Scalars['Float'];
  hissaCompanyId?: InputMaybe<Scalars['String']>;
  jurisdiction: Scalars['String'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type AddTagsToDocumentInput = {
  companyCin?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  documentLinkId?: InputMaybe<Scalars['BigInt']>;
  id?: InputMaybe<Scalars['BigInt']>;
  isIndirect?: InputMaybe<Scalars['Boolean']>;
  isTransaction?: InputMaybe<Scalars['Boolean']>;
  key?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  vaultType?: InputMaybe<Document_Vault>;
};

export type AddTagsToInvestmentInput = {
  cin?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['BigInt']>;
  companyName?: InputMaybe<Scalars['String']>;
  hissaCompanyId?: InputMaybe<Scalars['String']>;
  hissaRecordId?: InputMaybe<Scalars['String']>;
  hissaVerified?: InputMaybe<Scalars['Boolean']>;
  investmentId?: InputMaybe<Scalars['BigInt']>;
  investorId?: InputMaybe<Scalars['BigInt']>;
  isIndirect?: InputMaybe<Scalars['Boolean']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type AddTagsToTransactionInput = {
  companyId?: InputMaybe<Scalars['BigInt']>;
  companyName: Scalars['String'];
  companyType: CompanyTypes;
  currency: Scalars['String'];
  exchangeRate: Scalars['Float'];
  hissaCompanyId?: InputMaybe<Scalars['String']>;
  hissaRecordId?: InputMaybe<Scalars['String']>;
  indirectInvestmentId?: InputMaybe<Scalars['BigInt']>;
  investedAmount: Scalars['Float'];
  investmentDate: Scalars['Date'];
  investmentId?: InputMaybe<Scalars['BigInt']>;
  investorId: Scalars['BigInt'];
  jurisdiction: Scalars['String'];
  metadata?: InputMaybe<Scalars['JSON']>;
  noOfShares: Scalars['Float'];
  notes?: InputMaybe<Scalars['String']>;
  securitySubType: Scalars['String'];
  sharePrice: Scalars['Float'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type AddTransactionInput = {
  cin?: InputMaybe<Scalars['String']>;
  companyCurrency: Scalars['String'];
  companyValuation: Scalars['Float'];
  currentSharePrice: Scalars['Float'];
  dba?: InputMaybe<Scalars['String']>;
  industry?: InputMaybe<Scalars['String']>;
  investorId: Scalars['BigInt'];
  jurisdiction: Scalars['String'];
  name: Scalars['String'];
  noOfShares: Scalars['Float'];
  roundName?: InputMaybe<Scalars['String']>;
  securitySubType: Scalars['String'];
  shareDistinctiveRange?: InputMaybe<Scalars['JSON']>;
  sharePrice: Scalars['Float'];
  transactionAmount: Scalars['Float'];
  transactionCurrency: Scalars['String'];
  transactionDate: Scalars['DateTime'];
  transactionExchangeRate?: InputMaybe<Scalars['Float']>;
  transactionType: Transaction_Type;
  valuation?: InputMaybe<Scalars['Float']>;
};

export type AddUserCurrencyInput = {
  userCurrency?: InputMaybe<Scalars['String']>;
};

export type AddUserToMultipleInvestorsInput = {
  accountId?: InputMaybe<Scalars['BigInt']>;
  investorIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  role?: InputMaybe<Scalars['String']>;
  userEmailId?: InputMaybe<Scalars['String']>;
};

export type AddValuationDetailsInput = {
  companyCurrency: Scalars['String'];
  companyCurrentSharePrice: Scalars['Float'];
  companyId?: InputMaybe<Scalars['BigInt']>;
  companyName: Scalars['String'];
  companyType: CompanyTypes;
  currency: Scalars['String'];
  file?: InputMaybe<Scalars['Upload']>;
  hissaCompanyId?: InputMaybe<Scalars['String']>;
  jurisdiction: Scalars['String'];
  methodology?: InputMaybe<Scalars['String']>;
  sharePrice?: InputMaybe<Scalars['Float']>;
  sharePriceBookValue?: InputMaybe<Scalars['Float']>;
  sharePricePerReport: Scalars['Float'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  valuationDate: Scalars['DateTime'];
  valuationName: Scalars['String'];
  valuationReport?: InputMaybe<Scalars['String']>;
  valuationType?: InputMaybe<Scalars['String']>;
  valuatorName?: InputMaybe<Scalars['String']>;
};

export type AddWatchlistInput = {
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<WatchlistEntityType>;
};

export type AggregateDataObject = {
  __typename?: 'AggregateDataObject';
  currentHoldingPercentage?: Maybe<Scalars['Float']>;
  currentValue?: Maybe<Scalars['Float']>;
  irr?: Maybe<Scalars['Float']>;
  moic?: Maybe<Scalars['Float']>;
  noOfHoldingCompanies?: Maybe<Scalars['Int']>;
  noOfInvestments?: Maybe<Scalars['Int']>;
  realizedValue?: Maybe<Scalars['Float']>;
  totalInvestment?: Maybe<Scalars['Float']>;
  totalNoOfCompanies?: Maybe<Scalars['Int']>;
};

export type AllTransactionsType = {
  __typename?: 'AllTransactionsType';
  aggregateData?: Maybe<AggregateDataObject>;
  companyData: CompanyObject;
  indirectTransactionData?: Maybe<Array<Maybe<IndirectTransactionObject>>>;
  investorData?: Maybe<Array<Maybe<InvestorObject>>>;
  roundData?: Maybe<Array<Maybe<RoundObject>>>;
  stage2CompanyDetails?: Maybe<GlobalCompanySearchType>;
  transactionData?: Maybe<Array<Maybe<TransactionObject>>>;
  valuationDetailsData?: Maybe<Array<Maybe<ValuationDetailsObject>>>;
};

export type Beneficiary = {
  name?: InputMaybe<Scalars['String']>;
  percentage?: InputMaybe<Scalars['Float']>;
  range?: InputMaybe<Scalars['JSON']>;
};

export type CacheInvalidationResult = {
  __typename?: 'CacheInvalidationResult';
  keysCleared: Scalars['Int'];
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type CancelGrantInput = {
  cancellationReason?: InputMaybe<Scalars['String']>;
  grantId: Scalars['BigInt'];
};

export type Company = {
  __typename?: 'Company';
  DBA?: Maybe<Scalars['String']>;
  angel?: Maybe<Scalars['BigInt']>;
  business?: Maybe<Scalars['String']>;
  cin?: Maybe<Scalars['String']>;
  commitmentAmount?: Maybe<Scalars['Float']>;
  companyCurrency?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['BigInt']>;
  currentExchangeRate?: Maybe<Scalars['Float']>;
  currentSharePrice?: Maybe<Scalars['Float']>;
  currentValuation?: Maybe<Scalars['Float']>;
  esopHolding?: Maybe<Scalars['Float']>;
  exitData?: Maybe<Array<Maybe<Transaction>>>;
  founded?: Maybe<Scalars['String']>;
  founderHolding?: Maybe<Scalars['Float']>;
  hissaCompanyId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  incubationDate?: Maybe<Scalars['String']>;
  industry?: Maybe<Scalars['String']>;
  institutional?: Maybe<Scalars['BigInt']>;
  jurisdiction?: Maybe<Scalars['String']>;
  keyInvestors?: Maybe<Array<Maybe<Scalars['String']>>>;
  latestRaise?: Maybe<Scalars['Float']>;
  latestRaiseDate?: Maybe<Scalars['String']>;
  latestRound?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  noOfRounds?: Maybe<Scalars['Int']>;
  sharePrice?: Maybe<Scalars['Float']>;
  shareholders?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  shareholdingDetails?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  starred?: Maybe<Scalars['Boolean']>;
  t2CompanyId?: Maybe<Scalars['String']>;
  t3CompanyId?: Maybe<Scalars['String']>;
  totalFunding?: Maybe<Scalars['Float']>;
  totalInvestors?: Maybe<Scalars['BigInt']>;
  totalRaised?: Maybe<Scalars['Float']>;
  totalShares?: Maybe<Scalars['BigInt']>;
  valuation?: Maybe<Scalars['Float']>;
};

export type CompanyDataInput = {
  hissaCompanyId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  name?: InputMaybe<Scalars['String']>;
  type: CompanyTypes;
};

export type CompanyMetadataInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type CompanyMetadataType = {
  __typename?: 'CompanyMetadataType';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type CompanyObject = {
  __typename?: 'CompanyObject';
  boardMeetings?: Maybe<Scalars['JSON']>;
  businessDescription?: Maybe<Scalars['String']>;
  cashBalance?: Maybe<Scalars['Float']>;
  cin?: Maybe<Scalars['String']>;
  companyCurrency: Scalars['String'];
  companyMetadata?: Maybe<Array<Maybe<CompanyMetadataType>>>;
  companyStage?: Maybe<Scalars['String']>;
  corporateOfficeAddress?: Maybe<Scalars['String']>;
  dba?: Maybe<Scalars['String']>;
  directorDetails?: Maybe<Scalars['JSON']>;
  equityAuthorizedCapital?: Maybe<Scalars['Float']>;
  equityPaidUpCapital?: Maybe<Scalars['Float']>;
  esopHolding?: Maybe<Scalars['Float']>;
  financialData?: Maybe<FinancialType>;
  founderHoldingPercentage?: Maybe<Scalars['Float']>;
  hissaCompanyId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  incorporationDate?: Maybe<Scalars['String']>;
  industry?: Maybe<Scalars['String']>;
  isPrivate?: Maybe<Scalars['Boolean']>;
  jurisdiction?: Maybe<Scalars['String']>;
  latestRaise?: Maybe<Scalars['Float']>;
  latestRaiseDate?: Maybe<Scalars['String']>;
  latestRound?: Maybe<Scalars['String']>;
  liquidationPreference?: Maybe<Array<Maybe<LiquidationOverViewDetails>>>;
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  noOfRounds?: Maybe<Scalars['Int']>;
  preferenceAuthorizedCapital?: Maybe<Scalars['Float']>;
  preferencePaidUpCapital?: Maybe<Scalars['Float']>;
  revenue?: Maybe<Scalars['Float']>;
  securities?: Maybe<Array<Maybe<SecurityType>>>;
  sharePrice?: Maybe<Scalars['Float']>;
  shareholders?: Maybe<Array<Maybe<Shareholder>>>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  taskManagerProjects?: Maybe<Array<Maybe<UserProject>>>;
  totalFdbShares?: Maybe<Scalars['Float']>;
  totalFunding?: Maybe<Scalars['Float']>;
  type: CompanyTypes;
  valuation?: Maybe<Scalars['Float']>;
  valuationInCompanyCurrency?: Maybe<Scalars['Float']>;
};

export type CompanyType = {
  __typename?: 'CompanyType';
  companyId?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
};

export enum CompanyTypes {
  Direct = 'DIRECT',
  Hissa = 'HISSA',
  Indirect = 'INDIRECT',
  Stage2 = 'STAGE2'
}

export type CopyBeneficiaryInput = {
  fromId?: InputMaybe<Scalars['BigInt']>;
  investorId?: InputMaybe<Scalars['BigInt']>;
  toId?: InputMaybe<Scalars['BigInt']>;
};

export type CreateGrantInput = {
  companyCurrency?: InputMaybe<Scalars['String']>;
  companyFMV?: InputMaybe<Scalars['Float']>;
  companyName?: InputMaybe<Scalars['String']>;
  dba?: InputMaybe<Scalars['String']>;
  exercisePriceOrSarValue: Scalars['Float'];
  expiryDate?: InputMaybe<Scalars['DateTime']>;
  expiryNumber?: InputMaybe<Scalars['Int']>;
  expiryUnitType?: InputMaybe<ExpiryUnitType>;
  fmvDate?: InputMaybe<Scalars['DateTime']>;
  grantDate: Scalars['DateTime'];
  grantLetter?: InputMaybe<Scalars['String']>;
  grantType: GrantType;
  metadata?: InputMaybe<Scalars['JSON']>;
  notes?: InputMaybe<Scalars['String']>;
  numberExercised?: InputMaybe<Scalars['Float']>;
  numberGranted: Scalars['Float'];
  planDocument?: InputMaybe<Scalars['String']>;
  planName?: InputMaybe<Scalars['String']>;
  salePrice?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<GrantStatus>;
  userId?: InputMaybe<Scalars['BigInt']>;
  vestedOptions?: InputMaybe<Scalars['Int']>;
  vestingSchedule?: InputMaybe<CreateVestingScheduleInput>;
};

export type CreateLlmPromptInput = {
  entityType: EntityType;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  prompt: Scalars['String'];
};

export type CreateVestingMilestoneInput = {
  metadata?: InputMaybe<Scalars['JSON']>;
  milestoneDate: Scalars['DateTime'];
  numberToVest?: InputMaybe<Scalars['Int']>;
  percentageToVest?: InputMaybe<Scalars['Float']>;
  vestingScheduleId: Scalars['BigInt'];
};

export type CreateVestingScheduleInput = {
  cliffDurationMonths?: InputMaybe<Scalars['Int']>;
  grantId: Scalars['BigInt'];
  metadata?: InputMaybe<Scalars['JSON']>;
  performanceCriteria?: InputMaybe<Scalars['String']>;
  planName?: InputMaybe<Scalars['String']>;
  scheduleType: VestingScheduleType;
  totalVestingDurationMonths?: InputMaybe<Scalars['Int']>;
  vestedOptions?: InputMaybe<Scalars['Int']>;
  vestingFrequency?: InputMaybe<VestingFrequency>;
  vestingTemplateName?: InputMaybe<Scalars['String']>;
};

export type CurrencyExchangeInput = {
  currencyCode?: InputMaybe<Scalars['String']>;
  currencyName?: InputMaybe<Scalars['String']>;
};

export type CurrencyExchangeRate = {
  __typename?: 'CurrencyExchangeRate';
  currencyCode?: Maybe<Scalars['String']>;
  currencyName?: Maybe<Scalars['String']>;
  currencyRate?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['BigInt']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export enum Document_Vault {
  Company = 'COMPANY',
  Employee = 'EMPLOYEE',
  Investor = 'INVESTOR'
}

export type DealTemplate = {
  __typename?: 'DealTemplate';
  accountId?: Maybe<Scalars['BigInt']>;
  companiesIssuedTo?: Maybe<Array<Maybe<Scalars['String']>>>;
  creationDate?: Maybe<Scalars['String']>;
  documentType?: Maybe<Scalars['String']>;
  fileURL?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  investorId?: Maybe<Scalars['BigInt']>;
  jsonData?: Maybe<Scalars['JSON']>;
  lastIssuedDate?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sections?: Maybe<Array<Maybe<Scalars['String']>>>;
  thumbnailURL?: Maybe<Scalars['String']>;
};

export type DeleteDynamicTableInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type DeleteLlmPromptInput = {
  id: Scalars['BigInt'];
};

export type DeleteMisReportInput = {
  companyId?: InputMaybe<Scalars['BigInt']>;
  companyName?: InputMaybe<Scalars['String']>;
  companyType: CompanyTypes;
  hissaCompanyId?: InputMaybe<Scalars['String']>;
  id: Scalars['BigInt'];
};

export type DeletePrivateCaptableInput = {
  hissaCompanyId?: InputMaybe<Scalars['String']>;
};

export type DeleteValuationDetailsInput = {
  companyId?: InputMaybe<Scalars['BigInt']>;
  companyName?: InputMaybe<Scalars['String']>;
  hissaCompanyId?: InputMaybe<Scalars['String']>;
  hissaVerified?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['BigInt']>;
  investorId?: InputMaybe<Scalars['BigInt']>;
  valuationName?: InputMaybe<Scalars['String']>;
};

export type DirectTransactionType = {
  __typename?: 'DirectTransactionType';
  companyId?: Maybe<Scalars['BigInt']>;
  currency?: Maybe<Scalars['String']>;
  exchangeRate?: Maybe<Scalars['Float']>;
  investedAmount?: Maybe<Scalars['Float']>;
  investmentDate?: Maybe<Scalars['Date']>;
  investorId?: Maybe<Scalars['BigInt']>;
  noOfShares?: Maybe<Scalars['BigInt']>;
  roundName?: Maybe<Scalars['String']>;
  shareDistinctiveRange?: Maybe<Scalars['JSON']>;
  sharePrice?: Maybe<Scalars['Float']>;
};

export type DocumentSignIdInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type DocumentsType = {
  __typename?: 'DocumentsType';
  id?: Maybe<Scalars['BigInt']>;
  indirectInvestmentId?: Maybe<Scalars['BigInt']>;
  investmentId?: Maybe<Scalars['BigInt']>;
  isTransaction?: Maybe<Scalars['Boolean']>;
  key: Scalars['String'];
  name: Scalars['String'];
  size?: Maybe<Scalars['Float']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type DocxToPdfInput = {
  fileName?: InputMaybe<Scalars['Upload']>;
};

export type DynamicTableDataInput = {
  chartData?: InputMaybe<Scalars['JSON']>;
  description?: InputMaybe<Scalars['String']>;
  file?: InputMaybe<Scalars['Upload']>;
  id?: InputMaybe<Scalars['BigInt']>;
  isExisting?: InputMaybe<Scalars['Boolean']>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  tableData: Scalars['JSON'];
};

export type DynamicTableFilterInput = {
  filterName?: InputMaybe<Scalars['String']>;
  filterState: Scalars['JSON'];
  tableId?: InputMaybe<Scalars['BigInt']>;
  tableName: Scalars['String'];
};

export type DynamicTableFilters = {
  __typename?: 'DynamicTableFilters';
  filterName?: Maybe<Scalars['String']>;
  filterState?: Maybe<Scalars['JSON']>;
  id?: Maybe<Scalars['BigInt']>;
  tableId?: Maybe<Scalars['BigInt']>;
  tableName?: Maybe<Scalars['String']>;
};

export type DynamicTablePublicAccessInput = {
  id: Scalars['BigInt'];
  isPublic: Scalars['Boolean'];
};

export type DynamicTableType = {
  __typename?: 'DynamicTableType';
  chartData?: Maybe<Scalars['JSON']>;
  description?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  fileUrl?: Maybe<Scalars['String']>;
  googleSheetLink?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  tableData?: Maybe<Scalars['JSON']>;
  userId?: Maybe<Scalars['BigInt']>;
};

export type EditDirectTransactionInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  investorId: Scalars['BigInt'];
  noOfShares: Scalars['Float'];
  roundName?: InputMaybe<Scalars['String']>;
  securitySubType: Scalars['String'];
  shareDistinctiveRange?: InputMaybe<Scalars['JSON']>;
  sharePrice: Scalars['Float'];
  transactionAmount: Scalars['Float'];
  transactionCurrency: Scalars['String'];
  transactionDate: Scalars['DateTime'];
  transactionExchangeRate?: InputMaybe<Scalars['Float']>;
  transactionType: Transaction_Type;
  valuation?: InputMaybe<Scalars['Float']>;
};

export type EditEeCompanyMetricInput = {
  cin: Scalars['String'];
  compId: Scalars['BigInt'];
  id: Scalars['BigInt'];
  metricId: Scalars['BigInt'];
  name: Scalars['String'];
  tags?: InputMaybe<Scalars['JSON']>;
  value: Scalars['String'];
};

export type EditEeFilterInput = {
  formula: Scalars['String'];
  group: Scalars['String'];
  id: Scalars['BigInt'];
  name: Scalars['String'];
  type: FilterType;
};

export type EditEeMetricInput = {
  id: Scalars['BigInt'];
  moniker: Scalars['String'];
  name: Scalars['String'];
  tags?: InputMaybe<Scalars['String']>;
  type: MetricType;
};

export type EditEePortfolioInput = {
  companies?: InputMaybe<Scalars['JSON']>;
  expAmount?: InputMaybe<Scalars['Float']>;
  id: Scalars['BigInt'];
  minAmount?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  numBuckets?: InputMaybe<Scalars['BigInt']>;
  status?: InputMaybe<Scalars['String']>;
};

export type EditEeThemeInput = {
  filterId: Scalars['BigInt'];
  id: Scalars['BigInt'];
  inList?: InputMaybe<Scalars['String']>;
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
};

export type EditFmvInput = {
  currentNAV?: InputMaybe<Scalars['Float']>;
  estimatedFMV?: InputMaybe<Scalars['Float']>;
  investmentId?: InputMaybe<Scalars['BigInt']>;
  investorId?: InputMaybe<Scalars['BigInt']>;
};

export type EditIndirectCompanyDetailsInput = {
  cin?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  indirectInvestorName?: InputMaybe<Scalars['String']>;
  industry?: InputMaybe<Scalars['String']>;
  investmentId?: InputMaybe<Scalars['BigInt']>;
  investorId?: InputMaybe<Scalars['BigInt']>;
};

export type EditIndirectInvestmentInput = {
  accountId?: InputMaybe<Scalars['BigInt']>;
  companyName?: InputMaybe<Scalars['String']>;
  drawDown?: InputMaybe<Scalars['Float']>;
  indirectInvestorName?: InputMaybe<Scalars['String']>;
  indirectVehicleID?: InputMaybe<Scalars['BigInt']>;
  investedAmount?: InputMaybe<Scalars['Float']>;
  investmentDate?: InputMaybe<Scalars['DateTime']>;
  investmentId?: InputMaybe<Scalars['BigInt']>;
  investorId?: InputMaybe<Scalars['BigInt']>;
  noOfUnits?: InputMaybe<Scalars['Float']>;
  setupFee?: InputMaybe<Scalars['Float']>;
  unitType?: InputMaybe<Scalars['String']>;
};

export type EditIndirectTransactionsInput = {
  currentNAV: Scalars['Float'];
  drawDown: Scalars['Float'];
  estimatedFMV: Scalars['Float'];
  exchangeRate?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['BigInt']>;
  investmentNav: Scalars['Float'];
  investorId: Scalars['BigInt'];
  noOfUnits: Scalars['Float'];
  setupFee: Scalars['Float'];
  transactionAmount: Scalars['Float'];
  transactionCurrency: Scalars['String'];
  transactionDate: Scalars['DateTime'];
  unitType?: InputMaybe<Scalars['String']>;
};

export type EditInvestmentInput = {
  cin?: InputMaybe<Scalars['String']>;
  companyCurrency?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  currentExchangeRate?: InputMaybe<Scalars['Float']>;
  currentSharePrice?: InputMaybe<Scalars['Float']>;
  currentValuation?: InputMaybe<Scalars['Float']>;
  exchangeRate?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['BigInt']>;
  investmentDate?: InputMaybe<Scalars['DateTime']>;
  investorId?: InputMaybe<Scalars['BigInt']>;
  jurisdiction?: InputMaybe<Scalars['String']>;
  noOfShares?: InputMaybe<Scalars['BigInt']>;
  round?: InputMaybe<Scalars['String']>;
  shareDistinctiveRange?: InputMaybe<Scalars['JSON']>;
  sharePrice?: InputMaybe<Scalars['Float']>;
  valuation?: InputMaybe<Scalars['Float']>;
};

export type EditMisReportInput = {
  companyCurrency: Scalars['String'];
  companyCurrentSharePrice: Scalars['Float'];
  companyId?: InputMaybe<Scalars['BigInt']>;
  companyName: Scalars['String'];
  companyType: CompanyTypes;
  currency: Scalars['String'];
  file?: InputMaybe<Scalars['Upload']>;
  hissaCompanyId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  jurisdiction: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  reportDate?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type EditTermsheetTemplate = {
  documentType?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['Upload']>;
  investorId?: InputMaybe<Scalars['BigInt']>;
  jsonData?: InputMaybe<Scalars['JSON']>;
  name?: InputMaybe<Scalars['String']>;
  sections?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  templateId?: InputMaybe<Scalars['BigInt']>;
};

export type EditTransactionInput = {
  cin?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  hissaCompanyId?: InputMaybe<Scalars['String']>;
  hissaRecordId?: InputMaybe<Scalars['String']>;
  hissaVerified?: InputMaybe<Scalars['Boolean']>;
  noOfSecurities?: InputMaybe<Scalars['BigInt']>;
  shareDistinctiveRange?: InputMaybe<Scalars['JSON']>;
  transactionAmount?: InputMaybe<Scalars['Float']>;
  transactionDate?: InputMaybe<Scalars['DateTime']>;
};

export type EditValuationDetailsInput = {
  companyName?: InputMaybe<Scalars['String']>;
  file?: InputMaybe<Scalars['Upload']>;
  hissaCompanyId?: InputMaybe<Scalars['String']>;
  hissaVerified?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['BigInt']>;
  isValuationReport?: InputMaybe<Scalars['Boolean']>;
  methodology?: InputMaybe<Scalars['String']>;
  sharePrice?: InputMaybe<Scalars['Float']>;
  sharePriceBookValue?: InputMaybe<Scalars['Float']>;
  sharePricePerReport?: InputMaybe<Scalars['Float']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  valuationDate?: InputMaybe<Scalars['DateTime']>;
  valuationName?: InputMaybe<Scalars['String']>;
  valuationReport?: InputMaybe<Scalars['String']>;
  valuationType?: InputMaybe<Scalars['String']>;
  valuatorName?: InputMaybe<Scalars['String']>;
};

export type EditWatchlistInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  name?: InputMaybe<Scalars['String']>;
};

export enum Elements {
  Dashboard = 'DASHBOARD',
  EquityGrants = 'EQUITY_GRANTS',
  Events = 'EVENTS',
  FundMetrics = 'FUND_METRICS',
  IntentHistory = 'INTENT_HISTORY',
  Portfolio = 'PORTFOLIO',
  SearchChats = 'SEARCH_CHATS',
  Waitlist = 'WAITLIST',
  Watchlist = 'WATCHLIST'
}

export type EmailTermsheetInput = {
  companyEmail?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  investorEmail?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  termsheetId?: InputMaybe<Scalars['BigInt']>;
  type?: InputMaybe<Scalars['String']>;
};

export enum EntityType {
  Grant = 'Grant'
}

export type EoiInput = {
  comments?: InputMaybe<Scalars['String']>;
  companyCin?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['BigInt']>;
  companyName?: InputMaybe<Scalars['String']>;
  companyType?: InputMaybe<CompanyTypes>;
  esopFinancing?: InputMaybe<Scalars['JSON']>;
  hissaCompanyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  offerDetails?: InputMaybe<Scalars['JSON']>;
  offerType?: InputMaybe<Scalars['String']>;
};

export type EoiType = {
  __typename?: 'EoiType';
  comments?: Maybe<Scalars['String']>;
  companyCin?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['BigInt']>;
  companyName?: Maybe<Scalars['String']>;
  companyType?: Maybe<CompanyTypes>;
  createdAt?: Maybe<Scalars['DateTime']>;
  esopFinancing?: Maybe<Scalars['JSON']>;
  hissaCompanyId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  notes?: Maybe<Scalars['String']>;
  offerDetails?: Maybe<Scalars['JSON']>;
  offerType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ExistingCompanyType = {
  __typename?: 'ExistingCompanyType';
  companyId?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  companyType?: Maybe<Scalars['String']>;
};

export type ExitModelling = {
  __typename?: 'ExitModelling';
  companyFdbShares: Scalars['Float'];
  currentInvestmentDetails?: Maybe<ExitModellingTableDetails>;
  finalCurrentValue?: Maybe<Scalars['Float']>;
  finalHoldingPercentage: Scalars['Float'];
  finalInvestmentAmount: Scalars['Float'];
  heatMap: Array<Scalars['Float']>;
  nonPriceRoundHeatMap: Array<Scalars['Float']>;
  numberOfRounds: Scalars['Float'];
  tableDetails: Array<Maybe<ExitModellingTableDetails>>;
  valuationCap: Scalars['Float'];
};

export type ExitModellingTableDetails = {
  __typename?: 'ExitModellingTableDetails';
  currentValue?: Maybe<Scalars['Float']>;
  date: Scalars['String'];
  dilution: Scalars['Float'];
  exitHere: Scalars['Boolean'];
  holdingPercentage: Scalars['Float'];
  investment?: Maybe<Scalars['Float']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  revenue: Scalars['Float'];
  roundName?: Maybe<Scalars['String']>;
  roundSize: Scalars['Float'];
  valuation: Scalars['Float'];
};

export enum ExpiryUnitType {
  Days = 'DAYS',
  Months = 'MONTHS',
  Years = 'YEARS'
}

export type FetchAllCompaniesInput = {
  investorId?: InputMaybe<Scalars['BigInt']>;
  investorName?: InputMaybe<Scalars['String']>;
};

export type FetchCompanyInput = {
  cin?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['String']>;
  invId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FetchDealTemplatesInput = {
  investorId?: InputMaybe<Scalars['BigInt']>;
};

export type FetchInvestmentInput = {
  cin?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['BigInt']>;
  investmentId?: InputMaybe<Scalars['BigInt']>;
  investorId?: InputMaybe<Scalars['BigInt']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FetchTermsheetInput = {
  termsheetId?: InputMaybe<Scalars['BigInt']>;
};

export type FetchUrlPathInput = {
  accountId?: InputMaybe<Scalars['BigInt']>;
  companyId?: InputMaybe<Scalars['String']>;
  investorId?: InputMaybe<Scalars['BigInt']>;
};

export type FetchWatchlistInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type File = {
  __typename?: 'File';
  encoding: Scalars['String'];
  filename: Scalars['String'];
  mimetype: Scalars['String'];
};

export type FilesDataInput = {
  cId?: InputMaybe<Scalars['String']>;
  cin?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  hissaVerified?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['BigInt']>;
  isIndirect?: InputMaybe<Scalars['Boolean']>;
  vaultType?: InputMaybe<Document_Vault>;
};

export enum FilterType {
  Incrores = 'INCRORES',
  Inrupees = 'INRUPEES',
  List = 'LIST',
  Nestedlist = 'NESTEDLIST',
  Number = 'NUMBER',
  Percent = 'PERCENT'
}

export type FinancialData = {
  __typename?: 'FinancialData';
  cin?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['String']>;
  companyIsPrivate?: Maybe<Scalars['Boolean']>;
  data?: Maybe<Scalars['JSON']>;
  id?: Maybe<Scalars['String']>;
  isPrivate?: Maybe<Scalars['Boolean']>;
  misData?: Maybe<Scalars['JSON']>;
  name?: Maybe<Scalars['String']>;
  publicCompanyName?: Maybe<Scalars['String']>;
  s3Url?: Maybe<Scalars['String']>;
  timeline?: Maybe<Scalars['String']>;
  timelineType?: Maybe<Scalars['String']>;
  updatedDate?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['String']>;
};

export type FinancialType = {
  __typename?: 'FinancialType';
  data?: Maybe<Array<Maybe<FinancialData>>>;
  showRPT?: Maybe<ShowRptData>;
};

export type GenerateCertificateType = {
  certificateId?: InputMaybe<Scalars['String']>;
  hissaCompanyId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<CompanyTypes>;
};

export type GetAllDynamicFilterInput = {
  tableId?: InputMaybe<Scalars['BigInt']>;
};

export type GetAllFundsOfUserInput = {
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type GetAllInvestorsInput = {
  accountId?: InputMaybe<Scalars['BigInt']>;
  accountName?: InputMaybe<Scalars['String']>;
};

export type GetDynamicFilterInput = {
  filterName?: InputMaybe<Scalars['String']>;
  tableId?: InputMaybe<Scalars['BigInt']>;
  tableName?: InputMaybe<Scalars['String']>;
};

export type GetEeCompanyMetricsInput = {
  cin: Scalars['String'];
  compId: Scalars['BigInt'];
  name: Scalars['String'];
};

export type GetGroupInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type GetIndirectInvestmentInput = {
  companyName?: InputMaybe<Scalars['String']>;
  indirectVehicleID?: InputMaybe<Scalars['BigInt']>;
  investorId?: InputMaybe<Scalars['BigInt']>;
};

export type GetInvestmentModellingDetailsInput = {
  hissaCompanyId?: InputMaybe<Scalars['String']>;
  modelId?: InputMaybe<Scalars['BigInt']>;
};

export type GetInvestorModellingInput = {
  hissaCompanyId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
};

export type GetLlmPromptsInput = {
  entityType?: InputMaybe<EntityType>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
};

export type GlobalCompanySearchType = {
  __typename?: 'GlobalCompanySearchType';
  angelHolding?: Maybe<Scalars['Float']>;
  angelInvestors?: Maybe<Array<Maybe<Scalars['String']>>>;
  annualRevenue2024?: Maybe<Scalars['String']>;
  annualRevenue2025?: Maybe<Scalars['String']>;
  businessModels?: Maybe<Array<Maybe<Scalars['String']>>>;
  category?: Maybe<Scalars['JSON']>;
  cin?: Maybe<Scalars['String']>;
  companyCurrency?: Maybe<Scalars['String']>;
  companyLogo?: Maybe<Scalars['String']>;
  companyMetadata?: Maybe<Scalars['JSON']>;
  companyReport?: Maybe<Scalars['String']>;
  companyStage?: Maybe<Scalars['String']>;
  companyType?: Maybe<Scalars['String']>;
  corporateOfficeAddress?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  dba?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  esopHolding?: Maybe<Scalars['Float']>;
  founders?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incorporationDate?: Maybe<Scalars['String']>;
  industry?: Maybe<Scalars['JSON']>;
  institutionalInvestors?: Maybe<Array<Maybe<Scalars['String']>>>;
  investorName?: Maybe<Scalars['String']>;
  isPrivate?: Maybe<Scalars['Boolean']>;
  jurisdiction?: Maybe<Scalars['String']>;
  latestFundedAmount?: Maybe<Scalars['String']>;
  latestFundedDate?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  relatedCompanies?: Maybe<Scalars['String']>;
  sector?: Maybe<Scalars['String']>;
  sharePrice?: Maybe<Scalars['Float']>;
  stage?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  totalEmployeeCount?: Maybe<Scalars['String']>;
  totalFunding?: Maybe<Scalars['String']>;
  type?: Maybe<WatchlistEntityType>;
  unlistedMetadata?: Maybe<Scalars['JSON']>;
  valuation?: Maybe<Scalars['Float']>;
  valuationDate?: Maybe<Scalars['String']>;
};

export type Grant = {
  __typename?: 'Grant';
  cancellationReason?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  companyCurrency?: Maybe<Scalars['String']>;
  companyFMV?: Maybe<Scalars['Float']>;
  companyFmvinUserCurrency?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  dba?: Maybe<Scalars['String']>;
  exercisePriceOrSarValue: Scalars['Float'];
  expiryDate?: Maybe<Scalars['DateTime']>;
  expiryNumber?: Maybe<Scalars['Int']>;
  expiryUnitType?: Maybe<ExpiryUnitType>;
  fmvDate?: Maybe<Scalars['DateTime']>;
  grantDate: Scalars['DateTime'];
  grantId: Scalars['BigInt'];
  grantLetter?: Maybe<Scalars['String']>;
  grantLetterUrl?: Maybe<Scalars['String']>;
  grantType: GrantType;
  metadata?: Maybe<Scalars['JSON']>;
  notes?: Maybe<Scalars['String']>;
  numberExercised?: Maybe<Scalars['Float']>;
  numberGranted: Scalars['Float'];
  planDocument?: Maybe<Scalars['String']>;
  planDocumentUrl?: Maybe<Scalars['String']>;
  planName?: Maybe<Scalars['String']>;
  salePrice?: Maybe<Scalars['Float']>;
  status: GrantStatus;
  strikePriceinUserCurrency?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  userId: Scalars['BigInt'];
  vestedOptions?: Maybe<Scalars['Int']>;
  vestingSchedules?: Maybe<Array<Maybe<VestingSchedule>>>;
};

export enum GrantStatus {
  Active = 'Active',
  Cancelled = 'Cancelled',
  Exercised = 'Exercised',
  Expired = 'Expired',
  InActive = 'InActive',
  Terminated = 'Terminated'
}

export enum GrantType {
  Esop = 'ESOP',
  Rsu = 'RSU',
  Sar = 'SAR'
}

export type GrantUploadInput = {
  file: Scalars['Upload'];
  isUpload?: InputMaybe<Scalars['Boolean']>;
};

export type Group = {
  __typename?: 'Group';
  companies?: Maybe<Array<Maybe<Scalars['String']>>>;
  id?: Maybe<Scalars['BigInt']>;
  name?: Maybe<Scalars['String']>;
};

export type Holding = {
  __typename?: 'Holding';
  business?: Maybe<Scalars['String']>;
  cin?: Maybe<Scalars['String']>;
  currentSharePrice?: Maybe<Scalars['Float']>;
  currentValue?: Maybe<Scalars['Float']>;
  exitValue?: Maybe<Scalars['Float']>;
  hissaVerified?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['BigInt']>;
  industry?: Maybe<Scalars['String']>;
  investedAmount?: Maybe<Scalars['Float']>;
  investmentDate?: Maybe<Scalars['DateTime']>;
  irr?: Maybe<Scalars['Float']>;
  isExited?: Maybe<Scalars['Boolean']>;
  leadInvestorName?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  moic?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  noOfShares?: Maybe<Scalars['Int']>;
  perSharePrice?: Maybe<Scalars['Float']>;
  percentage?: Maybe<Scalars['Float']>;
  round?: Maybe<Scalars['String']>;
};

export type IndirectInvestment = {
  accountId?: InputMaybe<Scalars['BigInt']>;
  cin?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['BigInt']>;
  companyName?: InputMaybe<Scalars['String']>;
  currentNAV?: InputMaybe<Scalars['BigInt']>;
  drawDown?: InputMaybe<Scalars['BigInt']>;
  estimatedFMV?: InputMaybe<Scalars['BigInt']>;
  hissaCompanyId?: InputMaybe<Scalars['String']>;
  indirectInvestorId?: InputMaybe<Scalars['BigInt']>;
  indirectInvestorName?: InputMaybe<Scalars['String']>;
  industry?: InputMaybe<Scalars['String']>;
  investedAmount?: InputMaybe<Scalars['BigInt']>;
  investmentDate?: InputMaybe<Scalars['DateTime']>;
  investmentId?: InputMaybe<Scalars['BigInt']>;
  investorId?: InputMaybe<Scalars['BigInt']>;
  noOfUnits?: InputMaybe<Scalars['BigInt']>;
  setupFee?: InputMaybe<Scalars['BigInt']>;
  unitType?: InputMaybe<Scalars['String']>;
};

export type IndirectTransactionObject = {
  __typename?: 'IndirectTransactionObject';
  currentNav?: Maybe<Scalars['Float']>;
  currentNavDate: Scalars['String'];
  currentValue: Scalars['Float'];
  documents?: Maybe<Array<Maybe<DocumentsType>>>;
  drawDown?: Maybe<Scalars['Float']>;
  exchangeRate?: Maybe<Scalars['Float']>;
  hissTransactionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  indirectVehicleID?: Maybe<Scalars['BigInt']>;
  indirectVehicleName?: Maybe<Scalars['String']>;
  investorId?: Maybe<Scalars['BigInt']>;
  investorName?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['JSON']>;
  noOfUnits: Scalars['Float'];
  notes?: Maybe<Scalars['String']>;
  setupFee?: Maybe<Scalars['Float']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  transactionAmount: Scalars['Float'];
  transactionCurrency: Scalars['String'];
  transactionDate: Scalars['String'];
  transactionNav: Scalars['Float'];
  unitType?: Maybe<Scalars['String']>;
};

export type IndirectTransactionType = {
  __typename?: 'IndirectTransactionType';
  companyId?: Maybe<Scalars['BigInt']>;
  currentNav?: Maybe<Scalars['Float']>;
  currentNavDate?: Maybe<Scalars['Float']>;
  drawDown?: Maybe<Scalars['Float']>;
  indirectVehicleID?: Maybe<Scalars['BigInt']>;
  investedAmount?: Maybe<Scalars['Float']>;
  investmentDate?: Maybe<Scalars['Date']>;
  investmentNav?: Maybe<Scalars['Float']>;
  investorId?: Maybe<Scalars['BigInt']>;
  noOfUnits?: Maybe<Scalars['BigInt']>;
  setupFee?: Maybe<Scalars['Float']>;
  unitType?: Maybe<Scalars['String']>;
};

export type IndividualInvestorCapTable = {
  __typename?: 'IndividualInvestorCapTable';
  amountInvestedInRound: Scalars['Float'];
  id: Scalars['String'];
  postHoldingFdbPercentage: Scalars['Float'];
  postHoldingFdbShares: Scalars['BigInt'];
  preHoldingFdbPercentage: Scalars['Float'];
  preHoldingFdbShares: Scalars['BigInt'];
  shareholderName: Scalars['String'];
  shareholderType: Scalars['String'];
};

export type InvalidateCacheByKeysInput = {
  keys: Array<Scalars['String']>;
  pattern?: InputMaybe<Scalars['String']>;
};

export type InvestmentByStage = {
  __typename?: 'InvestmentByStage';
  count?: Maybe<Scalars['Int']>;
  stage?: Maybe<Scalars['String']>;
};

export type InvestmentModellingDetails = {
  __typename?: 'InvestmentModellingDetails';
  investmentModellingDetails?: Maybe<ExitModelling>;
  modelName?: Maybe<Scalars['String']>;
  modellingDataId?: Maybe<Scalars['BigInt']>;
};

export type Investor = {
  __typename?: 'Investor';
  accountId?: Maybe<Scalars['BigInt']>;
  hissaId?: Maybe<Scalars['BigInt']>;
  holdings?: Maybe<Array<Maybe<Holding>>>;
  id?: Maybe<Scalars['BigInt']>;
  indirectHoldings?: Maybe<Scalars['JSON']>;
  indirectInvestment?: Maybe<Scalars['JSON']>;
  name?: Maybe<Scalars['String']>;
  portfolios?: Maybe<Array<Maybe<Portfolio>>>;
  watchlists?: Maybe<Array<Maybe<Watchlist>>>;
};

export type InvestorDataInput = {
  cin?: InputMaybe<Scalars['String']>;
  investorId?: InputMaybe<Scalars['BigInt']>;
};

export type InvestorDetail = {
  amountCommited?: InputMaybe<Scalars['BigInt']>;
  emailId?: InputMaybe<Scalars['String']>;
  investorId?: InputMaybe<Scalars['BigInt']>;
  investorName?: InputMaybe<Scalars['String']>;
};

export type InvestorDetailsType = {
  address?: InputMaybe<Scalars['String']>;
  conversionRatio?: InputMaybe<Scalars['Int']>;
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  security?: InputMaybe<Scalars['String']>;
  tranches?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type InvestorFetchInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  name?: InputMaybe<Scalars['String']>;
};

export type InvestorObject = {
  __typename?: 'InvestorObject';
  currentValue?: Maybe<Scalars['Float']>;
  exited?: Maybe<Scalars['Boolean']>;
  fdbHoldingPercentage?: Maybe<Scalars['Float']>;
  fdbShares?: Maybe<Scalars['Float']>;
  globalInvestorId?: Maybe<Scalars['String']>;
  id: Scalars['BigInt'];
  name: Scalars['String'];
};

export type InvestorOrCompanyInput = {
  companies?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  investorIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type InvestorRemoveInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export enum InvestorRoles {
  Admin = 'admin',
  CompanyAccess = 'companyAccess',
  Dashboard = 'dashboard',
  DocumentAssembler = 'documentAssembler',
  DynamicTable = 'dynamicTable',
  ExitEnabler = 'exitEnabler',
  ExitEnablerAdmin = 'exitEnablerAdmin',
  FundMetrics = 'fundMetrics',
  MyCaptables = 'myCaptables',
  Portfolio = 'portfolio',
  Watchlist = 'watchlist'
}

export type InvestorRoundModellingData = {
  __typename?: 'InvestorRoundModellingData';
  accountId?: Maybe<Scalars['BigInt']>;
  hissaCompanyId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  investmentModellingData?: Maybe<Scalars['JSON']>;
  name?: Maybe<Scalars['String']>;
};

export type InvestorRoundModellingInput = {
  companyId?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  investors?: InputMaybe<Array<InputMaybe<RoundInvestors>>>;
  roundDetails?: InputMaybe<RoundDetails>;
};

export type IrrTransactionType = {
  __typename?: 'IrrTransactionType';
  amount?: Maybe<Scalars['Float']>;
  date?: Maybe<Scalars['String']>;
};

export type ItemType = {
  __typename?: 'ItemType';
  data?: Maybe<Array<Maybe<ReportDataPointType>>>;
  subGroupItem?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type LiquidationOverViewDetails = {
  __typename?: 'LiquidationOverViewDetails';
  investment?: Maybe<Scalars['Float']>;
  investmentMultiple?: Maybe<Scalars['Float']>;
  isParriPassu?: Maybe<Scalars['Boolean']>;
  isParticipation?: Maybe<Scalars['Boolean']>;
  lpValue?: Maybe<Scalars['Float']>;
  participationCap?: Maybe<Scalars['Float']>;
  rank?: Maybe<Scalars['Float']>;
  securityClassId?: Maybe<Scalars['String']>;
  securityClassName?: Maybe<Scalars['String']>;
  securityType?: Maybe<Scalars['String']>;
};

export type LlmPrompt = {
  __typename?: 'LlmPrompt';
  createdAt: Scalars['DateTime'];
  entityType: EntityType;
  id: Scalars['BigInt'];
  isDefault: Scalars['Boolean'];
  prompt: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export enum MetricType {
  Amount = 'AMOUNT',
  Number = 'NUMBER',
  Percent = 'PERCENT'
}

export type MisDataType = {
  __typename?: 'MisDataType';
  companyName?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<ReportDataType>>>;
  fileUrl?: Maybe<Scalars['String']>;
  reportDate?: Maybe<Scalars['String']>;
  reportId?: Maybe<Scalars['BigInt']>;
  reportName?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  timeline?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type MisReportDataType = {
  __typename?: 'MisReportDataType';
  createdAt?: Maybe<Scalars['Date']>;
  fileUrl?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  name?: Maybe<Scalars['String']>;
  reportDate?: Maybe<Scalars['Date']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  AddAccountAccess?: Maybe<Scalars['String']>;
  achieveMilestone?: Maybe<VestingMilestone>;
  addAccountToUser?: Maybe<Scalars['JSON']>;
  addAnotherUserToAccount?: Maybe<Scalars['JSON']>;
  addBeneficiary?: Maybe<Scalars['JSONObject']>;
  addClassification?: Maybe<Scalars['JSON']>;
  addCompaniesToClassification?: Maybe<Scalars['JSON']>;
  addCompanyMisReport?: Maybe<MisReportDataType>;
  addCompanyToList?: Maybe<Scalars['JSONObject']>;
  addDealTemplate?: Maybe<Scalars['JSONObject']>;
  addDirectTransactionBulkUpload?: Maybe<Scalars['JSONObject']>;
  addDocumentLink?: Maybe<Scalars['JSON']>;
  addDocumentToTransaction?: Maybe<Scalars['JSONObject']>;
  addEECompanyMetric?: Maybe<Scalars['JSONObject']>;
  addEEFilter?: Maybe<Scalars['JSONObject']>;
  addEEMetric?: Maybe<Scalars['JSONObject']>;
  addEEPortfolio?: Maybe<Scalars['JSONObject']>;
  addEETheme?: Maybe<Scalars['JSONObject']>;
  addEoi?: Maybe<EoiType>;
  addExitManualInvestment?: Maybe<Scalars['JSONObject']>;
  addHissaCompany?: Maybe<Scalars['String']>;
  addIndirectInvestment?: Maybe<Scalars['JSONObject']>;
  addIndirectTransaction?: Maybe<IndirectTransactionType>;
  addInvestment?: Maybe<Scalars['JSONObject']>;
  addInvestmentBulkUpload?: Maybe<Scalars['JSONObject']>;
  addInvestmentImportCaptable?: Maybe<Scalars['JSONObject']>;
  /** add an investor entity to current user  no user id is required as it is taken from JWT */
  addInvestor?: Maybe<Scalars['JSONObject']>;
  addInvestorToUser?: Maybe<Investor>;
  addMultipleInvestorsToMultipleUsers?: Maybe<Scalars['String']>;
  addNewHissaCompaniesForInvestor?: Maybe<Array<Maybe<CompanyType>>>;
  addRolesToInvestor?: Maybe<Scalars['String']>;
  addSignature?: Maybe<Scalars['String']>;
  addTagsToCompany?: Maybe<Array<Maybe<Scalars['String']>>>;
  addTagsToDocument?: Maybe<Scalars['JSONObject']>;
  addTagsToInvestment?: Maybe<Array<Maybe<Scalars['String']>>>;
  addTagsToTransaction?: Maybe<Array<Maybe<Scalars['String']>>>;
  addTermsheet?: Maybe<Scalars['JSON']>;
  addTransaction?: Maybe<DirectTransactionType>;
  addUserCurrency?: Maybe<UserCurrency>;
  addUserRecentCompany?: Maybe<Array<Maybe<RecentCompanyType>>>;
  addUserToMultipleInvestors?: Maybe<Array<Maybe<Scalars['String']>>>;
  addValuationDetails?: Maybe<Scalars['JSON']>;
  addWatchlist?: Maybe<Scalars['JSONObject']>;
  cancelGrant?: Maybe<Grant>;
  copyBeneficiary?: Maybe<Scalars['JSONObject']>;
  createDynamicTableData?: Maybe<DynamicTableType>;
  createDynamicTableFilter?: Maybe<Scalars['String']>;
  createGrant?: Maybe<Grant>;
  createLlmPrompt?: Maybe<LlmPrompt>;
  createPrivateCaptable?: Maybe<PrivateCaptableType>;
  createVestingMilestone?: Maybe<VestingMilestone>;
  createVestingSchedule?: Maybe<VestingSchedule>;
  deleteCompanyMisReport?: Maybe<MisReportDataType>;
  deleteDynamicTableData?: Maybe<Scalars['String']>;
  deleteGrant?: Maybe<Scalars['Boolean']>;
  deleteIndirectInvestment?: Maybe<Scalars['JSONObject']>;
  deleteInvestorRoundModellingDetails?: Maybe<Scalars['String']>;
  deleteLlmPrompt?: Maybe<Scalars['Boolean']>;
  deletePrivateCaptables?: Maybe<Scalars['String']>;
  deleteValuationDetails?: Maybe<Scalars['String']>;
  deleteVestingMilestone?: Maybe<Scalars['Boolean']>;
  deleteVestingSchedule?: Maybe<Scalars['Boolean']>;
  docxToPdfConverter?: Maybe<Scalars['String']>;
  editClassification?: Maybe<Scalars['JSON']>;
  editCompanyMisReport?: Maybe<MisReportDataType>;
  editDirectTransaction?: Maybe<DirectTransactionType>;
  editEECompanyMetric?: Maybe<Scalars['JSONObject']>;
  editEEFilter?: Maybe<Scalars['JSONObject']>;
  editEEMetric?: Maybe<Scalars['JSONObject']>;
  editEEPortfolio?: Maybe<Scalars['JSONObject']>;
  editEETheme?: Maybe<Scalars['JSONObject']>;
  editFMV?: Maybe<Scalars['JSONObject']>;
  editIndirectCompanyDetails?: Maybe<Scalars['JSONObject']>;
  editIndirectInvestment?: Maybe<Scalars['JSONObject']>;
  editIndirectTransaction?: Maybe<IndirectTransactionType>;
  editInvestment?: Maybe<Scalars['JSONObject']>;
  editTermsheetTemplate?: Maybe<Scalars['JSONObject']>;
  editTransaction?: Maybe<Array<Maybe<Scalars['String']>>>;
  editValuationDetails?: Maybe<Scalars['JSON']>;
  editWatchlist?: Maybe<Scalars['JSONObject']>;
  emailTermsheet?: Maybe<Scalars['JSON']>;
  fileUpload?: Maybe<Scalars['JSON']>;
  getCurrencyExchangeRate?: Maybe<CurrencyExchangeRate>;
  invalidateAllCache?: Maybe<CacheInvalidationResult>;
  invalidateCacheByKeys?: Maybe<CacheInvalidationResult>;
  removeAccount?: Maybe<Scalars['JSON']>;
  removeBeneficiary?: Maybe<Scalars['JSONObject']>;
  removeClassification?: Maybe<Scalars['JSON']>;
  removeCompaniesFromClassification?: Maybe<Scalars['JSON']>;
  removeCompaniesOfInvestor?: Maybe<Array<Maybe<ExistingCompanyType>>>;
  removeCompanyFromList?: Maybe<Scalars['JSONObject']>;
  removeDealTemplate?: Maybe<Scalars['JSONObject']>;
  removeDocumentLink?: Maybe<Scalars['JSON']>;
  removeDynamicTableFilter?: Maybe<Scalars['String']>;
  removeEECompanyMetric?: Maybe<Scalars['JSONObject']>;
  removeEEFilter?: Maybe<Scalars['JSONObject']>;
  removeEEMetric?: Maybe<Scalars['JSONObject']>;
  removeEEPortfolio?: Maybe<Scalars['JSONObject']>;
  removeEETheme?: Maybe<Scalars['JSONObject']>;
  removeEEThemeFilter?: Maybe<Scalars['JSONObject']>;
  removeExistingCompanies?: Maybe<Array<Maybe<ExistingCompanyType>>>;
  removeExitManualInvestment?: Maybe<Scalars['JSONObject']>;
  removeExitModellingDetails?: Maybe<Scalars['String']>;
  removeHissaCompany?: Maybe<Scalars['String']>;
  removeIndirectTransaction?: Maybe<RemovedTransactionData>;
  removeInvestment?: Maybe<Scalars['JSONObject']>;
  removeInvestor?: Maybe<Scalars['JSONObject']>;
  removeInvestorOfUser?: Maybe<Scalars['String']>;
  removeObject?: Maybe<Scalars['JSON']>;
  removeTermsheet?: Maybe<Scalars['JSONObject']>;
  removeTransaction?: Maybe<RemovedTransactionData>;
  removeUserFromAccount?: Maybe<Scalars['String']>;
  removeUserRecentCompany?: Maybe<Array<Maybe<RecentCompanyType>>>;
  removeWatchlist?: Maybe<Scalars['JSONObject']>;
  saveInvestmentModellingDetails?: Maybe<InvestmentModellingDetails>;
  saveInvestorRoundModellingDetails?: Maybe<SavedInvestorModelling>;
  sendTermsheetToCaptable?: Maybe<Scalars['JSON']>;
  setDefaultLlmPrompt?: Maybe<LlmPrompt>;
  setDefaultValuation?: Maybe<Scalars['String']>;
  setDynamicTablePublicAccess?: Maybe<Scalars['String']>;
  shareInvestmentModelling?: Maybe<Scalars['String']>;
  singleUpload: File;
  switchAccount?: Maybe<Scalars['JSON']>;
  syncGoogleSheetToS3?: Maybe<Scalars['String']>;
  syncHissaCompaniesForInvestor?: Maybe<Array<Maybe<CompanyType>>>;
  updateCompanyDetails?: Maybe<Scalars['String']>;
  updateDealTemplate?: Maybe<Scalars['JSONObject']>;
  updateDefaultInvestor?: Maybe<Scalars['JSON']>;
  updateExitManualInvestment?: Maybe<Scalars['JSONObject']>;
  updateGrant?: Maybe<Grant>;
  updateInvestments?: Maybe<Scalars['JSONObject']>;
  updateLlmPrompt?: Maybe<LlmPrompt>;
  updateRoleOfInvestor?: Maybe<Scalars['String']>;
  updateVestingMilestone?: Maybe<VestingMilestone>;
  updateVestingSchedule?: Maybe<VestingSchedule>;
  uploadCompanyCaptable?: Maybe<Scalars['JSONObject']>;
  uploadCompanyOverview?: Maybe<Scalars['JSONObject']>;
  uploadGrantData?: Maybe<Scalars['JSON']>;
  upsertStarCompanyToWatchlist?: Maybe<StarCompanyType>;
  userInvestorCompanyRole?: Maybe<Scalars['JSON']>;
};


export type MutationAddAccountAccessArgs = {
  input?: InputMaybe<AddAccountAccessInput>;
};


export type MutationAchieveMilestoneArgs = {
  achievedDate?: InputMaybe<Scalars['DateTime']>;
  vestingMilestoneId: Scalars['BigInt'];
};


export type MutationAddAccountToUserArgs = {
  input?: InputMaybe<AddAccountInput>;
};


export type MutationAddAnotherUserToAccountArgs = {
  input?: InputMaybe<AddAnotherUserToAccountInput>;
};


export type MutationAddBeneficiaryArgs = {
  input?: InputMaybe<AddBeneficiaryInput>;
};


export type MutationAddClassificationArgs = {
  input?: InputMaybe<AddGroupInput>;
};


export type MutationAddCompaniesToClassificationArgs = {
  input?: InputMaybe<AddCompaniesToGroupInput>;
};


export type MutationAddCompanyMisReportArgs = {
  input?: InputMaybe<AddMisReportInput>;
};


export type MutationAddCompanyToListArgs = {
  input: AddCompanyToListInput;
};


export type MutationAddDealTemplateArgs = {
  input?: InputMaybe<AddDealTemplateInput>;
};


export type MutationAddDirectTransactionBulkUploadArgs = {
  input?: InputMaybe<AddDirectTransactionBulkUpload>;
};


export type MutationAddDocumentLinkArgs = {
  input?: InputMaybe<AddLinkInput>;
};


export type MutationAddDocumentToTransactionArgs = {
  input?: InputMaybe<AddDocumentToTransactionInput>;
};


export type MutationAddEeCompanyMetricArgs = {
  input?: InputMaybe<AddEeCompanyMetricInput>;
};


export type MutationAddEeFilterArgs = {
  input?: InputMaybe<AddEeFilterInput>;
};


export type MutationAddEeMetricArgs = {
  input?: InputMaybe<AddEeMetricInput>;
};


export type MutationAddEePortfolioArgs = {
  input?: InputMaybe<AddEePortfolioInput>;
};


export type MutationAddEeThemeArgs = {
  input?: InputMaybe<AddEeThemeInput>;
};


export type MutationAddEoiArgs = {
  input: EoiInput;
};


export type MutationAddExitManualInvestmentArgs = {
  input?: InputMaybe<AddExitManualInvestment>;
};


export type MutationAddHissaCompanyArgs = {
  input?: InputMaybe<AddHissaCompanyInput>;
};


export type MutationAddIndirectInvestmentArgs = {
  input?: InputMaybe<AddIndirectInvestmentInput>;
};


export type MutationAddIndirectTransactionArgs = {
  input?: InputMaybe<AddIndirectTransactionsInput>;
};


export type MutationAddInvestmentArgs = {
  input?: InputMaybe<AddInvestmentInput>;
};


export type MutationAddInvestmentBulkUploadArgs = {
  input?: InputMaybe<AddInvestmentBulkUpload>;
};


export type MutationAddInvestmentImportCaptableArgs = {
  input?: InputMaybe<AddInvestmentImportCaptable>;
};


export type MutationAddInvestorArgs = {
  input: AddInvestorInput;
};


export type MutationAddInvestorToUserArgs = {
  input: AddInvestorToUserInput;
};


export type MutationAddMultipleInvestorsToMultipleUsersArgs = {
  input?: InputMaybe<AddMultipleInvestorToMultipleUserInput>;
};


export type MutationAddNewHissaCompaniesForInvestorArgs = {
  input?: InputMaybe<SyncInvestorCompaniesInput>;
};


export type MutationAddRolesToInvestorArgs = {
  input?: InputMaybe<AddRolesToInvestorInput>;
};


export type MutationAddSignatureArgs = {
  input?: InputMaybe<AddSignatureInput>;
};


export type MutationAddTagsToCompanyArgs = {
  input?: InputMaybe<AddTagsToCompanyInput>;
};


export type MutationAddTagsToDocumentArgs = {
  input?: InputMaybe<AddTagsToDocumentInput>;
};


export type MutationAddTagsToInvestmentArgs = {
  input?: InputMaybe<AddTagsToInvestmentInput>;
};


export type MutationAddTagsToTransactionArgs = {
  input?: InputMaybe<AddTagsToTransactionInput>;
};


export type MutationAddTermsheetArgs = {
  input?: InputMaybe<TermsheetInput>;
  sendImmediately?: InputMaybe<Scalars['Boolean']>;
};


export type MutationAddTransactionArgs = {
  input?: InputMaybe<AddTransactionInput>;
};


export type MutationAddUserCurrencyArgs = {
  input?: InputMaybe<AddUserCurrencyInput>;
};


export type MutationAddUserRecentCompanyArgs = {
  input?: InputMaybe<RecentCompanyInput>;
};


export type MutationAddUserToMultipleInvestorsArgs = {
  input?: InputMaybe<AddUserToMultipleInvestorsInput>;
};


export type MutationAddValuationDetailsArgs = {
  input?: InputMaybe<AddValuationDetailsInput>;
};


export type MutationAddWatchlistArgs = {
  input: AddWatchlistInput;
};


export type MutationCancelGrantArgs = {
  input: CancelGrantInput;
};


export type MutationCopyBeneficiaryArgs = {
  input?: InputMaybe<CopyBeneficiaryInput>;
};


export type MutationCreateDynamicTableDataArgs = {
  input?: InputMaybe<DynamicTableDataInput>;
};


export type MutationCreateDynamicTableFilterArgs = {
  input?: InputMaybe<DynamicTableFilterInput>;
};


export type MutationCreateGrantArgs = {
  input: CreateGrantInput;
};


export type MutationCreateLlmPromptArgs = {
  input: CreateLlmPromptInput;
};


export type MutationCreatePrivateCaptableArgs = {
  input?: InputMaybe<PrivateCaptableInput>;
};


export type MutationCreateVestingMilestoneArgs = {
  input: CreateVestingMilestoneInput;
};


export type MutationCreateVestingScheduleArgs = {
  input: CreateVestingScheduleInput;
};


export type MutationDeleteCompanyMisReportArgs = {
  input?: InputMaybe<DeleteMisReportInput>;
};


export type MutationDeleteDynamicTableDataArgs = {
  input?: InputMaybe<DeleteDynamicTableInput>;
};


export type MutationDeleteGrantArgs = {
  grantId: Scalars['BigInt'];
};


export type MutationDeleteIndirectInvestmentArgs = {
  input?: InputMaybe<RemoveIndirectInvestmentInput>;
};


export type MutationDeleteInvestorRoundModellingDetailsArgs = {
  input?: InputMaybe<RemoveInvestorModellingInput>;
};


export type MutationDeleteLlmPromptArgs = {
  input: DeleteLlmPromptInput;
};


export type MutationDeletePrivateCaptablesArgs = {
  input?: InputMaybe<DeletePrivateCaptableInput>;
};


export type MutationDeleteValuationDetailsArgs = {
  input?: InputMaybe<DeleteValuationDetailsInput>;
};


export type MutationDeleteVestingMilestoneArgs = {
  vestingMilestoneId: Scalars['BigInt'];
};


export type MutationDeleteVestingScheduleArgs = {
  vestingScheduleId: Scalars['BigInt'];
};


export type MutationDocxToPdfConverterArgs = {
  input?: InputMaybe<DocxToPdfInput>;
};


export type MutationEditClassificationArgs = {
  input?: InputMaybe<UpdateGroupInput>;
};


export type MutationEditCompanyMisReportArgs = {
  input?: InputMaybe<EditMisReportInput>;
};


export type MutationEditDirectTransactionArgs = {
  input?: InputMaybe<EditDirectTransactionInput>;
};


export type MutationEditEeCompanyMetricArgs = {
  input?: InputMaybe<EditEeCompanyMetricInput>;
};


export type MutationEditEeFilterArgs = {
  input?: InputMaybe<EditEeFilterInput>;
};


export type MutationEditEeMetricArgs = {
  input?: InputMaybe<EditEeMetricInput>;
};


export type MutationEditEePortfolioArgs = {
  input?: InputMaybe<EditEePortfolioInput>;
};


export type MutationEditEeThemeArgs = {
  input?: InputMaybe<EditEeThemeInput>;
};


export type MutationEditFmvArgs = {
  input?: InputMaybe<EditFmvInput>;
};


export type MutationEditIndirectCompanyDetailsArgs = {
  input?: InputMaybe<EditIndirectCompanyDetailsInput>;
};


export type MutationEditIndirectInvestmentArgs = {
  input?: InputMaybe<EditIndirectInvestmentInput>;
};


export type MutationEditIndirectTransactionArgs = {
  input?: InputMaybe<EditIndirectTransactionsInput>;
};


export type MutationEditInvestmentArgs = {
  input?: InputMaybe<EditInvestmentInput>;
};


export type MutationEditTermsheetTemplateArgs = {
  input?: InputMaybe<EditTermsheetTemplate>;
};


export type MutationEditTransactionArgs = {
  input?: InputMaybe<EditTransactionInput>;
};


export type MutationEditValuationDetailsArgs = {
  input?: InputMaybe<EditValuationDetailsInput>;
};


export type MutationEditWatchlistArgs = {
  input: EditWatchlistInput;
};


export type MutationEmailTermsheetArgs = {
  input?: InputMaybe<EmailTermsheetInput>;
};


export type MutationFileUploadArgs = {
  input?: InputMaybe<UploadFile>;
};


export type MutationGetCurrencyExchangeRateArgs = {
  input?: InputMaybe<CurrencyExchangeInput>;
};


export type MutationInvalidateCacheByKeysArgs = {
  input: InvalidateCacheByKeysInput;
};


export type MutationRemoveAccountArgs = {
  input?: InputMaybe<RemoveAccountInput>;
};


export type MutationRemoveBeneficiaryArgs = {
  input?: InputMaybe<RemoveInvestmentInput>;
};


export type MutationRemoveClassificationArgs = {
  input?: InputMaybe<RemoveGroupInput>;
};


export type MutationRemoveCompaniesFromClassificationArgs = {
  input?: InputMaybe<AddCompaniesToGroupInput>;
};


export type MutationRemoveCompaniesOfInvestorArgs = {
  input?: InputMaybe<RemoveInvestorCompaniesInput>;
};


export type MutationRemoveCompanyFromListArgs = {
  input?: InputMaybe<RemoveCompanyFromListInput>;
};


export type MutationRemoveDealTemplateArgs = {
  input?: InputMaybe<RemoveDealTemplateInput>;
};


export type MutationRemoveDocumentLinkArgs = {
  input?: InputMaybe<RemoveLinkInput>;
};


export type MutationRemoveDynamicTableFilterArgs = {
  input?: InputMaybe<GetDynamicFilterInput>;
};


export type MutationRemoveEeCompanyMetricArgs = {
  input?: InputMaybe<RemoveEeCompanyMetricInput>;
};


export type MutationRemoveEeFilterArgs = {
  input?: InputMaybe<RemoveEeFilterInput>;
};


export type MutationRemoveEeMetricArgs = {
  input?: InputMaybe<RemoveEeMetricInput>;
};


export type MutationRemoveEePortfolioArgs = {
  input?: InputMaybe<RemoveEePortfolioInput>;
};


export type MutationRemoveEeThemeArgs = {
  input?: InputMaybe<RemoveEeThemeInput>;
};


export type MutationRemoveEeThemeFilterArgs = {
  input?: InputMaybe<RemoveEeThemeFilterInput>;
};


export type MutationRemoveExistingCompaniesArgs = {
  input?: InputMaybe<SyncInvestorCompaniesInput>;
};


export type MutationRemoveExitManualInvestmentArgs = {
  input?: InputMaybe<RemoveExitManualInvestment>;
};


export type MutationRemoveExitModellingDetailsArgs = {
  input?: InputMaybe<RemoveExitModelInput>;
};


export type MutationRemoveHissaCompanyArgs = {
  input?: InputMaybe<AddHissaCompanyInput>;
};


export type MutationRemoveIndirectTransactionArgs = {
  input?: InputMaybe<RemoveTransactionInput>;
};


export type MutationRemoveInvestmentArgs = {
  input?: InputMaybe<RemoveInvestmentInput>;
};


export type MutationRemoveInvestorArgs = {
  input?: InputMaybe<InvestorRemoveInput>;
};


export type MutationRemoveInvestorOfUserArgs = {
  input?: InputMaybe<RemoveInvestorOfUserInput>;
};


export type MutationRemoveObjectArgs = {
  input?: InputMaybe<UploadFile>;
};


export type MutationRemoveTermsheetArgs = {
  input?: InputMaybe<TermsheetRemoveInput>;
};


export type MutationRemoveTransactionArgs = {
  input?: InputMaybe<RemoveTransactionInput>;
};


export type MutationRemoveUserFromAccountArgs = {
  userId?: InputMaybe<Scalars['BigInt']>;
};


export type MutationRemoveUserRecentCompanyArgs = {
  input?: InputMaybe<Array<InputMaybe<RecentCompanyInput>>>;
};


export type MutationRemoveWatchlistArgs = {
  input?: InputMaybe<RemoveWatchlistInput>;
};


export type MutationSaveInvestmentModellingDetailsArgs = {
  input?: InputMaybe<SaveInvestmentModellingDetailsInput>;
};


export type MutationSaveInvestorRoundModellingDetailsArgs = {
  input?: InputMaybe<SaveInvestorModellingInput>;
};


export type MutationSendTermsheetToCaptableArgs = {
  input?: InputMaybe<FetchTermsheetInput>;
};


export type MutationSetDefaultLlmPromptArgs = {
  id: Scalars['BigInt'];
};


export type MutationSetDefaultValuationArgs = {
  input?: InputMaybe<SetDefaultValuationInput>;
};


export type MutationSetDynamicTablePublicAccessArgs = {
  input?: InputMaybe<DynamicTablePublicAccessInput>;
};


export type MutationShareInvestmentModellingArgs = {
  input?: InputMaybe<ShareInvestmentModellingDetailsInput>;
};


export type MutationSingleUploadArgs = {
  file: Scalars['Upload'];
};


export type MutationSwitchAccountArgs = {
  input: SwitchAccountInput;
};


export type MutationSyncGoogleSheetToS3Args = {
  input?: InputMaybe<SyncGoogleSheetInput>;
};


export type MutationSyncHissaCompaniesForInvestorArgs = {
  investorId?: InputMaybe<Scalars['BigInt']>;
};


export type MutationUpdateCompanyDetailsArgs = {
  input?: InputMaybe<UpdateCompanyDetailsInput>;
};


export type MutationUpdateDealTemplateArgs = {
  input?: InputMaybe<UpdateDealTemplateInput>;
};


export type MutationUpdateDefaultInvestorArgs = {
  defaultInvestorId?: InputMaybe<Scalars['BigInt']>;
};


export type MutationUpdateExitManualInvestmentArgs = {
  input?: InputMaybe<UpdateExitManualInvestment>;
};


export type MutationUpdateGrantArgs = {
  input: UpdateGrantInput;
};


export type MutationUpdateInvestmentsArgs = {
  input?: InputMaybe<UpdateInvestmentsInput>;
};


export type MutationUpdateLlmPromptArgs = {
  input: UpdateLlmPromptInput;
};


export type MutationUpdateRoleOfInvestorArgs = {
  input?: InputMaybe<UpdateRoleOfInvestorInput>;
};


export type MutationUpdateVestingMilestoneArgs = {
  input: UpdateVestingMilestoneInput;
};


export type MutationUpdateVestingScheduleArgs = {
  input: UpdateVestingScheduleInput;
};


export type MutationUploadCompanyCaptableArgs = {
  input?: InputMaybe<Type3FileUploadInput>;
};


export type MutationUploadCompanyOverviewArgs = {
  input?: InputMaybe<Type2FileUploadInput>;
};


export type MutationUploadGrantDataArgs = {
  input: GrantUploadInput;
};


export type MutationUpsertStarCompanyToWatchlistArgs = {
  input?: InputMaybe<StarCompanyInput>;
};


export type MutationUserInvestorCompanyRoleArgs = {
  input?: InputMaybe<UserInvestorCompanyRoleInput>;
};

export type Portfolio = {
  __typename?: 'Portfolio';
  holdings?: Maybe<Array<Maybe<Holding>>>;
  id?: Maybe<Scalars['BigInt']>;
  name?: Maybe<Scalars['String']>;
};

export type PortfolioEvents = {
  __typename?: 'PortfolioEvents';
  companyName?: Maybe<Scalars['String']>;
  eventDate?: Maybe<Scalars['Date']>;
  eventType?: Maybe<Scalars['String']>;
  investorId?: Maybe<Scalars['BigInt']>;
};

export type PrivateCaptableInput = {
  companyType?: InputMaybe<StageCompanyType>;
  file: Scalars['Upload'];
};

export type PrivateCaptableType = {
  __typename?: 'PrivateCaptableType';
  cin?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  companyType?: Maybe<StageCompanyType>;
  fileUrl?: Maybe<Scalars['String']>;
  hissaCompanyId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
};

export type Query = {
  __typename?: 'Query';
  BigInt?: Maybe<Scalars['BigInt']>;
  Date?: Maybe<Scalars['Date']>;
  JSON?: Maybe<Scalars['JSON']>;
  JSONObject?: Maybe<Scalars['JSONObject']>;
  allInvestments?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  allInvestorCompanies?: Maybe<Scalars['JSON']>;
  allTransactions?: Maybe<Array<Maybe<AllTransactionsType>>>;
  beneficiaries?: Maybe<Array<Maybe<Scalars['String']>>>;
  checkIsRequestSent?: Maybe<UserAccessType>;
  classification?: Maybe<Scalars['JSON']>;
  classifications?: Maybe<Scalars['JSON']>;
  companies: Array<Maybe<Company>>;
  companyObjects?: Maybe<Array<Maybe<CompanyObject>>>;
  companyWiseReport?: Maybe<Scalars['JSON']>;
  data?: Maybe<Scalars['JSON']>;
  dealTemplates?: Maybe<Array<Maybe<DealTemplate>>>;
  /** get default investor for user */
  defaultInvestor?: Maybe<Scalars['JSON']>;
  defaultLlmPrompt?: Maybe<LlmPrompt>;
  eeCompanyMetrics?: Maybe<Scalars['JSON']>;
  eeFilters?: Maybe<Scalars['JSON']>;
  eeInvests?: Maybe<Scalars['JSON']>;
  eeMetrics?: Maybe<Scalars['JSON']>;
  eePortfolios?: Maybe<Scalars['JSON']>;
  eeThemes?: Maybe<Scalars['JSON']>;
  exitDataInvestorWise?: Maybe<Array<Maybe<Transaction>>>;
  getAllAccountOfUser?: Maybe<Scalars['JSON']>;
  getAllDynamicTableFilter?: Maybe<Array<Maybe<DynamicTableFilters>>>;
  getAllExitModellingDetails?: Maybe<Array<Maybe<InvestmentModellingDetails>>>;
  getAllFundsOfUser?: Maybe<Scalars['JSON']>;
  getAllInvestorRoundModelling?: Maybe<Array<Maybe<InvestorRoundModellingData>>>;
  getAllInvestors?: Maybe<Scalars['JSON']>;
  getAllPrivateCaptables?: Maybe<Array<Maybe<PrivateCaptableType>>>;
  getAllUsersOfAccount?: Maybe<Array<Maybe<AccountUserType>>>;
  getAllValuationOfCompany?: Maybe<Scalars['JSON']>;
  getCompaniesOfOtherInvestor?: Maybe<Array<Maybe<ExistingCompanyType>>>;
  getCompanyData?: Maybe<AllTransactionsType>;
  getCompanyLatestReport?: Maybe<Array<Maybe<MisDataType>>>;
  getCompanyMisReportById?: Maybe<Array<Maybe<MisDataType>>>;
  getCompanyMisReports?: Maybe<Array<Maybe<MisReportDataType>>>;
  getDocumentSignId?: Maybe<Scalars['String']>;
  getDynamicTableData?: Maybe<Array<Maybe<DynamicTableType>>>;
  getDynamicTableFilter?: Maybe<DynamicTableFilters>;
  getEoi?: Maybe<Array<Maybe<EoiType>>>;
  getEoiForAllUsers?: Maybe<Array<Maybe<EoiType>>>;
  getExistingCompaniesForInvestor?: Maybe<Array<Maybe<ExistingCompanyType>>>;
  getInvestmentModellingDetails?: Maybe<InvestmentModellingDetails>;
  getInvestorRoundModellingDetails?: Maybe<Array<Maybe<IndividualInvestorCapTable>>>;
  getInvestorTransactions?: Maybe<Array<Maybe<IrrTransactionType>>>;
  getNewHissaCompaniesForInvestor?: Maybe<Array<Maybe<CompanyType>>>;
  getReGeneratedCertificate?: Maybe<Scalars['JSON']>;
  getSavedInvestorRoundModellingDetails?: Maybe<InvestorRoundModellingData>;
  getTermsheetTemplate?: Maybe<Scalars['JSON']>;
  getTermsheetUrlPath?: Maybe<TermsheetUrlPath>;
  getUserCurrency?: Maybe<Scalars['String']>;
  getUserProjects?: Maybe<Array<Maybe<UserProject>>>;
  getUserRecentCompanies?: Maybe<Array<Maybe<RecentCompanyType>>>;
  getUserRoles?: Maybe<Array<Maybe<UserRoles>>>;
  globalCompaniesSearch?: Maybe<Array<Maybe<GlobalCompanySearchType>>>;
  grant?: Maybe<Grant>;
  grantDetails?: Maybe<Grant>;
  grants?: Maybe<Array<Maybe<Grant>>>;
  indirectCompanies?: Maybe<Scalars['JSON']>;
  investmentByStage?: Maybe<Array<Maybe<InvestmentByStage>>>;
  investments?: Maybe<Scalars['JSON']>;
  /** get all investors for user */
  investors?: Maybe<Scalars['JSON']>;
  llmPrompt?: Maybe<LlmPrompt>;
  llmPrompts?: Maybe<Array<Maybe<LlmPrompt>>>;
  newWatchlists?: Maybe<Array<Maybe<WatchlistObject>>>;
  portfolioEvents?: Maybe<Array<Maybe<PortfolioEvents>>>;
  portfolioMetrics?: Maybe<Array<Maybe<RoundsCount>>>;
  portfolioOverviewReport?: Maybe<Scalars['JSON']>;
  /** search company for watchlist */
  searchCompany?: Maybe<Scalars['JSON']>;
  searchCompanyObject?: Maybe<Array<Maybe<AllTransactionsType>>>;
  starCompanies?: Maybe<Scalars['JSON']>;
  tasksOverview?: Maybe<Array<Maybe<TaskOverviewEvent>>>;
  termsheet?: Maybe<Scalars['JSON']>;
  termsheets?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  urlForS3Object?: Maybe<Scalars['String']>;
  vestingMilestone?: Maybe<VestingMilestone>;
  vestingMilestones?: Maybe<Array<Maybe<VestingMilestone>>>;
  vestingSchedule?: Maybe<VestingSchedule>;
  vestingSchedules?: Maybe<Array<Maybe<VestingSchedule>>>;
  watchlists?: Maybe<Array<Maybe<Watchlist>>>;
};


export type QueryAllInvestorCompaniesArgs = {
  input?: InputMaybe<FetchAllCompaniesInput>;
};


export type QueryClassificationArgs = {
  input?: InputMaybe<GetGroupInput>;
};


export type QueryCompaniesArgs = {
  input?: InputMaybe<FetchCompanyInput>;
};


export type QueryCompanyWiseReportArgs = {
  input?: InputMaybe<Array<InputMaybe<CompanyDataInput>>>;
};


export type QueryDataArgs = {
  input?: InputMaybe<FilesDataInput>;
};


export type QueryDefaultLlmPromptArgs = {
  entityType: EntityType;
};


export type QueryEeCompanyMetricsArgs = {
  input?: InputMaybe<GetEeCompanyMetricsInput>;
};


export type QueryExitDataInvestorWiseArgs = {
  investorIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};


export type QueryGetAllDynamicTableFilterArgs = {
  input?: InputMaybe<GetAllDynamicFilterInput>;
};


export type QueryGetAllExitModellingDetailsArgs = {
  input?: InputMaybe<GetInvestmentModellingDetailsInput>;
};


export type QueryGetAllFundsOfUserArgs = {
  userId?: InputMaybe<Scalars['BigInt']>;
};


export type QueryGetAllInvestorRoundModellingArgs = {
  input?: InputMaybe<GetInvestorModellingInput>;
};


export type QueryGetAllInvestorsArgs = {
  input?: InputMaybe<GetAllInvestorsInput>;
};


export type QueryGetAllValuationOfCompanyArgs = {
  input?: InputMaybe<ValuationDetailsInput>;
};


export type QueryGetCompaniesOfOtherInvestorArgs = {
  input?: InputMaybe<RemoveInvestorOfUserInput>;
};


export type QueryGetCompanyDataArgs = {
  input?: InputMaybe<CompanyDataInput>;
};


export type QueryGetCompanyLatestReportArgs = {
  input?: InputMaybe<CompanyDataInput>;
};


export type QueryGetCompanyMisReportByIdArgs = {
  input?: InputMaybe<DeleteMisReportInput>;
};


export type QueryGetCompanyMisReportsArgs = {
  input?: InputMaybe<CompanyDataInput>;
};


export type QueryGetDocumentSignIdArgs = {
  input?: InputMaybe<DocumentSignIdInput>;
};


export type QueryGetDynamicTableFilterArgs = {
  input?: InputMaybe<GetDynamicFilterInput>;
};


export type QueryGetExistingCompaniesForInvestorArgs = {
  investorId?: InputMaybe<Scalars['BigInt']>;
};


export type QueryGetInvestmentModellingDetailsArgs = {
  input?: InputMaybe<GetInvestmentModellingDetailsInput>;
};


export type QueryGetInvestorRoundModellingDetailsArgs = {
  input?: InputMaybe<InvestorRoundModellingInput>;
};


export type QueryGetInvestorTransactionsArgs = {
  input?: InputMaybe<CompanyDataInput>;
};


export type QueryGetNewHissaCompaniesForInvestorArgs = {
  investorId?: InputMaybe<Scalars['BigInt']>;
};


export type QueryGetReGeneratedCertificateArgs = {
  input?: InputMaybe<GenerateCertificateType>;
};


export type QueryGetSavedInvestorRoundModellingDetailsArgs = {
  input?: InputMaybe<GetInvestorModellingInput>;
};


export type QueryGetTermsheetTemplateArgs = {
  input?: InputMaybe<TemplateInput>;
};


export type QueryGetTermsheetUrlPathArgs = {
  input?: InputMaybe<FetchUrlPathInput>;
};


export type QueryGrantArgs = {
  grantId: Scalars['BigInt'];
};


export type QueryGrantDetailsArgs = {
  grantId: Scalars['BigInt'];
};


export type QueryIndirectCompaniesArgs = {
  input?: InputMaybe<FetchCompanyInput>;
};


export type QueryInvestmentByStageArgs = {
  input?: InputMaybe<InvestorOrCompanyInput>;
};


export type QueryInvestmentsArgs = {
  input?: InputMaybe<FetchInvestmentInput>;
};


export type QueryInvestorsArgs = {
  input?: InputMaybe<InvestorFetchInput>;
};


export type QueryLlmPromptArgs = {
  id: Scalars['BigInt'];
};


export type QueryLlmPromptsArgs = {
  input?: InputMaybe<GetLlmPromptsInput>;
};


export type QueryNewWatchlistsArgs = {
  input?: InputMaybe<FetchWatchlistInput>;
};


export type QueryPortfolioEventsArgs = {
  input?: InputMaybe<InvestorOrCompanyInput>;
};


export type QueryPortfolioMetricsArgs = {
  input?: InputMaybe<InvestorOrCompanyInput>;
};


export type QuerySearchCompanyArgs = {
  input?: InputMaybe<SearchCompanyInput>;
};


export type QuerySearchCompanyObjectArgs = {
  input?: InputMaybe<SearchCompanyInput>;
};


export type QueryStarCompaniesArgs = {
  input?: InputMaybe<QueryStarCompaniesArgsInput>;
};


export type QueryTermsheetArgs = {
  input?: InputMaybe<FetchTermsheetInput>;
};


export type QueryUrlForS3ObjectArgs = {
  input?: InputMaybe<S3ObjectUrl>;
};


export type QueryVestingMilestoneArgs = {
  vestingMilestoneId: Scalars['BigInt'];
};


export type QueryVestingMilestonesArgs = {
  vestingScheduleId: Scalars['BigInt'];
};


export type QueryVestingScheduleArgs = {
  vestingScheduleId: Scalars['BigInt'];
};


export type QueryVestingSchedulesArgs = {
  grantId: Scalars['BigInt'];
};


export type QueryWatchlistsArgs = {
  input?: InputMaybe<FetchWatchlistInput>;
};

export type QueryStarCompaniesArgsInput = {
  investorIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type RecentCompanyInput = {
  dba?: InputMaybe<Scalars['String']>;
  hissaCompanyId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  logo?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  type: CompanyTypes;
  visitedDateTime?: InputMaybe<Scalars['String']>;
};

export type RecentCompanyType = {
  __typename?: 'RecentCompanyType';
  dba?: Maybe<Scalars['String']>;
  hissaCompanyId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  logo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type: CompanyTypes;
  visitedDateTime?: Maybe<Scalars['String']>;
};

export type RemoveAccountInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type RemoveCompanyFromGroupInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  name?: InputMaybe<Scalars['String']>;
};

export type RemoveCompanyFromListInput = {
  companyId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
};

export type RemoveDealTemplateInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  investorId?: InputMaybe<Scalars['BigInt']>;
};

export type RemoveEeCompanyMetricInput = {
  id: Scalars['BigInt'];
};

export type RemoveEeFilterInput = {
  id: Scalars['BigInt'];
};

export type RemoveEeMetricInput = {
  id: Scalars['BigInt'];
};

export type RemoveEePortfolioInput = {
  id: Scalars['BigInt'];
};

export type RemoveEeThemeFilterInput = {
  id: Scalars['BigInt'];
};

export type RemoveEeThemeInput = {
  name: Scalars['String'];
};

export type RemoveExitManualInvestment = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type RemoveExitModelInput = {
  hissaCompanyId?: InputMaybe<Scalars['String']>;
  modelId?: InputMaybe<Scalars['BigInt']>;
};

export type RemoveGroupInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type RemoveIndirectInvestmentInput = {
  companyId?: InputMaybe<Scalars['BigInt']>;
  companyName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  indirectVehicleID?: InputMaybe<Scalars['BigInt']>;
  investorId?: InputMaybe<Scalars['BigInt']>;
  investorName?: InputMaybe<Scalars['String']>;
};

export type RemoveInvestmentInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  investorId?: InputMaybe<Scalars['BigInt']>;
};

export type RemoveInvestorCompaniesInput = {
  companies?: InputMaybe<Array<InputMaybe<SyncCompanyInput>>>;
  investorId?: InputMaybe<Scalars['BigInt']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type RemoveInvestorModellingInput = {
  hissaCompanyId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
};

export type RemoveInvestorOfUserInput = {
  investorId?: InputMaybe<Scalars['BigInt']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type RemoveLinkInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  investorId?: InputMaybe<Scalars['BigInt']>;
};

export type RemoveTransactionInput = {
  companyId: Scalars['BigInt'];
  id: Scalars['BigInt'];
  investorId: Scalars['BigInt'];
};

export type RemoveUserFromAccountInput = {
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type RemoveWatchlistInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type RemovedTransactionData = {
  __typename?: 'RemovedTransactionData';
  companyId?: Maybe<Scalars['BigInt']>;
  companyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  investorId?: Maybe<Scalars['BigInt']>;
};

export type ReportDataPointType = {
  __typename?: 'ReportDataPointType';
  actual?: Maybe<Scalars['Float']>;
  projected?: Maybe<Scalars['Float']>;
};

export type ReportDataType = {
  __typename?: 'ReportDataType';
  groupName?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Maybe<ItemType>>>;
};

export enum RoleName {
  Admin = 'ADMIN',
  AdminDynamicTable = 'ADMIN_DYNAMIC_TABLE',
  Portfolio = 'PORTFOLIO'
}

export type RoundDetails = {
  autoDiluteEsop?: InputMaybe<Scalars['Boolean']>;
  closeDate?: InputMaybe<Scalars['String']>;
  modelName?: InputMaybe<Scalars['String']>;
  postMoneyValuation?: InputMaybe<Scalars['Float']>;
  postRoundEsopPercentage?: InputMaybe<Scalars['Float']>;
  preMoneyValuation?: InputMaybe<Scalars['Float']>;
  roundId?: InputMaybe<Scalars['String']>;
  roundName?: InputMaybe<Scalars['String']>;
  roundSize?: InputMaybe<Scalars['Float']>;
};

export type RoundDetailsObject = {
  __typename?: 'RoundDetailsObject';
  roundIdentifier?: Maybe<Scalars['String']>;
  roundName?: Maybe<Scalars['String']>;
  roundType?: Maybe<Scalars['String']>;
};

export type RoundInvestors = {
  investmentAmount?: InputMaybe<Scalars['Float']>;
  noOfShares?: InputMaybe<Scalars['BigInt']>;
  nominalEquityShares?: InputMaybe<Scalars['BigInt']>;
  percentage?: InputMaybe<Scalars['Float']>;
  pricePerShare?: InputMaybe<Scalars['Float']>;
  securityType?: InputMaybe<Scalars['String']>;
  selectedType?: InputMaybe<Scalars['String']>;
  shareholderName?: InputMaybe<Scalars['String']>;
};

export type RoundObject = {
  __typename?: 'RoundObject';
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  postMoneyValuation?: Maybe<Scalars['Float']>;
  roundDate: Scalars['String'];
  roundSize: Scalars['Float'];
};

export type RoundsCount = {
  __typename?: 'RoundsCount';
  amount?: Maybe<Scalars['Float']>;
  count?: Maybe<Scalars['BigInt']>;
  investorId?: Maybe<Scalars['BigInt']>;
  investorName?: Maybe<Scalars['String']>;
};

export type S3ObjectUrl = {
  bucket?: InputMaybe<Scalars['String']>;
  expiry?: InputMaybe<Scalars['BigInt']>;
  isUpload?: InputMaybe<Scalars['Boolean']>;
  key?: InputMaybe<Scalars['String']>;
};

export enum Source {
  Existing = 'EXISTING',
  New = 'NEW'
}

export enum Star_Comp_Source {
  Portfolio = 'PORTFOLIO',
  Watchlist = 'WATCHLIST'
}

export type SaveInvestmentModellingDetailsInput = {
  hissaCompanyId?: InputMaybe<Scalars['String']>;
  investmentModellingDetails?: InputMaybe<Scalars['JSON']>;
  investorIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  modelName?: InputMaybe<Scalars['String']>;
  modellingDataId?: InputMaybe<Scalars['BigInt']>;
};

export type SaveInvestorModellingInput = {
  hissaCompanyId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  investorModellingDetails?: InputMaybe<Scalars['JSON']>;
  name?: InputMaybe<Scalars['String']>;
};

export type SavedInvestorModelling = {
  __typename?: 'SavedInvestorModelling';
  hissaCompanyId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  investorModellingDetails?: Maybe<Scalars['JSON']>;
  name?: Maybe<Scalars['String']>;
};

export type SearchCompanyInput = {
  name?: InputMaybe<Scalars['String']>;
};

export type SecurityType = {
  __typename?: 'SecurityType';
  capitalValue?: Maybe<Scalars['Float']>;
  holding?: Maybe<Scalars['Float']>;
  noOfClassess?: Maybe<Scalars['Float']>;
  noOfShares?: Maybe<Scalars['Float']>;
  parValue?: Maybe<Scalars['Float']>;
  securityType?: Maybe<Scalars['String']>;
};

export type SendTermsheetInput = {
  companyCin: Scalars['String'];
  companyName: Scalars['String'];
  investorId: Scalars['BigInt'];
};

export type SetDefaultValuationInput = {
  companyId?: InputMaybe<Scalars['BigInt']>;
  companyName?: InputMaybe<Scalars['String']>;
  companyType?: InputMaybe<CompanyTypes>;
  hissaCompanyId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  setDefault?: InputMaybe<Scalars['Boolean']>;
  valuationName?: InputMaybe<Scalars['String']>;
};

export type ShareCertificates = {
  __typename?: 'ShareCertificates';
  amountInvested?: Maybe<Scalars['Float']>;
  certificateId?: Maybe<Scalars['String']>;
  certificateName?: Maybe<Scalars['String']>;
  certificateUrl?: Maybe<Scalars['String']>;
  currentValue?: Maybe<Scalars['Float']>;
  demat?: Maybe<Scalars['Boolean']>;
  fdbShares?: Maybe<Scalars['BigInt']>;
  numberOfShares?: Maybe<Scalars['Float']>;
  pricePerShare?: Maybe<Scalars['Float']>;
  ranges?: Maybe<Scalars['JSON']>;
  remarks?: Maybe<Scalars['String']>;
  round?: Maybe<Scalars['String']>;
  roundDetails?: Maybe<Scalars['JSON']>;
  securityClass?: Maybe<Scalars['String']>;
  securityClassId?: Maybe<Scalars['String']>;
  securityType?: Maybe<Scalars['String']>;
};

export type ShareInvestmentModellingDetailsInput = {
  emailIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modellingDataId?: InputMaybe<Scalars['BigInt']>;
};

export type Shareholder = {
  __typename?: 'Shareholder';
  companyInvestorId?: Maybe<Scalars['String']>;
  emailId?: Maybe<Scalars['String']>;
  investedAmount?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  noOfShares?: Maybe<Scalars['Float']>;
  percentage?: Maybe<Scalars['Float']>;
  shareCertificates?: Maybe<Array<Maybe<ShareCertificates>>>;
  type?: Maybe<Scalars['String']>;
};

export type ShareholderSummary = {
  __typename?: 'ShareholderSummary';
  esopHolding?: Maybe<Scalars['Float']>;
  founderOwnerShip?: Maybe<Scalars['Float']>;
  leadInvestor?: Maybe<Scalars['String']>;
  noOfFounders?: Maybe<Scalars['Int']>;
  noOfInvestors?: Maybe<Scalars['Int']>;
};

export type ShowRptData = {
  __typename?: 'ShowRPTData';
  Monthly?: Maybe<Scalars['Boolean']>;
  Quarterly?: Maybe<Scalars['Boolean']>;
  Year?: Maybe<Scalars['Boolean']>;
};

export enum StageCompanyType {
  Stage_3 = 'Stage_3',
  Stage_4 = 'Stage_4'
}

export type StarCompanyInput = {
  companyId?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  isRemove?: InputMaybe<Scalars['Boolean']>;
  watchlistId?: InputMaybe<Scalars['BigInt']>;
};

export type StarCompanyType = {
  __typename?: 'StarCompanyType';
  companyId?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  watchlistId?: Maybe<Scalars['BigInt']>;
};

export type SwitchAccountInput = {
  accountId: Scalars['BigInt'];
};

export type SyncCompanyInput = {
  companyId?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  companyType?: InputMaybe<Scalars['String']>;
};

export type SyncGoogleSheetInput = {
  id: Scalars['BigInt'];
  sheetUrl: Scalars['String'];
};

export type SyncInvestorCompaniesInput = {
  investorId?: InputMaybe<Scalars['BigInt']>;
  newCompanies?: InputMaybe<Array<InputMaybe<SyncCompanyInput>>>;
};

export enum Task_Event {
  InvestmentMade = 'INVESTMENT_MADE',
  TermsheetIssued = 'TERMSHEET_ISSUED'
}

export enum Task_Event_Status {
  Completed = 'COMPLETED',
  Inprogress = 'INPROGRESS',
  Pending = 'PENDING'
}

export enum Transaction_Type {
  Antidilution = 'ANTIDILUTION',
  Bonus = 'BONUS',
  Buy = 'BUY',
  Cancel = 'CANCEL',
  Convert = 'CONVERT',
  Partlypaid = 'PARTLYPAID',
  Redeem = 'REDEEM',
  ReverseSplitAllocate = 'REVERSE_SPLIT_ALLOCATE',
  ReverseSplitCancel = 'REVERSE_SPLIT_CANCEL',
  SecondaryBuy = 'SECONDARY_BUY',
  Sell = 'SELL',
  Split = 'SPLIT',
  SplitAllocate = 'SPLIT_ALLOCATE',
  SplitCancel = 'SPLIT_CANCEL'
}

export type TaskOverviewEvent = {
  __typename?: 'TaskOverviewEvent';
  companyId?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  eventStatus?: Maybe<Task_Event_Status>;
  eventType?: Maybe<Task_Event>;
};

export type TemplateInput = {
  templateId?: InputMaybe<Scalars['BigInt']>;
  templateName?: InputMaybe<Scalars['String']>;
};

export type Termsheet = {
  __typename?: 'Termsheet';
  amountInvested?: Maybe<Scalars['BigInt']>;
  antiDilution?: Maybe<Scalars['String']>;
  companyCin: Scalars['String'];
  companyName: Scalars['String'];
  country?: Maybe<Scalars['String']>;
  diligence?: Maybe<Scalars['Boolean']>;
  directorBoardComposition?: Maybe<Scalars['Int']>;
  discount?: Maybe<Scalars['Float']>;
  discountConvertible?: Maybe<Scalars['Float']>;
  dragAlong?: Maybe<Scalars['String']>;
  exclusivity?: Maybe<Scalars['Int']>;
  exitRights?: Maybe<Scalars['String']>;
  expiryDate?: Maybe<Scalars['String']>;
  expiryDays?: Maybe<Scalars['Int']>;
  fileURL?: Maybe<Scalars['String']>;
  floorValuation?: Maybe<Scalars['BigInt']>;
  founderLockin?: Maybe<Scalars['String']>;
  founderVesting?: Maybe<Scalars['String']>;
  investorId: Scalars['BigInt'];
  investorRights?: Maybe<Array<Maybe<Scalars['String']>>>;
  isPricedRound?: Maybe<Scalars['Boolean']>;
  liquidationPreference?: Maybe<Scalars['String']>;
  observerBoardComposition?: Maybe<Scalars['Int']>;
  postRoundEsopPercentage?: Maybe<Scalars['Float']>;
  pricedRoundString?: Maybe<Scalars['String']>;
  proposedDate?: Maybe<Scalars['String']>;
  rightOfFO?: Maybe<Scalars['String']>;
  rightOfFR?: Maybe<Scalars['String']>;
  roundSize?: Maybe<Scalars['BigInt']>;
  tagAlong?: Maybe<Scalars['String']>;
  templateId?: Maybe<Scalars['Int']>;
  transactionCost?: Maybe<Scalars['String']>;
  validityMisc?: Maybe<Scalars['String']>;
  valuation?: Maybe<Scalars['BigInt']>;
  valuationCap?: Maybe<Scalars['BigInt']>;
};

export type TermsheetInput = {
  accountId?: InputMaybe<Scalars['BigInt']>;
  additionalSections?: InputMaybe<Scalars['JSON']>;
  cin?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  docURL?: InputMaybe<Scalars['String']>;
  eSignId?: InputMaybe<Scalars['String']>;
  expiryDate?: InputMaybe<Scalars['String']>;
  fileUrl?: InputMaybe<Scalars['String']>;
  investmentAmount?: InputMaybe<Scalars['BigInt']>;
  investorDetails?: InputMaybe<Array<InputMaybe<InvestorDetailsType>>>;
  investorId?: InputMaybe<Scalars['BigInt']>;
  investorName?: InputMaybe<Scalars['String']>;
  isSignRevoked?: InputMaybe<Scalars['Boolean']>;
  isSigned?: InputMaybe<Scalars['Boolean']>;
  mandatorySections?: InputMaybe<Scalars['JSON']>;
  roundSize?: InputMaybe<Scalars['BigInt']>;
  sections?: InputMaybe<Scalars['JSON']>;
  signedPdfURL?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  templateId?: InputMaybe<Scalars['Int']>;
  termsheetId?: InputMaybe<Scalars['BigInt']>;
  termsheetName?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  uploadPdfURL?: InputMaybe<Scalars['String']>;
  valuation?: InputMaybe<Scalars['BigInt']>;
};

export type TermsheetRemoveInput = {
  termsheetId?: InputMaybe<Scalars['BigInt']>;
};

export type TermsheetUrlPath = {
  __typename?: 'TermsheetUrlPath';
  docUrlPath?: Maybe<Scalars['String']>;
  presignedDocUrl?: Maybe<Scalars['String']>;
  presignedUrl?: Maybe<Scalars['String']>;
  urlPath?: Maybe<Scalars['String']>;
};

export type Transaction = {
  __typename?: 'Transaction';
  amount?: Maybe<Scalars['Float']>;
  cin?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  investorId?: Maybe<Scalars['String']>;
  investorName?: Maybe<Scalars['String']>;
  noOfShares?: Maybe<Scalars['BigInt']>;
  pricePerShare?: Maybe<Scalars['Float']>;
  roundIdentifier?: Maybe<Scalars['String']>;
  roundName?: Maybe<Scalars['String']>;
  transactionDate?: Maybe<Scalars['String']>;
  transactionType?: Maybe<Transaction_Type>;
};

export type TransactionObject = {
  __typename?: 'TransactionObject';
  amount: Scalars['Float'];
  companySharePrice?: Maybe<Scalars['Float']>;
  companyType: CompanyTypes;
  currency: Scalars['String'];
  documents?: Maybe<Array<Maybe<DocumentsType>>>;
  exchangeRate?: Maybe<Scalars['Float']>;
  globalInvestorId?: Maybe<Scalars['String']>;
  hissTransactionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  investorId: Scalars['BigInt'];
  investorName?: Maybe<Scalars['String']>;
  investorsData?: Maybe<InvestorObject>;
  metadata?: Maybe<Scalars['JSON']>;
  noOfShares: Scalars['Float'];
  notes?: Maybe<Scalars['String']>;
  round?: Maybe<Scalars['String']>;
  roundIdentifier?: Maybe<Scalars['String']>;
  securitySubType?: Maybe<Scalars['String']>;
  shareDistinctiveRange?: Maybe<Scalars['JSON']>;
  sharePrice?: Maybe<Scalars['Float']>;
  sharePriceInUserCurrency?: Maybe<Scalars['Float']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  transactionDate: Scalars['String'];
  transactionFdbShares?: Maybe<Scalars['Float']>;
  transactionType: Transaction_Type;
  transactionValuation?: Maybe<Scalars['Float']>;
};

export type Type2FileUploadInput = {
  cin?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['BigInt']>;
  companyName?: InputMaybe<Scalars['String']>;
  filename?: InputMaybe<Scalars['Upload']>;
};

export type Type3FileUploadInput = {
  cin?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['BigInt']>;
  companyName?: InputMaybe<Scalars['String']>;
  filename?: InputMaybe<Scalars['Upload']>;
};

export type UpdateCompanyDetailsInput = {
  cin?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['BigInt']>;
  companyMetadata?: InputMaybe<Array<InputMaybe<CompanyMetadataInput>>>;
  companyName?: InputMaybe<Scalars['String']>;
  companyType: CompanyTypes;
  currency: Scalars['String'];
  currentSharePrice?: InputMaybe<Scalars['Float']>;
  currentValuation?: InputMaybe<Scalars['Float']>;
  dba?: InputMaybe<Scalars['String']>;
  hissaCompanyId?: InputMaybe<Scalars['String']>;
  industry?: InputMaybe<Scalars['String']>;
  investmentId?: InputMaybe<Scalars['BigInt']>;
  investorId?: InputMaybe<Scalars['BigInt']>;
  isIndirect?: InputMaybe<Scalars['Boolean']>;
  jurisdiction?: InputMaybe<Scalars['String']>;
};

export type UpdateDealTemplateInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  investorId?: InputMaybe<Scalars['BigInt']>;
  name?: InputMaybe<Scalars['String']>;
  sections?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type UpdateExitManualInvestment = {
  exchangeRate?: InputMaybe<Scalars['Float']>;
  exitDate?: InputMaybe<Scalars['DateTime']>;
  exitType?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  investmentId?: InputMaybe<Scalars['BigInt']>;
  noOfShares?: InputMaybe<Scalars['BigInt']>;
  sharePrice?: InputMaybe<Scalars['Float']>;
};

export type UpdateGrantInput = {
  cancellationReason?: InputMaybe<Scalars['String']>;
  companyCurrency?: InputMaybe<Scalars['String']>;
  companyFMV?: InputMaybe<Scalars['Float']>;
  companyName?: InputMaybe<Scalars['String']>;
  dba?: InputMaybe<Scalars['String']>;
  exercisePriceOrSarValue?: InputMaybe<Scalars['Float']>;
  expiryDate?: InputMaybe<Scalars['DateTime']>;
  expiryNumber?: InputMaybe<Scalars['Int']>;
  expiryUnitType?: InputMaybe<ExpiryUnitType>;
  fmvDate?: InputMaybe<Scalars['DateTime']>;
  grantDate?: InputMaybe<Scalars['DateTime']>;
  grantId: Scalars['BigInt'];
  grantLetter?: InputMaybe<Scalars['String']>;
  grantType?: InputMaybe<GrantType>;
  metadata?: InputMaybe<Scalars['JSON']>;
  notes?: InputMaybe<Scalars['String']>;
  numberExercised?: InputMaybe<Scalars['Float']>;
  numberGranted?: InputMaybe<Scalars['Float']>;
  planDocument?: InputMaybe<Scalars['String']>;
  planName?: InputMaybe<Scalars['String']>;
  salePrice?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<GrantStatus>;
  vestedOptions?: InputMaybe<Scalars['Int']>;
  vestingSchedule?: InputMaybe<UpdateVestingScheduleInput>;
};

export type UpdateGroupInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateInvestmentsInput = {
  cin?: InputMaybe<Scalars['String']>;
  commitmentAmount?: InputMaybe<Scalars['Float']>;
  companyName?: InputMaybe<Scalars['String']>;
  currentExchangeRate?: InputMaybe<Scalars['Float']>;
  currentSharePrice?: InputMaybe<Scalars['Float']>;
  currentValuation?: InputMaybe<Scalars['Float']>;
  dba?: InputMaybe<Scalars['String']>;
  hissaCompanyId?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  incubationDate?: InputMaybe<Scalars['DateTime']>;
  industry?: InputMaybe<Scalars['String']>;
  investorIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  isVerified: Scalars['Boolean'];
};

export type UpdateLlmPromptInput = {
  entityType?: InputMaybe<EntityType>;
  id: Scalars['BigInt'];
  isDefault?: InputMaybe<Scalars['Boolean']>;
  prompt?: InputMaybe<Scalars['String']>;
};

export type UpdateRoleOfInvestorInput = {
  isAccountAdmin?: InputMaybe<Scalars['Boolean']>;
  role?: InputMaybe<RoleName>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type UpdateTermsheetInput = {
  additionalSections?: InputMaybe<Scalars['JSON']>;
  amountInvested: Scalars['BigInt'];
  expiryDate: Scalars['String'];
  investorId: Scalars['BigInt'];
  mandatorySections?: InputMaybe<Scalars['JSON']>;
  roundSize: Scalars['BigInt'];
  sections?: InputMaybe<Scalars['JSON']>;
  templateId?: InputMaybe<Scalars['Int']>;
  termsheetId: Scalars['BigInt'];
  valuation: Scalars['BigInt'];
};

export type UpdateVestingMilestoneInput = {
  achievedDate?: InputMaybe<Scalars['DateTime']>;
  isAchieved?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  milestoneDate?: InputMaybe<Scalars['DateTime']>;
  numberToVest?: InputMaybe<Scalars['Int']>;
  percentageToVest?: InputMaybe<Scalars['Float']>;
  vestingMilestoneId: Scalars['BigInt'];
};

export type UpdateVestingScheduleInput = {
  cliffDurationMonths?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  performanceCriteria?: InputMaybe<Scalars['String']>;
  planName?: InputMaybe<Scalars['String']>;
  scheduleType?: InputMaybe<VestingScheduleType>;
  totalVestingDurationMonths?: InputMaybe<Scalars['Int']>;
  vestedOptions?: InputMaybe<Scalars['Int']>;
  vestingFrequency?: InputMaybe<VestingFrequency>;
  vestingScheduleId?: InputMaybe<Scalars['BigInt']>;
  vestingTemplateName?: InputMaybe<Scalars['String']>;
};

export type UploadFile = {
  cin?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['BigInt']>;
  companyName?: InputMaybe<Scalars['String']>;
  file?: InputMaybe<Scalars['Upload']>;
  fileName?: InputMaybe<Scalars['String']>;
  folder?: InputMaybe<Scalars['String']>;
  hissaCompanyId?: InputMaybe<Scalars['String']>;
  hissaVerified?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['BigInt']>;
  investorId?: InputMaybe<Scalars['BigInt']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UserAccessType = {
  __typename?: 'UserAccessType';
  id?: Maybe<Scalars['BigInt']>;
  isEmailSent?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['BigInt']>;
};

export type UserCurrency = {
  __typename?: 'UserCurrency';
  id?: Maybe<Scalars['BigInt']>;
  userCurrency?: Maybe<Scalars['String']>;
  userEmailId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['BigInt']>;
};

export type UserInvestorCompanyRoleInput = {
  companies?: InputMaybe<Scalars['String']>;
  investorId?: InputMaybe<Scalars['BigInt']>;
  roleId?: InputMaybe<Scalars['BigInt']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type UserProject = {
  __typename?: 'UserProject';
  companyId?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type UserRoles = {
  __typename?: 'UserRoles';
  action?: Maybe<Scalars['String']>;
  actionName?: Maybe<Scalars['String']>;
  attributes?: Maybe<Array<Maybe<Scalars['String']>>>;
  resource?: Maybe<Scalars['String']>;
};

export type ValuationDetailsInput = {
  companyName?: InputMaybe<Scalars['String']>;
  hissaCompanyId?: InputMaybe<Scalars['String']>;
  hissaVerified?: InputMaybe<Scalars['Boolean']>;
};

export type ValuationDetailsObject = {
  __typename?: 'ValuationDetailsObject';
  currency: Scalars['String'];
  fileUrl?: Maybe<Scalars['String']>;
  id: Scalars['BigInt'];
  isDefault?: Maybe<Scalars['Boolean']>;
  methodology?: Maybe<Scalars['String']>;
  sharePrice?: Maybe<Scalars['Float']>;
  sharePriceBookValue?: Maybe<Scalars['Float']>;
  sharePricePerReport: Scalars['Float'];
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  valuationDate: Scalars['String'];
  valuationName: Scalars['String'];
  valuationType?: Maybe<Scalars['String']>;
  valuatorName?: Maybe<Scalars['String']>;
};

export enum VestingFrequency {
  Annually = 'Annually',
  Daily = 'Daily',
  Monthly = 'Monthly',
  Quarterly = 'Quarterly',
  SemiAnnually = 'Semi_Annually',
  Weekly = 'Weekly'
}

export type VestingMilestone = {
  __typename?: 'VestingMilestone';
  achievedDate?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  isAchieved: Scalars['Boolean'];
  metadata?: Maybe<Scalars['JSON']>;
  milestoneDate: Scalars['DateTime'];
  numberToVest?: Maybe<Scalars['Int']>;
  percentageToVest?: Maybe<Scalars['Float']>;
  updatedAt: Scalars['DateTime'];
  vestingMilestoneId: Scalars['BigInt'];
  vestingScheduleId: Scalars['BigInt'];
};

export type VestingSchedule = {
  __typename?: 'VestingSchedule';
  cliffDurationMonths?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  grantId: Scalars['BigInt'];
  metadata?: Maybe<Scalars['JSON']>;
  performanceCriteria?: Maybe<Scalars['String']>;
  planName?: Maybe<Scalars['String']>;
  scheduleType: VestingScheduleType;
  totalVestingDurationMonths?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
  vestedOptions?: Maybe<Scalars['Int']>;
  vestingFrequency?: Maybe<VestingFrequency>;
  vestingMilestones?: Maybe<Array<Maybe<VestingMilestone>>>;
  vestingScheduleId?: Maybe<Scalars['BigInt']>;
  vestingTemplateName?: Maybe<Scalars['String']>;
};

export enum VestingScheduleType {
  Custom = 'Custom',
  Graded = 'Graded',
  Manual = 'Manual',
  Performance = 'Performance',
  TimeBased = 'Time_Based'
}

export enum Watchlist_Event {
  LatestRaise = 'LATEST_RAISE',
  MultipleUsers = 'MULTIPLE_USERS',
  Termsheet = 'TERMSHEET',
  Unicorn = 'UNICORN'
}

export type Watchlist = {
  __typename?: 'Watchlist';
  companies?: Maybe<Array<Maybe<Company>>>;
  highlights?: Maybe<Array<Maybe<WatchlistEvents>>>;
  id?: Maybe<Scalars['BigInt']>;
  name?: Maybe<Scalars['String']>;
};


export type WatchlistCompaniesArgs = {
  input?: InputMaybe<FetchCompanyInput>;
};


export type WatchlistHighlightsArgs = {
  input?: InputMaybe<Scalars['BigInt']>;
};

export enum WatchlistEntityType {
  Company = 'company',
  Investor = 'investor'
}

export type WatchlistEvents = {
  __typename?: 'WatchlistEvents';
  companyName?: Maybe<Scalars['String']>;
  eventType?: Maybe<Watchlist_Event>;
};

export type WatchlistObject = {
  __typename?: 'WatchlistObject';
  companies?: Maybe<Array<Maybe<AllTransactionsType>>>;
  createdAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  name?: Maybe<Scalars['String']>;
  starredCompanies?: Maybe<Array<Maybe<Scalars['String']>>>;
  type?: Maybe<WatchlistEntityType>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type GetInvestmentQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInvestmentQuery = { __typename?: 'Query', investments?: any | null };

export type GetInvestorsQueryVariables = Exact<{
  input?: InputMaybe<InvestorFetchInput>;
}>;


export type GetInvestorsQuery = { __typename?: 'Query', investors?: any | null };

export type GetWatchlistsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWatchlistsQuery = { __typename?: 'Query', watchlists?: Array<{ __typename?: 'Watchlist', id?: any | null, name?: string | null, companies?: Array<{ __typename?: 'Company', id?: any | null, cin?: string | null, name?: string | null, sharePrice?: number | null, latestRaise?: number | null, latestRaiseDate?: string | null, noOfRounds?: number | null, valuation?: number | null, totalFunding?: number | null, logo?: string | null, industry?: string | null, starred?: boolean | null, business?: string | null, hissaCompanyId?: string | null, totalRaised?: number | null, DBA?: string | null, institutional?: any | null, angel?: any | null, totalInvestors?: any | null, keyInvestors?: Array<string | null> | null, totalShares?: any | null, founderHolding?: number | null, esopHolding?: number | null, companyId?: any | null, founded?: string | null, t2CompanyId?: string | null, t3CompanyId?: string | null } | null> | null, highlights?: Array<{ __typename?: 'WatchlistEvents', eventType?: Watchlist_Event | null, companyName?: string | null } | null> | null } | null> | null };

export type GetNewWatchlistsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNewWatchlistsQuery = { __typename?: 'Query', newWatchlists?: Array<{ __typename?: 'WatchlistObject', id?: any | null, name?: string | null, starredCompanies?: Array<string | null> | null, createdAt?: string | null, updatedAt?: string | null, type?: WatchlistEntityType | null } | null> | null };

export type GetWatchlistsWithCompaniesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWatchlistsWithCompaniesQuery = { __typename?: 'Query', newWatchlists?: Array<{ __typename?: 'WatchlistObject', id?: any | null, name?: string | null, starredCompanies?: Array<string | null> | null, createdAt?: string | null, updatedAt?: string | null, type?: WatchlistEntityType | null, companies?: Array<{ __typename?: 'AllTransactionsType', companyData: { __typename?: 'CompanyObject', cashBalance?: number | null, cin?: string | null, companyCurrency: string, dba?: string | null, esopHolding?: number | null, founderHoldingPercentage?: number | null, isPrivate?: boolean | null, companyStage?: string | null, hissaCompanyId?: string | null, id?: any | null, incorporationDate?: string | null, industry?: string | null, jurisdiction?: string | null, latestRaise?: number | null, latestRaiseDate?: string | null, latestRound?: string | null, valuationInCompanyCurrency?: number | null, logo?: string | null, name: string, noOfRounds?: number | null, revenue?: number | null, sharePrice?: number | null, totalFdbShares?: number | null, totalFunding?: number | null, type: CompanyTypes, valuation?: number | null, businessDescription?: string | null, corporateOfficeAddress?: string | null, equityPaidUpCapital?: number | null, preferencePaidUpCapital?: number | null, equityAuthorizedCapital?: number | null, preferenceAuthorizedCapital?: number | null, directorDetails?: any | null }, roundData?: Array<{ __typename?: 'RoundObject', id?: string | null, name: string, postMoneyValuation?: number | null, roundSize: number, roundDate: string } | null> | null } | null> | null } | null> | null };

export type GetWatchlistByIdQueryVariables = Exact<{
  input: FetchWatchlistInput;
}>;


export type GetWatchlistByIdQuery = { __typename?: 'Query', newWatchlists?: Array<{ __typename?: 'WatchlistObject', id?: any | null, name?: string | null, starredCompanies?: Array<string | null> | null, createdAt?: string | null, updatedAt?: string | null, type?: WatchlistEntityType | null, companies?: Array<{ __typename?: 'AllTransactionsType', companyData: { __typename?: 'CompanyObject', cashBalance?: number | null, cin?: string | null, companyCurrency: string, dba?: string | null, esopHolding?: number | null, founderHoldingPercentage?: number | null, isPrivate?: boolean | null, companyStage?: string | null, hissaCompanyId?: string | null, id?: any | null, incorporationDate?: string | null, industry?: string | null, jurisdiction?: string | null, latestRaise?: number | null, latestRaiseDate?: string | null, latestRound?: string | null, valuationInCompanyCurrency?: number | null, logo?: string | null, name: string, noOfRounds?: number | null, revenue?: number | null, sharePrice?: number | null, totalFdbShares?: number | null, totalFunding?: number | null, type: CompanyTypes, valuation?: number | null, businessDescription?: string | null, corporateOfficeAddress?: string | null, equityPaidUpCapital?: number | null, preferencePaidUpCapital?: number | null, equityAuthorizedCapital?: number | null, preferenceAuthorizedCapital?: number | null, directorDetails?: any | null }, roundData?: Array<{ __typename?: 'RoundObject', id?: string | null, name: string, postMoneyValuation?: number | null, roundSize: number, roundDate: string } | null> | null, aggregateData?: { __typename?: 'AggregateDataObject', moic?: number | null, irr?: number | null, realizedValue?: number | null, noOfInvestments?: number | null, totalInvestment?: number | null, currentValue?: number | null, noOfHoldingCompanies?: number | null, totalNoOfCompanies?: number | null, currentHoldingPercentage?: number | null } | null } | null> | null } | null> | null };

export type AddWatchlistMutationVariables = Exact<{
  input: AddWatchlistInput;
}>;


export type AddWatchlistMutation = { __typename?: 'Mutation', addWatchlist?: any | null };

export type RemoveWatchlistMutationVariables = Exact<{
  input?: InputMaybe<Scalars['BigInt']>;
}>;


export type RemoveWatchlistMutation = { __typename?: 'Mutation', removeWatchlist?: any | null };

export type GetInvestmentByStageQueryVariables = Exact<{
  input?: InputMaybe<InvestorOrCompanyInput>;
}>;


export type GetInvestmentByStageQuery = { __typename?: 'Query', investmentByStage?: Array<{ __typename?: 'InvestmentByStage', stage?: string | null, count?: number | null } | null> | null };

export type RemoveCompanyMutationVariables = Exact<{
  input?: InputMaybe<RemoveCompanyFromListInput>;
}>;


export type RemoveCompanyMutation = { __typename?: 'Mutation', removeCompanyFromList?: any | null };

export type AddCompanyMutationVariables = Exact<{
  input: AddCompanyToListInput;
}>;


export type AddCompanyMutation = { __typename?: 'Mutation', addCompanyToList?: any | null };

export type SearchQueryVariables = Exact<{
  input?: InputMaybe<SearchCompanyInput>;
}>;


export type SearchQuery = { __typename?: 'Query', searchCompany?: any | null };

export type GetCompanyDetailsQueryVariables = Exact<{
  input: FetchCompanyInput;
}>;


export type GetCompanyDetailsQuery = { __typename?: 'Query', companies: Array<{ __typename?: 'Company', id?: any | null, name?: string | null, cin?: string | null, shareholders?: Array<any | null> | null, totalFunding?: number | null, totalShares?: any | null, sharePrice?: number | null, valuation?: number | null, latestRaise?: number | null, noOfRounds?: number | null, industry?: string | null, logo?: string | null, business?: string | null, starred?: boolean | null, currentValuation?: number | null, jurisdiction?: string | null, currentSharePrice?: number | null, companyId?: any | null, hissaCompanyId?: string | null, currentExchangeRate?: number | null, DBA?: string | null, incubationDate?: string | null, commitmentAmount?: number | null, t2CompanyId?: string | null, t3CompanyId?: string | null } | null> };

export type GetTermsheetsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTermsheetsQuery = { __typename?: 'Query', termsheets?: Array<any | null> | null };

export type GetShareholdingDetailsByCompanyQueryVariables = Exact<{
  input: FetchCompanyInput;
}>;


export type GetShareholdingDetailsByCompanyQuery = { __typename?: 'Query', companies: Array<{ __typename?: 'Company', id?: any | null, name?: string | null, cin?: string | null, shareholdingDetails?: Array<any | null> | null, exitData?: Array<{ __typename?: 'Transaction', investorName?: string | null, companyName?: string | null, transactionType?: Transaction_Type | null, noOfShares?: any | null, transactionDate?: string | null, roundName?: string | null, pricePerShare?: number | null, roundIdentifier?: string | null, cin?: string | null, amount?: number | null } | null> | null } | null> };

export type GetExitDataInvestorWiseQueryVariables = Exact<{
  input?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>> | InputMaybe<Scalars['BigInt']>>;
}>;


export type GetExitDataInvestorWiseQuery = { __typename?: 'Query', exitDataInvestorWise?: Array<{ __typename?: 'Transaction', investorName?: string | null, companyName?: string | null, transactionType?: Transaction_Type | null, noOfShares?: any | null, transactionDate?: string | null, roundName?: string | null, pricePerShare?: number | null, roundIdentifier?: string | null, cin?: string | null, amount?: number | null, investorId?: string | null, companyId?: string | null } | null> | null };

export type AddInvestmentInputMutationVariables = Exact<{
  input?: InputMaybe<AddInvestmentInput>;
}>;


export type AddInvestmentInputMutation = { __typename?: 'Mutation', addInvestment?: any | null };

export type GetAllInvestmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllInvestmentsQuery = { __typename?: 'Query', allInvestments?: Array<any | null> | null };

export type RemoveInvestmentMutationVariables = Exact<{
  input?: InputMaybe<RemoveInvestmentInput>;
}>;


export type RemoveInvestmentMutation = { __typename?: 'Mutation', removeInvestment?: any | null };

export type GetPortfolioMetricsQueryVariables = Exact<{
  input?: InputMaybe<InvestorOrCompanyInput>;
}>;


export type GetPortfolioMetricsQuery = { __typename?: 'Query', portfolioMetrics?: Array<{ __typename?: 'RoundsCount', investorName?: string | null, count?: any | null, amount?: number | null, investorId?: any | null } | null> | null };

export type GetStarCompaniesQueryVariables = Exact<{
  input?: InputMaybe<QueryStarCompaniesArgsInput>;
}>;


export type GetStarCompaniesQuery = { __typename?: 'Query', starCompanies?: any | null };

export type GetUrlForS3ObjectQueryVariables = Exact<{
  input?: InputMaybe<S3ObjectUrl>;
}>;


export type GetUrlForS3ObjectQuery = { __typename?: 'Query', urlForS3Object?: string | null };

export type GetManualInvestmentQueryVariables = Exact<{
  input: FetchInvestmentInput;
}>;


export type GetManualInvestmentQuery = { __typename?: 'Query', investments?: any | null };

export type EditInvestmentInputMutationVariables = Exact<{
  input?: InputMaybe<EditInvestmentInput>;
}>;


export type EditInvestmentInputMutation = { __typename?: 'Mutation', editInvestment?: any | null };

export type UpdateInvestmentsMutationVariables = Exact<{
  input?: InputMaybe<UpdateInvestmentsInput>;
}>;


export type UpdateInvestmentsMutation = { __typename?: 'Mutation', updateInvestments?: any | null };

export type GetCompanyDataQueryVariables = Exact<{
  input?: InputMaybe<FilesDataInput>;
}>;


export type GetCompanyDataQuery = { __typename?: 'Query', data?: any | null };

export type UploadFileToCompanyMutationVariables = Exact<{
  input?: InputMaybe<UploadFile>;
}>;


export type UploadFileToCompanyMutation = { __typename?: 'Mutation', fileUpload?: any | null };

export type GetPortfolioEventsQueryVariables = Exact<{
  input?: InputMaybe<InvestorOrCompanyInput>;
}>;


export type GetPortfolioEventsQuery = { __typename?: 'Query', portfolioEvents?: Array<{ __typename?: 'PortfolioEvents', investorId?: any | null, companyName?: string | null, eventType?: string | null, eventDate?: any | null } | null> | null };

export type EditWatchlistNameMutationVariables = Exact<{
  input: EditWatchlistInput;
}>;


export type EditWatchlistNameMutation = { __typename?: 'Mutation', editWatchlist?: any | null };

export type UploadBulkInvestmentsMutationVariables = Exact<{
  up?: InputMaybe<Scalars['Upload']>;
}>;


export type UploadBulkInvestmentsMutation = { __typename?: 'Mutation', addInvestmentBulkUpload?: any | null };

export type RemoveObjectMutationVariables = Exact<{
  input?: InputMaybe<UploadFile>;
}>;


export type RemoveObjectMutation = { __typename?: 'Mutation', removeObject?: any | null };

export type GetWatchlistHighlightsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWatchlistHighlightsQuery = { __typename?: 'Query', watchlists?: Array<{ __typename?: 'Watchlist', id?: any | null, name?: string | null, highlights?: Array<{ __typename?: 'WatchlistEvents', eventType?: Watchlist_Event | null, companyName?: string | null } | null> | null } | null> | null };

export type GetDealTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDealTemplatesQuery = { __typename?: 'Query', dealTemplates?: Array<{ __typename?: 'DealTemplate', id?: any | null, investorId?: any | null, name?: string | null, sections?: Array<string | null> | null, fileURL?: string | null, companiesIssuedTo?: Array<string | null> | null, creationDate?: string | null, lastIssuedDate?: string | null, jsonData?: any | null, documentType?: string | null, accountId?: any | null, thumbnailURL?: string | null } | null> | null };

export type AddDealTemplateMutationVariables = Exact<{
  input?: InputMaybe<AddDealTemplateInput>;
}>;


export type AddDealTemplateMutation = { __typename?: 'Mutation', addDealTemplate?: any | null };

export type AddTagsToDocumentMutationVariables = Exact<{
  input?: InputMaybe<AddTagsToDocumentInput>;
}>;


export type AddTagsToDocumentMutation = { __typename?: 'Mutation', addTagsToDocument?: any | null };

export type EditDealTemplateMutationVariables = Exact<{
  input?: InputMaybe<UpdateDealTemplateInput>;
}>;


export type EditDealTemplateMutation = { __typename?: 'Mutation', updateDealTemplate?: any | null };

export type DeleteDealTemplateMutationVariables = Exact<{
  input?: InputMaybe<RemoveDealTemplateInput>;
}>;


export type DeleteDealTemplateMutation = { __typename?: 'Mutation', removeDealTemplate?: any | null };

export type SendNewTermsheetMutationVariables = Exact<{
  input?: InputMaybe<TermsheetInput>;
  sendImmediately?: InputMaybe<Scalars['Boolean']>;
}>;


export type SendNewTermsheetMutation = { __typename?: 'Mutation', addTermsheet?: any | null };

export type GetTasksOverviewQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTasksOverviewQuery = { __typename?: 'Query', tasksOverview?: Array<{ __typename?: 'TaskOverviewEvent', date?: string | null, eventType?: Task_Event | null, eventStatus?: Task_Event_Status | null, companyName?: string | null, companyId?: string | null } | null> | null };

export type GetCurrencyExchangeRateMutationVariables = Exact<{
  input?: InputMaybe<CurrencyExchangeInput>;
}>;


export type GetCurrencyExchangeRateMutation = { __typename?: 'Mutation', getCurrencyExchangeRate?: { __typename?: 'CurrencyExchangeRate', currencyName?: string | null, currencyCode?: string | null, currencyRate?: number | null, updatedAt?: string | null } | null };

export type UploadLinksMutationVariables = Exact<{
  input?: InputMaybe<AddLinkInput>;
}>;


export type UploadLinksMutation = { __typename?: 'Mutation', addDocumentLink?: any | null };

export type DeleteLinksMutationVariables = Exact<{
  input?: InputMaybe<RemoveLinkInput>;
}>;


export type DeleteLinksMutation = { __typename?: 'Mutation', removeDocumentLink?: any | null };

export type AddBeneficiaryMutationVariables = Exact<{
  input?: InputMaybe<AddBeneficiaryInput>;
}>;


export type AddBeneficiaryMutation = { __typename?: 'Mutation', addBeneficiary?: any | null };

export type GetAllClassificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllClassificationsQuery = { __typename?: 'Query', classifications?: any | null };

export type GetClassificationQueryVariables = Exact<{
  input?: InputMaybe<GetGroupInput>;
}>;


export type GetClassificationQuery = { __typename?: 'Query', classification?: any | null };

export type AddClassificationMutationVariables = Exact<{
  input?: InputMaybe<AddGroupInput>;
}>;


export type AddClassificationMutation = { __typename?: 'Mutation', addClassification?: any | null };

export type EditClassificationMutationVariables = Exact<{
  input?: InputMaybe<UpdateGroupInput>;
}>;


export type EditClassificationMutation = { __typename?: 'Mutation', editClassification?: any | null };

export type RemoveClassificationMutationVariables = Exact<{
  input?: InputMaybe<RemoveGroupInput>;
}>;


export type RemoveClassificationMutation = { __typename?: 'Mutation', removeClassification?: any | null };

export type AddCompaniesToClassificationMutationVariables = Exact<{
  input?: InputMaybe<AddCompaniesToGroupInput>;
}>;


export type AddCompaniesToClassificationMutation = { __typename?: 'Mutation', addCompaniesToClassification?: any | null };

export type RemoveCompaniesFromClassificationMutationVariables = Exact<{
  input?: InputMaybe<AddCompaniesToGroupInput>;
}>;


export type RemoveCompaniesFromClassificationMutation = { __typename?: 'Mutation', removeCompaniesFromClassification?: any | null };

export type ManualShareholdingDetailsQueryVariables = Exact<{
  input?: InputMaybe<FetchCompanyInput>;
}>;


export type ManualShareholdingDetailsQuery = { __typename?: 'Query', companies: Array<{ __typename?: 'Company', shareholdingDetails?: Array<any | null> | null } | null> };

export type BeneficiariesQueryVariables = Exact<{ [key: string]: never; }>;


export type BeneficiariesQuery = { __typename?: 'Query', beneficiaries?: Array<string | null> | null };

export type AddExitManualInvestmentMutationVariables = Exact<{
  input?: InputMaybe<AddExitManualInvestment>;
}>;


export type AddExitManualInvestmentMutation = { __typename?: 'Mutation', addExitManualInvestment?: any | null };

export type UpdateExitManualInvestmentMutationVariables = Exact<{
  input?: InputMaybe<UpdateExitManualInvestment>;
}>;


export type UpdateExitManualInvestmentMutation = { __typename?: 'Mutation', updateExitManualInvestment?: any | null };

export type DeleteExitManualInvestmentMutationVariables = Exact<{
  input?: InputMaybe<RemoveExitManualInvestment>;
}>;


export type DeleteExitManualInvestmentMutation = { __typename?: 'Mutation', removeExitManualInvestment?: any | null };

export type RemoveBeneficiaryMutationVariables = Exact<{
  input?: InputMaybe<RemoveInvestmentInput>;
}>;


export type RemoveBeneficiaryMutation = { __typename?: 'Mutation', removeInvestment?: any | null };

export type EmailTermsheetMutationVariables = Exact<{
  input?: InputMaybe<EmailTermsheetInput>;
}>;


export type EmailTermsheetMutation = { __typename?: 'Mutation', emailTermsheet?: any | null };

export type AllInvestorsQueryVariables = Exact<{
  input?: InputMaybe<GetAllInvestorsInput>;
}>;


export type AllInvestorsQuery = { __typename?: 'Query', getAllInvestors?: any | null };

export type AddUserToInvestorMutationVariables = Exact<{
  input?: InputMaybe<AddAnotherUserToAccountInput>;
}>;


export type AddUserToInvestorMutation = { __typename?: 'Mutation', addAnotherUserToAccount?: any | null };

export type AddAccountToUserMutationVariables = Exact<{
  input?: InputMaybe<AddAccountInput>;
}>;


export type AddAccountToUserMutation = { __typename?: 'Mutation', addAccountToUser?: any | null };

export type AllAccountOfUserQueryVariables = Exact<{ [key: string]: never; }>;


export type AllAccountOfUserQuery = { __typename?: 'Query', getAllAccountOfUser?: any | null };

export type AddInvestorMutationVariables = Exact<{
  input: AddInvestorInput;
}>;


export type AddInvestorMutation = { __typename?: 'Mutation', addInvestor?: any | null };

export type AddIndirectInvestmentMutationVariables = Exact<{
  input?: InputMaybe<AddIndirectInvestmentInput>;
}>;


export type AddIndirectInvestmentMutation = { __typename?: 'Mutation', addIndirectInvestment?: any | null };

export type GetIndirectCompaniesQueryVariables = Exact<{
  input?: InputMaybe<FetchCompanyInput>;
}>;


export type GetIndirectCompaniesQuery = { __typename?: 'Query', indirectCompanies?: any | null };

export type DeleteIndirectInvestmentMutationVariables = Exact<{
  input?: InputMaybe<RemoveIndirectInvestmentInput>;
}>;


export type DeleteIndirectInvestmentMutation = { __typename?: 'Mutation', deleteIndirectInvestment?: any | null };

export type EditIndirectInvestmentMutationVariables = Exact<{
  input?: InputMaybe<EditIndirectInvestmentInput>;
}>;


export type EditIndirectInvestmentMutation = { __typename?: 'Mutation', editIndirectInvestment?: any | null };

export type EditIndirectCompanyDetailsMutationVariables = Exact<{
  input?: InputMaybe<EditIndirectCompanyDetailsInput>;
}>;


export type EditIndirectCompanyDetailsMutation = { __typename?: 'Mutation', editIndirectCompanyDetails?: any | null };

export type GetAllInvestorComapniesQueryVariables = Exact<{
  input?: InputMaybe<FetchAllCompaniesInput>;
}>;


export type GetAllInvestorComapniesQuery = { __typename?: 'Query', allInvestorCompanies?: any | null };

export type EditFmvMutationVariables = Exact<{
  input?: InputMaybe<EditFmvInput>;
}>;


export type EditFmvMutation = { __typename?: 'Mutation', editFMV?: any | null };

export type GetEeMetricsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEeMetricsQuery = { __typename?: 'Query', eeMetrics?: any | null };

export type AddEeMetricMutationVariables = Exact<{
  input?: InputMaybe<AddEeMetricInput>;
}>;


export type AddEeMetricMutation = { __typename?: 'Mutation', addEEMetric?: any | null };

export type EditEeMetricMutationVariables = Exact<{
  input?: InputMaybe<EditEeMetricInput>;
}>;


export type EditEeMetricMutation = { __typename?: 'Mutation', editEEMetric?: any | null };

export type RemoveEeMetricMutationVariables = Exact<{
  input?: InputMaybe<RemoveEeMetricInput>;
}>;


export type RemoveEeMetricMutation = { __typename?: 'Mutation', removeEEMetric?: any | null };

export type GetEeCompanyMetricsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEeCompanyMetricsQuery = { __typename?: 'Query', eeCompanyMetrics?: any | null };

export type AddEeCompanyMetricMutationVariables = Exact<{
  input?: InputMaybe<AddEeCompanyMetricInput>;
}>;


export type AddEeCompanyMetricMutation = { __typename?: 'Mutation', addEECompanyMetric?: any | null };

export type EditEeCompanyMetricMutationVariables = Exact<{
  input?: InputMaybe<EditEeCompanyMetricInput>;
}>;


export type EditEeCompanyMetricMutation = { __typename?: 'Mutation', editEECompanyMetric?: any | null };

export type RemoveEeCompanyMetricMutationVariables = Exact<{
  input?: InputMaybe<RemoveEeCompanyMetricInput>;
}>;


export type RemoveEeCompanyMetricMutation = { __typename?: 'Mutation', removeEECompanyMetric?: any | null };

export type GetEeFiltersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEeFiltersQuery = { __typename?: 'Query', eeFilters?: any | null };

export type AddEeFilterMutationVariables = Exact<{
  input?: InputMaybe<AddEeFilterInput>;
}>;


export type AddEeFilterMutation = { __typename?: 'Mutation', addEEFilter?: any | null };

export type EditEeFilterMutationVariables = Exact<{
  input?: InputMaybe<EditEeFilterInput>;
}>;


export type EditEeFilterMutation = { __typename?: 'Mutation', editEEFilter?: any | null };

export type RemoveEeFilterMutationVariables = Exact<{
  input?: InputMaybe<RemoveEeFilterInput>;
}>;


export type RemoveEeFilterMutation = { __typename?: 'Mutation', removeEEFilter?: any | null };

export type GetEeThemesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEeThemesQuery = { __typename?: 'Query', eeThemes?: any | null };

export type AddEeThemeMutationVariables = Exact<{
  input?: InputMaybe<AddEeThemeInput>;
}>;


export type AddEeThemeMutation = { __typename?: 'Mutation', addEETheme?: any | null };

export type EditEeThemeMutationVariables = Exact<{
  input?: InputMaybe<EditEeThemeInput>;
}>;


export type EditEeThemeMutation = { __typename?: 'Mutation', editEETheme?: any | null };

export type RemoveEeThemeMutationVariables = Exact<{
  input?: InputMaybe<RemoveEeThemeInput>;
}>;


export type RemoveEeThemeMutation = { __typename?: 'Mutation', removeEETheme?: any | null };

export type RemoveEeThemeFilterMutationVariables = Exact<{
  input?: InputMaybe<RemoveEeThemeFilterInput>;
}>;


export type RemoveEeThemeFilterMutation = { __typename?: 'Mutation', removeEEThemeFilter?: any | null };

export type GetEeInvestsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEeInvestsQuery = { __typename?: 'Query', eeInvests?: any | null };

export type GetEePortfoliosQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEePortfoliosQuery = { __typename?: 'Query', eePortfolios?: any | null };

export type AddEePortfolioMutationVariables = Exact<{
  input?: InputMaybe<AddEePortfolioInput>;
}>;


export type AddEePortfolioMutation = { __typename?: 'Mutation', addEEPortfolio?: any | null };

export type EditEePortfolioMutationVariables = Exact<{
  input?: InputMaybe<EditEePortfolioInput>;
}>;


export type EditEePortfolioMutation = { __typename?: 'Mutation', editEEPortfolio?: any | null };

export type RemoveEePortfolioMutationVariables = Exact<{
  input?: InputMaybe<RemoveEePortfolioInput>;
}>;


export type RemoveEePortfolioMutation = { __typename?: 'Mutation', removeEEPortfolio?: any | null };

export type AddTagsToInvestmentMutationVariables = Exact<{
  input?: InputMaybe<AddTagsToInvestmentInput>;
}>;


export type AddTagsToInvestmentMutation = { __typename?: 'Mutation', addTagsToInvestment?: Array<string | null> | null };

export type EditTransactionMutationVariables = Exact<{
  input?: InputMaybe<EditTransactionInput>;
}>;


export type EditTransactionMutation = { __typename?: 'Mutation', editTransaction?: Array<string | null> | null };

export type AddValuationDetailsMutationVariables = Exact<{
  input?: InputMaybe<AddValuationDetailsInput>;
}>;


export type AddValuationDetailsMutation = { __typename?: 'Mutation', addValuationDetails?: any | null };

export type GetAllValuationOfCompanyQueryVariables = Exact<{
  input?: InputMaybe<ValuationDetailsInput>;
}>;


export type GetAllValuationOfCompanyQuery = { __typename?: 'Query', getAllValuationOfCompany?: any | null };

export type EditValuationDetailsMutationVariables = Exact<{
  input?: InputMaybe<EditValuationDetailsInput>;
}>;


export type EditValuationDetailsMutation = { __typename?: 'Mutation', editValuationDetails?: any | null };

export type DeleteValuationDetailsMutationVariables = Exact<{
  input?: InputMaybe<DeleteValuationDetailsInput>;
}>;


export type DeleteValuationDetailsMutation = { __typename?: 'Mutation', deleteValuationDetails?: string | null };

export type UploadType2CaptableMutationVariables = Exact<{
  up?: InputMaybe<Scalars['Upload']>;
}>;


export type UploadType2CaptableMutation = { __typename?: 'Mutation', uploadCompanyOverview?: any | null };

export type UploadType3CaptableMutationVariables = Exact<{
  up?: InputMaybe<Scalars['Upload']>;
}>;


export type UploadType3CaptableMutation = { __typename?: 'Mutation', uploadCompanyCaptable?: any | null };

export type SetDefaultValuationMutationVariables = Exact<{
  input?: InputMaybe<SetDefaultValuationInput>;
}>;


export type SetDefaultValuationMutation = { __typename?: 'Mutation', setDefaultValuation?: string | null };

export type GetTemplateDocumentQueryVariables = Exact<{
  input?: InputMaybe<TemplateInput>;
}>;


export type GetTemplateDocumentQuery = { __typename?: 'Query', getTermsheetTemplate?: any | null };

export type EditTemplateDocumentMutationVariables = Exact<{
  input?: InputMaybe<EditTermsheetTemplate>;
}>;


export type EditTemplateDocumentMutation = { __typename?: 'Mutation', editTermsheetTemplate?: any | null };

export type GetS3UrlForTermsheetQueryVariables = Exact<{
  input?: InputMaybe<FetchUrlPathInput>;
}>;


export type GetS3UrlForTermsheetQuery = { __typename?: 'Query', getTermsheetUrlPath?: { __typename?: 'TermsheetUrlPath', urlPath?: string | null, presignedUrl?: string | null, presignedDocUrl?: string | null, docUrlPath?: string | null } | null };

export type InsertSignatureMutationVariables = Exact<{
  input?: InputMaybe<AddSignatureInput>;
}>;


export type InsertSignatureMutation = { __typename?: 'Mutation', addSignature?: string | null };

export type DocxToPdfMutationVariables = Exact<{
  input?: InputMaybe<DocxToPdfInput>;
}>;


export type DocxToPdfMutation = { __typename?: 'Mutation', docxToPdfConverter?: string | null };

export type AddMultipleInvestorsToUserMutationVariables = Exact<{
  input?: InputMaybe<AddUserToMultipleInvestorsInput>;
}>;


export type AddMultipleInvestorsToUserMutation = { __typename?: 'Mutation', addUserToMultipleInvestors?: Array<string | null> | null };

export type GetAllTransactionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllTransactionsQuery = { __typename?: 'Query', allTransactions?: Array<{ __typename?: 'AllTransactionsType', companyData: { __typename?: 'CompanyObject', type: CompanyTypes, id?: any | null, hissaCompanyId?: string | null, name: string, cin?: string | null, companyCurrency: string, totalFunding?: number | null, sharePrice?: number | null, valuation?: number | null, totalFdbShares?: number | null, latestRaise?: number | null, latestRaiseDate?: string | null, noOfRounds?: number | null, industry?: string | null, logo?: string | null, dba?: string | null, isPrivate?: boolean | null, companyStage?: string | null, founderHoldingPercentage?: number | null, latestRound?: string | null, incorporationDate?: string | null, jurisdiction?: string | null, revenue?: number | null, cashBalance?: number | null, valuationInCompanyCurrency?: number | null, esopHolding?: number | null, tags?: Array<string | null> | null, businessDescription?: string | null, corporateOfficeAddress?: string | null, equityPaidUpCapital?: number | null, preferencePaidUpCapital?: number | null, equityAuthorizedCapital?: number | null, preferenceAuthorizedCapital?: number | null, directorDetails?: any | null, companyMetadata?: Array<{ __typename?: 'CompanyMetadataType', key?: string | null, value?: string | null } | null> | null }, transactionData?: Array<{ __typename?: 'TransactionObject', hissTransactionId?: string | null, id?: any | null, companyType: CompanyTypes, investorName?: string | null, investorId: any, transactionType: Transaction_Type, round?: string | null, noOfShares: number, sharePrice?: number | null, roundIdentifier?: string | null, amount: number, transactionDate: string, currency: string, exchangeRate?: number | null, companySharePrice?: number | null, transactionFdbShares?: number | null, securitySubType?: string | null, notes?: string | null, metadata?: any | null, investorsData?: { __typename?: 'InvestorObject', name: string, exited?: boolean | null, fdbShares?: number | null, fdbHoldingPercentage?: number | null, currentValue?: number | null } | null } | null> | null, investorData?: Array<{ __typename?: 'InvestorObject', id: any, name: string, exited?: boolean | null, fdbShares?: number | null, fdbHoldingPercentage?: number | null, currentValue?: number | null } | null> | null, indirectTransactionData?: Array<{ __typename?: 'IndirectTransactionObject', id?: any | null, investorId?: any | null, investorName?: string | null, hissTransactionId?: string | null, unitType?: string | null, transactionDate: string, noOfUnits: number, currentNav?: number | null, transactionAmount: number, drawDown?: number | null, setupFee?: number | null, indirectVehicleID?: any | null, indirectVehicleName?: string | null, currentNavDate: string, transactionNav: number, currentValue: number, notes?: string | null, metadata?: any | null, transactionCurrency: string, exchangeRate?: number | null, documents?: Array<{ __typename?: 'DocumentsType', id?: any | null, name: string, key: string, tags?: Array<string | null> | null, size?: number | null, isTransaction?: boolean | null, investmentId?: any | null, indirectInvestmentId?: any | null } | null> | null } | null> | null, roundData?: Array<{ __typename?: 'RoundObject', id?: string | null, name: string, postMoneyValuation?: number | null, roundSize: number, roundDate: string } | null> | null } | null> | null };

export type GetCompanyWiseDataQueryVariables = Exact<{
  input?: InputMaybe<CompanyDataInput>;
}>;


export type GetCompanyWiseDataQuery = { __typename?: 'Query', getCompanyData?: { __typename?: 'AllTransactionsType', companyData: { __typename?: 'CompanyObject', type: CompanyTypes, id?: any | null, hissaCompanyId?: string | null, name: string, cin?: string | null, companyCurrency: string, totalFunding?: number | null, sharePrice?: number | null, valuation?: number | null, totalFdbShares?: number | null, valuationInCompanyCurrency?: number | null, latestRaise?: number | null, latestRaiseDate?: string | null, noOfRounds?: number | null, industry?: string | null, logo?: string | null, dba?: string | null, isPrivate?: boolean | null, companyStage?: string | null, founderHoldingPercentage?: number | null, latestRound?: string | null, incorporationDate?: string | null, jurisdiction?: string | null, revenue?: number | null, cashBalance?: number | null, esopHolding?: number | null, tags?: Array<string | null> | null, businessDescription?: string | null, corporateOfficeAddress?: string | null, directorDetails?: any | null, equityPaidUpCapital?: number | null, preferencePaidUpCapital?: number | null, equityAuthorizedCapital?: number | null, preferenceAuthorizedCapital?: number | null, companyMetadata?: Array<{ __typename?: 'CompanyMetadataType', key?: string | null, value?: string | null } | null> | null, liquidationPreference?: Array<{ __typename?: 'LiquidationOverViewDetails', securityClassId?: string | null, securityType?: string | null, securityClassName?: string | null, rank?: number | null, investmentMultiple?: number | null, investment?: number | null, lpValue?: number | null, isParriPassu?: boolean | null, isParticipation?: boolean | null, participationCap?: number | null } | null> | null, taskManagerProjects?: Array<{ __typename?: 'UserProject', id?: string | null, name?: string | null, description?: string | null, startDate?: string | null, endDate?: string | null, companyId?: string | null, companyName?: string | null } | null> | null, shareholders?: Array<{ __typename?: 'Shareholder', name: string, investedAmount?: number | null, percentage?: number | null, noOfShares?: number | null, type?: string | null, companyInvestorId?: string | null, shareCertificates?: Array<{ __typename?: 'ShareCertificates', certificateId?: string | null, certificateUrl?: string | null, certificateName?: string | null, securityType?: string | null, securityClass?: string | null, round?: string | null, numberOfShares?: number | null, demat?: boolean | null, pricePerShare?: number | null, amountInvested?: number | null, currentValue?: number | null, securityClassId?: string | null, roundDetails?: any | null, fdbShares?: any | null, remarks?: string | null, ranges?: any | null } | null> | null } | null> | null, securities?: Array<{ __typename?: 'SecurityType', securityType?: string | null, noOfShares?: number | null, noOfClassess?: number | null, holding?: number | null, parValue?: number | null, capitalValue?: number | null } | null> | null, financialData?: { __typename?: 'FinancialType', data?: Array<{ __typename?: 'FinancialData', cin?: string | null, companyId?: string | null, companyIsPrivate?: boolean | null, data?: any | null, id?: string | null, isPrivate?: boolean | null, misData?: any | null, name?: string | null, publicCompanyName?: string | null, s3Url?: string | null, timeline?: string | null, timelineType?: string | null, updatedDate?: string | null, year?: string | null } | null> | null } | null }, transactionData?: Array<{ __typename?: 'TransactionObject', hissTransactionId?: string | null, id?: any | null, companyType: CompanyTypes, investorName?: string | null, investorId: any, transactionType: Transaction_Type, round?: string | null, noOfShares: number, sharePrice?: number | null, roundIdentifier?: string | null, amount: number, transactionDate: string, currency: string, exchangeRate?: number | null, companySharePrice?: number | null, transactionFdbShares?: number | null, transactionValuation?: number | null, securitySubType?: string | null, tags?: Array<string | null> | null, notes?: string | null, metadata?: any | null, shareDistinctiveRange?: any | null, investorsData?: { __typename?: 'InvestorObject', name: string, exited?: boolean | null, fdbShares?: number | null, fdbHoldingPercentage?: number | null, currentValue?: number | null } | null, documents?: Array<{ __typename?: 'DocumentsType', id?: any | null, name: string, key: string, tags?: Array<string | null> | null, size?: number | null, isTransaction?: boolean | null, investmentId?: any | null, indirectInvestmentId?: any | null } | null> | null } | null> | null, investorData?: Array<{ __typename?: 'InvestorObject', id: any, name: string, exited?: boolean | null, fdbShares?: number | null, fdbHoldingPercentage?: number | null, currentValue?: number | null } | null> | null, indirectTransactionData?: Array<{ __typename?: 'IndirectTransactionObject', id?: any | null, investorId?: any | null, investorName?: string | null, hissTransactionId?: string | null, unitType?: string | null, transactionDate: string, noOfUnits: number, currentNav?: number | null, transactionAmount: number, drawDown?: number | null, setupFee?: number | null, indirectVehicleID?: any | null, indirectVehicleName?: string | null, currentNavDate: string, transactionNav: number, currentValue: number, transactionCurrency: string, exchangeRate?: number | null, tags?: Array<string | null> | null, notes?: string | null, metadata?: any | null, documents?: Array<{ __typename?: 'DocumentsType', id?: any | null, name: string, key: string, tags?: Array<string | null> | null, size?: number | null, isTransaction?: boolean | null, investmentId?: any | null, indirectInvestmentId?: any | null } | null> | null } | null> | null, valuationDetailsData?: Array<{ __typename?: 'ValuationDetailsObject', id: any, valuationName: string, valuationDate: string, valuationType?: string | null, sharePricePerReport: number, sharePriceBookValue?: number | null, valuatorName?: string | null, methodology?: string | null, tags?: Array<string | null> | null, sharePrice?: number | null, currency: string, isDefault?: boolean | null, fileUrl?: string | null } | null> | null, roundData?: Array<{ __typename?: 'RoundObject', id?: string | null, name: string, postMoneyValuation?: number | null, roundSize: number, roundDate: string } | null> | null } | null };

export type AddUserCurrencyMutationVariables = Exact<{
  input?: InputMaybe<AddUserCurrencyInput>;
}>;


export type AddUserCurrencyMutation = { __typename?: 'Mutation', addUserCurrency?: { __typename?: 'UserCurrency', userId?: any | null, userEmailId?: string | null, userCurrency?: string | null } | null };

export type GetUserCurrencyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserCurrencyQuery = { __typename?: 'Query', getUserCurrency?: string | null };

export type GetGlobalCompaniesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGlobalCompaniesQuery = { __typename?: 'Query', globalCompaniesSearch?: Array<{ __typename?: 'GlobalCompanySearchType', id?: string | null, name?: string | null, cin?: string | null, valuation?: number | null, companyCurrency?: string | null, jurisdiction?: string | null, dba?: string | null, isPrivate?: boolean | null, companyStage?: string | null, valuationDate?: string | null, sharePrice?: number | null, type?: WatchlistEntityType | null, investorName?: string | null } | null> | null };

export type AddOrRemoveStarredCompaniesMutationVariables = Exact<{
  input?: InputMaybe<StarCompanyInput>;
}>;


export type AddOrRemoveStarredCompaniesMutation = { __typename?: 'Mutation', upsertStarCompanyToWatchlist?: { __typename?: 'StarCompanyType', companyName?: string | null, companyId?: string | null, watchlistId?: any | null } | null };

export type AddRecentCompaniesMutationVariables = Exact<{
  input?: InputMaybe<RecentCompanyInput>;
}>;


export type AddRecentCompaniesMutation = { __typename?: 'Mutation', addUserRecentCompany?: Array<{ __typename?: 'RecentCompanyType', name?: string | null, type: CompanyTypes, hissaCompanyId?: string | null, id?: any | null, logo?: string | null, dba?: string | null, visitedDateTime?: string | null } | null> | null };

export type RemoveRecentCompanyMutationVariables = Exact<{
  input?: InputMaybe<Array<InputMaybe<RecentCompanyInput>> | InputMaybe<RecentCompanyInput>>;
}>;


export type RemoveRecentCompanyMutation = { __typename?: 'Mutation', removeUserRecentCompany?: Array<{ __typename?: 'RecentCompanyType', name?: string | null, type: CompanyTypes, hissaCompanyId?: string | null, id?: any | null, logo?: string | null, dba?: string | null, visitedDateTime?: string | null } | null> | null };

export type GetRecentCompaniesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRecentCompaniesQuery = { __typename?: 'Query', getUserRecentCompanies?: Array<{ __typename?: 'RecentCompanyType', name?: string | null, type: CompanyTypes, hissaCompanyId?: string | null, id?: any | null, logo?: string | null, dba?: string | null, visitedDateTime?: string | null } | null> | null };

export type AddIndirectTransactionMutationVariables = Exact<{
  input?: InputMaybe<AddIndirectTransactionsInput>;
}>;


export type AddIndirectTransactionMutation = { __typename?: 'Mutation', addIndirectTransaction?: { __typename?: 'IndirectTransactionType', companyId?: any | null, investorId?: any | null, noOfUnits?: any | null, unitType?: string | null, investmentDate?: any | null, currentNav?: number | null, investedAmount?: number | null, drawDown?: number | null, setupFee?: number | null, indirectVehicleID?: any | null, investmentNav?: number | null, currentNavDate?: number | null } | null };

export type AddDirectTransactionMutationVariables = Exact<{
  input?: InputMaybe<AddTransactionInput>;
}>;


export type AddDirectTransactionMutation = { __typename?: 'Mutation', addTransaction?: { __typename?: 'DirectTransactionType', companyId?: any | null, currency?: string | null, investorId?: any | null, exchangeRate?: number | null, investmentDate?: any | null, noOfShares?: any | null, investedAmount?: number | null, sharePrice?: number | null, roundName?: string | null, shareDistinctiveRange?: any | null } | null };

export type AddTagsToCompanyMutationVariables = Exact<{
  input?: InputMaybe<AddTagsToCompanyInput>;
}>;


export type AddTagsToCompanyMutation = { __typename?: 'Mutation', addTagsToCompany?: Array<string | null> | null };

export type AddTagsToTransactionMutationVariables = Exact<{
  input?: InputMaybe<AddTagsToTransactionInput>;
}>;


export type AddTagsToTransactionMutation = { __typename?: 'Mutation', addTagsToTransaction?: Array<string | null> | null };

export type RemoveTransactionMutationVariables = Exact<{
  input?: InputMaybe<RemoveTransactionInput>;
}>;


export type RemoveTransactionMutation = { __typename?: 'Mutation', removeTransaction?: { __typename?: 'RemovedTransactionData', id?: any | null, companyId?: any | null, investorId?: any | null } | null };

export type RemoveIndirectTransactionMutationVariables = Exact<{
  input?: InputMaybe<RemoveTransactionInput>;
}>;


export type RemoveIndirectTransactionMutation = { __typename?: 'Mutation', removeIndirectTransaction?: { __typename?: 'RemovedTransactionData', id?: any | null, companyId?: any | null, investorId?: any | null } | null };

export type SyncHissaCompaniesMutationVariables = Exact<{
  input?: InputMaybe<Scalars['BigInt']>;
}>;


export type SyncHissaCompaniesMutation = { __typename?: 'Mutation', syncHissaCompaniesForInvestor?: Array<{ __typename?: 'CompanyType', companyId?: string | null, companyName?: string | null } | null> | null };

export type GetNewHissaCompaniesQueryVariables = Exact<{
  input?: InputMaybe<Scalars['BigInt']>;
}>;


export type GetNewHissaCompaniesQuery = { __typename?: 'Query', getNewHissaCompaniesForInvestor?: Array<{ __typename?: 'CompanyType', companyId?: string | null, companyName?: string | null } | null> | null };

export type EditDirectTransactionMutationVariables = Exact<{
  input?: InputMaybe<EditDirectTransactionInput>;
}>;


export type EditDirectTransactionMutation = { __typename?: 'Mutation', editDirectTransaction?: { __typename?: 'DirectTransactionType', companyId?: any | null, currency?: string | null, investorId?: any | null, exchangeRate?: number | null, investmentDate?: any | null, noOfShares?: any | null, investedAmount?: number | null, sharePrice?: number | null, roundName?: string | null, shareDistinctiveRange?: any | null } | null };

export type EditIndirectTransactionMutationVariables = Exact<{
  input?: InputMaybe<EditIndirectTransactionsInput>;
}>;


export type EditIndirectTransactionMutation = { __typename?: 'Mutation', editIndirectTransaction?: { __typename?: 'IndirectTransactionType', companyId?: any | null, investorId?: any | null, noOfUnits?: any | null, unitType?: string | null, investmentDate?: any | null, currentNav?: number | null, investedAmount?: number | null, drawDown?: number | null, setupFee?: number | null, indirectVehicleID?: any | null, investmentNav?: number | null, currentNavDate?: number | null } | null };

export type UpdateCompanyDetailsMutationVariables = Exact<{
  input?: InputMaybe<UpdateCompanyDetailsInput>;
}>;


export type UpdateCompanyDetailsMutation = { __typename?: 'Mutation', updateCompanyDetails?: string | null };

export type SaveInvestmentModellingMutationVariables = Exact<{
  input?: InputMaybe<SaveInvestmentModellingDetailsInput>;
}>;


export type SaveInvestmentModellingMutation = { __typename?: 'Mutation', saveInvestmentModellingDetails?: { __typename?: 'InvestmentModellingDetails', modellingDataId?: any | null } | null };

export type GetInvestmentModellingQueryVariables = Exact<{
  input?: InputMaybe<GetInvestmentModellingDetailsInput>;
}>;


export type GetInvestmentModellingQuery = { __typename?: 'Query', getInvestmentModellingDetails?: { __typename?: 'InvestmentModellingDetails', modellingDataId?: any | null, investmentModellingDetails?: { __typename?: 'ExitModelling', numberOfRounds: number, finalHoldingPercentage: number, heatMap: Array<number>, companyFdbShares: number, finalInvestmentAmount: number, nonPriceRoundHeatMap: Array<number>, valuationCap: number, finalCurrentValue?: number | null, currentInvestmentDetails?: { __typename?: 'ExitModellingTableDetails', roundName?: string | null, dilution: number, valuation: number, investment?: number | null, holdingPercentage: number, date: string, roundSize: number, revenue: number, exitHere: boolean, isDeleted?: boolean | null, currentValue?: number | null } | null, tableDetails: Array<{ __typename?: 'ExitModellingTableDetails', roundName?: string | null, dilution: number, valuation: number, investment?: number | null, holdingPercentage: number, date: string, roundSize: number, revenue: number, exitHere: boolean, isDeleted?: boolean | null, currentValue?: number | null } | null> } | null } | null };

export type AddAccountAccessMutationVariables = Exact<{
  input?: InputMaybe<AddAccountAccessInput>;
}>;


export type AddAccountAccessMutation = { __typename?: 'Mutation', AddAccountAccess?: string | null };

export type CheckIsRequestSentQueryVariables = Exact<{ [key: string]: never; }>;


export type CheckIsRequestSentQuery = { __typename?: 'Query', checkIsRequestSent?: { __typename?: 'UserAccessType', id?: any | null, userId?: any | null, isEmailSent?: boolean | null, message?: string | null } | null };

export type GetInvestorIrrTransactionsQueryVariables = Exact<{
  input?: InputMaybe<CompanyDataInput>;
}>;


export type GetInvestorIrrTransactionsQuery = { __typename?: 'Query', getInvestorTransactions?: Array<{ __typename?: 'IrrTransactionType', amount?: number | null, date?: string | null } | null> | null };

export type GetCompanyLatestReportQueryVariables = Exact<{
  input?: InputMaybe<CompanyDataInput>;
}>;


export type GetCompanyLatestReportQuery = { __typename?: 'Query', getCompanyLatestReport?: Array<{ __typename?: 'MisDataType', companyName?: string | null, reportId?: any | null, reportName?: string | null, tags?: Array<string | null> | null, reportDate?: string | null, fileUrl?: string | null, timeline?: Array<string | null> | null, data?: Array<{ __typename?: 'ReportDataType', groupName?: string | null, items?: Array<{ __typename?: 'ItemType', subGroupItem?: string | null, type?: string | null, data?: Array<{ __typename?: 'ReportDataPointType', projected?: number | null, actual?: number | null } | null> | null } | null> | null } | null> | null } | null> | null };

export type SendTermsheetToCaptableMutationVariables = Exact<{
  input?: InputMaybe<FetchTermsheetInput>;
}>;


export type SendTermsheetToCaptableMutation = { __typename?: 'Mutation', sendTermsheetToCaptable?: any | null };

export type GetInvestorRoundModellingQueryVariables = Exact<{
  input?: InputMaybe<InvestorRoundModellingInput>;
}>;


export type GetInvestorRoundModellingQuery = { __typename?: 'Query', getInvestorRoundModellingDetails?: Array<{ __typename?: 'IndividualInvestorCapTable', id: string, preHoldingFdbShares: any, postHoldingFdbShares: any, preHoldingFdbPercentage: number, postHoldingFdbPercentage: number, amountInvestedInRound: number, shareholderName: string, shareholderType: string } | null> | null };

export type GetInvestorRoundModellingDataQueryVariables = Exact<{
  input?: InputMaybe<GetInvestorModellingInput>;
}>;


export type GetInvestorRoundModellingDataQuery = { __typename?: 'Query', getSavedInvestorRoundModellingDetails?: { __typename?: 'InvestorRoundModellingData', id?: any | null, accountId?: any | null, investmentModellingData?: any | null, hissaCompanyId?: string | null, name?: string | null } | null };

export type GetAllInvestorRoundModellingDataQueryVariables = Exact<{
  input?: InputMaybe<GetInvestorModellingInput>;
}>;


export type GetAllInvestorRoundModellingDataQuery = { __typename?: 'Query', getAllInvestorRoundModelling?: Array<{ __typename?: 'InvestorRoundModellingData', id?: any | null, accountId?: any | null, investmentModellingData?: any | null, hissaCompanyId?: string | null, name?: string | null } | null> | null };

export type SaveInvestorRoundModellingDataMutationVariables = Exact<{
  input?: InputMaybe<SaveInvestorModellingInput>;
}>;


export type SaveInvestorRoundModellingDataMutation = { __typename?: 'Mutation', saveInvestorRoundModellingDetails?: { __typename?: 'SavedInvestorModelling', investorModellingDetails?: any | null, hissaCompanyId?: string | null, name?: string | null, id?: any | null } | null };

export type DeleteInvestorRoundModellingDataMutationVariables = Exact<{
  input?: InputMaybe<RemoveInvestorModellingInput>;
}>;


export type DeleteInvestorRoundModellingDataMutation = { __typename?: 'Mutation', deleteInvestorRoundModellingDetails?: string | null };

export type AddReportsToCompanyMutationVariables = Exact<{
  input?: InputMaybe<AddMisReportInput>;
}>;


export type AddReportsToCompanyMutation = { __typename?: 'Mutation', addCompanyMisReport?: { __typename?: 'MisReportDataType', id?: any | null, name?: string | null } | null };

export type GetCompanyMisReportsQueryVariables = Exact<{
  input?: InputMaybe<CompanyDataInput>;
}>;


export type GetCompanyMisReportsQuery = { __typename?: 'Query', getCompanyMisReports?: Array<{ __typename?: 'MisReportDataType', id?: any | null, name?: string | null, tags?: Array<string | null> | null, fileUrl?: string | null, createdAt?: any | null, updatedAt?: any | null, reportDate?: any | null } | null> | null };

export type DeleteCompanyReportsMutationVariables = Exact<{
  input?: InputMaybe<DeleteMisReportInput>;
}>;


export type DeleteCompanyReportsMutation = { __typename?: 'Mutation', deleteCompanyMisReport?: { __typename?: 'MisReportDataType', id?: any | null, name?: string | null } | null };

export type GetCompanyReportByIdQueryVariables = Exact<{
  input?: InputMaybe<DeleteMisReportInput>;
}>;


export type GetCompanyReportByIdQuery = { __typename?: 'Query', getCompanyMisReportById?: Array<{ __typename?: 'MisDataType', companyName?: string | null, reportId?: any | null, reportName?: string | null, tags?: Array<string | null> | null, reportDate?: string | null, fileUrl?: string | null, timeline?: Array<string | null> | null, data?: Array<{ __typename?: 'ReportDataType', groupName?: string | null, items?: Array<{ __typename?: 'ItemType', subGroupItem?: string | null, type?: string | null, data?: Array<{ __typename?: 'ReportDataPointType', projected?: number | null, actual?: number | null } | null> | null } | null> | null } | null> | null } | null> | null };

export type GetDocumentSignIdQueryVariables = Exact<{
  input?: InputMaybe<DocumentSignIdInput>;
}>;


export type GetDocumentSignIdQuery = { __typename?: 'Query', getDocumentSignId?: string | null };

export type EditReportsOfCompanyMutationVariables = Exact<{
  input?: InputMaybe<EditMisReportInput>;
}>;


export type EditReportsOfCompanyMutation = { __typename?: 'Mutation', editCompanyMisReport?: { __typename?: 'MisReportDataType', id?: any | null, name?: string | null } | null };

export type UploadPrivateCaptableMutationVariables = Exact<{
  input?: InputMaybe<PrivateCaptableInput>;
}>;


export type UploadPrivateCaptableMutation = { __typename?: 'Mutation', createPrivateCaptable?: { __typename?: 'PrivateCaptableType', id?: any | null, cin?: string | null, companyName?: string | null, hissaCompanyId?: string | null, companyType?: StageCompanyType | null, fileUrl?: string | null } | null };

export type GetAllPrivateCaptablesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllPrivateCaptablesQuery = { __typename?: 'Query', getAllPrivateCaptables?: Array<{ __typename?: 'PrivateCaptableType', id?: any | null, cin?: string | null, companyName?: string | null, hissaCompanyId?: string | null, companyType?: StageCompanyType | null, fileUrl?: string | null } | null> | null };

export type DeletePrivateCaptableMutationVariables = Exact<{
  input?: InputMaybe<DeletePrivateCaptableInput>;
}>;


export type DeletePrivateCaptableMutation = { __typename?: 'Mutation', deletePrivateCaptables?: string | null };

export type GetAllDynamicTableDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllDynamicTableDataQuery = { __typename?: 'Query', getDynamicTableData?: Array<{ __typename?: 'DynamicTableType', id?: any | null, userId?: any | null, name?: string | null, description?: string | null, tableData?: any | null, chartData?: any | null, fileUrl?: string | null, googleSheetLink?: string | null, fileName?: string | null, isPublished?: boolean | null } | null> | null };

export type AddDynamicTableDataMutationVariables = Exact<{
  input?: InputMaybe<DynamicTableDataInput>;
}>;


export type AddDynamicTableDataMutation = { __typename?: 'Mutation', createDynamicTableData?: { __typename?: 'DynamicTableType', id?: any | null, userId?: any | null, name?: string | null, description?: string | null, tableData?: any | null, chartData?: any | null, fileUrl?: string | null } | null };

export type DeleteDynamicTableDataMutationVariables = Exact<{
  input?: InputMaybe<DeleteDynamicTableInput>;
}>;


export type DeleteDynamicTableDataMutation = { __typename?: 'Mutation', deleteDynamicTableData?: string | null };

export type DeleteExitModelDataMutationVariables = Exact<{
  input?: InputMaybe<RemoveExitModelInput>;
}>;


export type DeleteExitModelDataMutation = { __typename?: 'Mutation', removeExitModellingDetails?: string | null };

export type GetAllExitModellingQueryVariables = Exact<{
  input?: InputMaybe<GetInvestmentModellingDetailsInput>;
}>;


export type GetAllExitModellingQuery = { __typename?: 'Query', getAllExitModellingDetails?: Array<{ __typename?: 'InvestmentModellingDetails', modellingDataId?: any | null, modelName?: string | null, investmentModellingDetails?: { __typename?: 'ExitModelling', numberOfRounds: number, finalHoldingPercentage: number, heatMap: Array<number>, companyFdbShares: number, finalInvestmentAmount: number, nonPriceRoundHeatMap: Array<number>, valuationCap: number, finalCurrentValue?: number | null, currentInvestmentDetails?: { __typename?: 'ExitModellingTableDetails', roundName?: string | null, dilution: number, valuation: number, investment?: number | null, holdingPercentage: number, date: string, roundSize: number, revenue: number, exitHere: boolean, isDeleted?: boolean | null, currentValue?: number | null } | null, tableDetails: Array<{ __typename?: 'ExitModellingTableDetails', roundName?: string | null, dilution: number, valuation: number, investment?: number | null, holdingPercentage: number, date: string, roundSize: number, revenue: number, exitHere: boolean, isDeleted?: boolean | null, currentValue?: number | null } | null> } | null } | null> | null };

export type AddNewHissaCompaniesForInvestorMutationVariables = Exact<{
  input?: InputMaybe<SyncInvestorCompaniesInput>;
}>;


export type AddNewHissaCompaniesForInvestorMutation = { __typename?: 'Mutation', addNewHissaCompaniesForInvestor?: Array<{ __typename?: 'CompanyType', companyId?: string | null, companyName?: string | null } | null> | null };

export type RemoveExistingCompaniesMutationVariables = Exact<{
  input?: InputMaybe<SyncInvestorCompaniesInput>;
}>;


export type RemoveExistingCompaniesMutation = { __typename?: 'Mutation', removeExistingCompanies?: Array<{ __typename?: 'ExistingCompanyType', companyId?: string | null, companyName?: string | null, companyType?: string | null } | null> | null };

export type GetExistingHissaCompaniesQueryVariables = Exact<{
  input?: InputMaybe<Scalars['BigInt']>;
}>;


export type GetExistingHissaCompaniesQuery = { __typename?: 'Query', getExistingCompaniesForInvestor?: Array<{ __typename?: 'ExistingCompanyType', companyId?: string | null, companyName?: string | null, companyType?: string | null } | null> | null };

export type RemoveInvestorFromAccountMutationVariables = Exact<{
  input?: InputMaybe<InvestorRemoveInput>;
}>;


export type RemoveInvestorFromAccountMutation = { __typename?: 'Mutation', removeInvestor?: any | null };

export type ReGenerateCertificateQueryVariables = Exact<{
  input?: InputMaybe<GenerateCertificateType>;
}>;


export type ReGenerateCertificateQuery = { __typename?: 'Query', getReGeneratedCertificate?: any | null };

export type GetGrantsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGrantsQuery = { __typename?: 'Query', grants?: Array<{ __typename?: 'Grant', grantId: any, userId: any, companyName?: string | null, grantDate: any, grantType: GrantType, numberGranted: number, exercisePriceOrSarValue: number, expiryDate?: any | null, status: GrantStatus, createdAt: any, updatedAt: any, cancelledAt?: any | null, cancellationReason?: string | null, salePrice?: number | null, metadata?: any | null, vestedOptions?: number | null, companyFMV?: number | null, companyCurrency?: string | null, fmvDate?: any | null, notes?: string | null, planName?: string | null, expiryNumber?: number | null, expiryUnitType?: ExpiryUnitType | null, numberExercised?: number | null, companyFmvinUserCurrency?: string | null, strikePriceinUserCurrency?: string | null, vestingSchedules?: Array<{ __typename?: 'VestingSchedule', vestingScheduleId?: any | null, grantId: any, scheduleType: VestingScheduleType, cliffDurationMonths?: number | null, vestingFrequency?: VestingFrequency | null, totalVestingDurationMonths?: number | null, performanceCriteria?: string | null, createdAt: any, updatedAt: any, vestedOptions?: number | null, vestingTemplateName?: string | null, metadata?: any | null } | null> | null } | null> | null };

export type GetGrantQueryVariables = Exact<{
  input: Scalars['BigInt'];
}>;


export type GetGrantQuery = { __typename?: 'Query', grant?: { __typename?: 'Grant', grantId: any, userId: any, companyName?: string | null, grantDate: any, grantType: GrantType, numberGranted: number, exercisePriceOrSarValue: number, expiryDate?: any | null, status: GrantStatus, createdAt: any, updatedAt: any, cancelledAt?: any | null, cancellationReason?: string | null, metadata?: any | null, salePrice?: number | null, vestedOptions?: number | null, companyFMV?: number | null, companyCurrency?: string | null, fmvDate?: any | null, notes?: string | null, numberExercised?: number | null, planName?: string | null, expiryNumber?: number | null, expiryUnitType?: ExpiryUnitType | null, vestingSchedules?: Array<{ __typename?: 'VestingSchedule', vestingScheduleId?: any | null, grantId: any, scheduleType: VestingScheduleType, cliffDurationMonths?: number | null, vestingFrequency?: VestingFrequency | null, vestedOptions?: number | null, totalVestingDurationMonths?: number | null, performanceCriteria?: string | null, createdAt: any, updatedAt: any, vestingTemplateName?: string | null, metadata?: any | null, vestingMilestones?: Array<{ __typename?: 'VestingMilestone', vestingMilestoneId: any, vestingScheduleId: any, milestoneDate: any, percentageToVest?: number | null, numberToVest?: number | null, isAchieved: boolean, achievedDate?: any | null, createdAt: any, updatedAt: any, metadata?: any | null } | null> | null } | null> | null } | null };

export type CreateGrantMutationVariables = Exact<{
  input: CreateGrantInput;
}>;


export type CreateGrantMutation = { __typename?: 'Mutation', createGrant?: { __typename?: 'Grant', grantId: any, userId: any, companyName?: string | null, grantDate: any, grantType: GrantType, numberGranted: number, status: GrantStatus, metadata?: any | null, vestedOptions?: number | null, companyFMV?: number | null, companyCurrency?: string | null, expiryNumber?: number | null, expiryUnitType?: ExpiryUnitType | null, planName?: string | null, vestingSchedules?: Array<{ __typename?: 'VestingSchedule', vestingScheduleId?: any | null, grantId: any, scheduleType: VestingScheduleType, cliffDurationMonths?: number | null, vestingFrequency?: VestingFrequency | null, totalVestingDurationMonths?: number | null, performanceCriteria?: string | null, createdAt: any, updatedAt: any, vestedOptions?: number | null, vestingTemplateName?: string | null, metadata?: any | null, vestingMilestones?: Array<{ __typename?: 'VestingMilestone', vestingMilestoneId: any, vestingScheduleId: any, milestoneDate: any, percentageToVest?: number | null, numberToVest?: number | null, isAchieved: boolean, achievedDate?: any | null, createdAt: any, updatedAt: any, metadata?: any | null } | null> | null } | null> | null } | null };

export type UpdateGrantMutationVariables = Exact<{
  input: UpdateGrantInput;
}>;


export type UpdateGrantMutation = { __typename?: 'Mutation', updateGrant?: { __typename?: 'Grant', grantId: any, userId: any, companyName?: string | null, grantDate: any, grantType: GrantType, numberGranted: number, status: GrantStatus, companyFMV?: number | null, companyCurrency?: string | null, vestedOptions?: number | null, planName?: string | null, expiryNumber?: number | null, metadata?: any | null } | null };

export type CancelGrantMutationVariables = Exact<{
  input: CancelGrantInput;
}>;


export type CancelGrantMutation = { __typename?: 'Mutation', cancelGrant?: { __typename?: 'Grant', grantId: any, cancellationReason?: string | null, cancelledAt?: any | null } | null };

export type DeleteGrantMutationVariables = Exact<{
  grantId: Scalars['BigInt'];
}>;


export type DeleteGrantMutation = { __typename?: 'Mutation', deleteGrant?: boolean | null };

export type UploadGrantDataMutationVariables = Exact<{
  input: GrantUploadInput;
}>;


export type UploadGrantDataMutation = { __typename?: 'Mutation', uploadGrantData?: any | null };

export type CreateVestingScheduleMutationVariables = Exact<{
  input: CreateVestingScheduleInput;
}>;


export type CreateVestingScheduleMutation = { __typename?: 'Mutation', createVestingSchedule?: { __typename?: 'VestingSchedule', vestingScheduleId?: any | null, grantId: any, scheduleType: VestingScheduleType, cliffDurationMonths?: number | null, vestingFrequency?: VestingFrequency | null, totalVestingDurationMonths?: number | null, performanceCriteria?: string | null, metadata?: any | null, createdAt: any, updatedAt: any, planName?: string | null, vestingTemplateName?: string | null, vestedOptions?: number | null } | null };

export type UpdateVestingScheduleMutationVariables = Exact<{
  input: UpdateVestingScheduleInput;
}>;


export type UpdateVestingScheduleMutation = { __typename?: 'Mutation', updateVestingSchedule?: { __typename?: 'VestingSchedule', vestingScheduleId?: any | null, grantId: any, scheduleType: VestingScheduleType, cliffDurationMonths?: number | null, vestingFrequency?: VestingFrequency | null, totalVestingDurationMonths?: number | null, performanceCriteria?: string | null, planName?: string | null, metadata?: any | null, vestingTemplateName?: string | null, vestedOptions?: number | null, updatedAt: any } | null };

export type GetPortfolioOverviewReportQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPortfolioOverviewReportQuery = { __typename?: 'Query', portfolioOverviewReport?: any | null };

export type GetCompanyWiseReportQueryVariables = Exact<{
  input?: InputMaybe<Array<InputMaybe<CompanyDataInput>> | InputMaybe<CompanyDataInput>>;
}>;


export type GetCompanyWiseReportQuery = { __typename?: 'Query', companyWiseReport?: any | null };

export type GetAllFundsOfUserQueryVariables = Exact<{
  input?: InputMaybe<Scalars['BigInt']>;
}>;


export type GetAllFundsOfUserQuery = { __typename?: 'Query', getAllFundsOfUser?: any | null };

export type GetAllUsersOfAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllUsersOfAccountQuery = { __typename?: 'Query', getAllUsersOfAccount?: Array<{ __typename?: 'AccountUserType', id?: any | null, name?: string | null, emailId?: string | null, type?: string | null, accountId?: any | null, isAccountAdmin?: boolean | null, role?: string | null } | null> | null };

export type UpdateRoleOfInvestorMutationVariables = Exact<{
  input?: InputMaybe<UpdateRoleOfInvestorInput>;
}>;


export type UpdateRoleOfInvestorMutation = { __typename?: 'Mutation', updateRoleOfInvestor?: string | null };

export type RemoveCompaniesOfInvestorMutationVariables = Exact<{
  input?: InputMaybe<RemoveInvestorCompaniesInput>;
}>;


export type RemoveCompaniesOfInvestorMutation = { __typename?: 'Mutation', removeCompaniesOfInvestor?: Array<{ __typename?: 'ExistingCompanyType', companyType?: string | null, companyId?: string | null, companyName?: string | null } | null> | null };

export type RemoveInvestorOfUserMutationVariables = Exact<{
  input: RemoveInvestorOfUserInput;
}>;


export type RemoveInvestorOfUserMutation = { __typename?: 'Mutation', removeInvestorOfUser?: string | null };

export type RemoveUserFromAccountMutationVariables = Exact<{
  input: Scalars['BigInt'];
}>;


export type RemoveUserFromAccountMutation = { __typename?: 'Mutation', removeUserFromAccount?: string | null };

export type GetExistingCompaniesOfInvestorQueryVariables = Exact<{
  input?: InputMaybe<RemoveInvestorOfUserInput>;
}>;


export type GetExistingCompaniesOfInvestorQuery = { __typename?: 'Query', getCompaniesOfOtherInvestor?: Array<{ __typename?: 'ExistingCompanyType', companyId?: string | null, companyName?: string | null, companyType?: string | null } | null> | null };

export type InvalidateAllCacheMutationVariables = Exact<{ [key: string]: never; }>;


export type InvalidateAllCacheMutation = { __typename?: 'Mutation', invalidateAllCache?: { __typename?: 'CacheInvalidationResult', success: boolean, message: string, keysCleared: number } | null };

export type GetAllDynamicTableFilterQueryVariables = Exact<{
  input?: InputMaybe<GetAllDynamicFilterInput>;
}>;


export type GetAllDynamicTableFilterQuery = { __typename?: 'Query', getAllDynamicTableFilter?: Array<{ __typename?: 'DynamicTableFilters', id?: any | null, tableId?: any | null, filterName?: string | null, filterState?: any | null, tableName?: string | null } | null> | null };

export type CreateDynamicTableFilterMutationVariables = Exact<{
  input?: InputMaybe<DynamicTableFilterInput>;
}>;


export type CreateDynamicTableFilterMutation = { __typename?: 'Mutation', createDynamicTableFilter?: string | null };

export type RemoveDynamicTableFilterMutationVariables = Exact<{
  input?: InputMaybe<GetDynamicFilterInput>;
}>;


export type RemoveDynamicTableFilterMutation = { __typename?: 'Mutation', removeDynamicTableFilter?: string | null };

export type SetDynamicTablePublicAccessMutationVariables = Exact<{
  input?: InputMaybe<DynamicTablePublicAccessInput>;
}>;


export type SetDynamicTablePublicAccessMutation = { __typename?: 'Mutation', setDynamicTablePublicAccess?: string | null };

export type AddInvestorToUserMutationVariables = Exact<{
  input: AddInvestorToUserInput;
}>;


export type AddInvestorToUserMutation = { __typename?: 'Mutation', addInvestorToUser?: { __typename?: 'Investor', id?: any | null, name?: string | null } | null };

export type AddMultipleInvestorToMultipleUserMutationVariables = Exact<{
  input?: InputMaybe<AddMultipleInvestorToMultipleUserInput>;
}>;


export type AddMultipleInvestorToMultipleUserMutation = { __typename?: 'Mutation', addMultipleInvestorsToMultipleUsers?: string | null };

export type AddEoiMutationVariables = Exact<{
  input: EoiInput;
}>;


export type AddEoiMutation = { __typename?: 'Mutation', addEoi?: { __typename?: 'EoiType', id?: any | null, companyId?: any | null, companyName?: string | null, companyCin?: string | null, hissaCompanyId?: string | null, offerDetails?: any | null, esopFinancing?: any | null, notes?: string | null, companyType?: CompanyTypes | null, offerType?: string | null, comments?: string | null } | null };

export type GetEoiForAllUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEoiForAllUsersQuery = { __typename?: 'Query', getEoiForAllUsers?: Array<{ __typename?: 'EoiType', id?: any | null, companyId?: any | null, companyName?: string | null, companyCin?: string | null, hissaCompanyId?: string | null, offerDetails?: any | null, esopFinancing?: any | null, notes?: string | null, companyType?: CompanyTypes | null, offerType?: string | null, comments?: string | null, createdAt?: any | null } | null> | null };

export type SyncGoogleSheetToS3MutationVariables = Exact<{
  input: SyncGoogleSheetInput;
}>;


export type SyncGoogleSheetToS3Mutation = { __typename?: 'Mutation', syncGoogleSheetToS3?: string | null };

export type SwitchAccountMutationVariables = Exact<{
  input: SwitchAccountInput;
}>;


export type SwitchAccountMutation = { __typename?: 'Mutation', switchAccount?: any | null };


export const GetInvestmentDocument = `
    query getInvestment {
  investments(input: {investorId: 47})
}
    `;
export const useGetInvestmentQuery = <
      TData = GetInvestmentQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetInvestmentQueryVariables,
      options?: UseQueryOptions<GetInvestmentQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetInvestmentQuery, TError, TData>(
      variables === undefined ? ['getInvestment'] : ['getInvestment', variables],
      fetcher<GetInvestmentQuery, GetInvestmentQueryVariables>(client, GetInvestmentDocument, variables, headers),
      options
    );

useGetInvestmentQuery.getKey = (variables?: GetInvestmentQueryVariables) => variables === undefined ? ['getInvestment'] : ['getInvestment', variables];
;

export const GetInvestorsDocument = `
    query getInvestors($input: InvestorFetchInput) {
  investors(input: $input)
}
    `;
export const useGetInvestorsQuery = <
      TData = GetInvestorsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetInvestorsQueryVariables,
      options?: UseQueryOptions<GetInvestorsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetInvestorsQuery, TError, TData>(
      variables === undefined ? ['getInvestors'] : ['getInvestors', variables],
      fetcher<GetInvestorsQuery, GetInvestorsQueryVariables>(client, GetInvestorsDocument, variables, headers),
      options
    );

useGetInvestorsQuery.getKey = (variables?: GetInvestorsQueryVariables) => variables === undefined ? ['getInvestors'] : ['getInvestors', variables];
;

export const GetWatchlistsDocument = `
    query getWatchlists {
  watchlists {
    id
    name
    companies {
      id
      cin
      name
      sharePrice
      latestRaise
      latestRaiseDate
      noOfRounds
      valuation
      totalFunding
      logo
      industry
      starred
      business
      hissaCompanyId
      totalRaised
      DBA
      institutional
      angel
      totalInvestors
      keyInvestors
      totalShares
      founderHolding
      esopHolding
      keyInvestors
      companyId
      founded
      t2CompanyId
      t3CompanyId
    }
    highlights {
      eventType
      companyName
    }
  }
}
    `;
export const useGetWatchlistsQuery = <
      TData = GetWatchlistsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetWatchlistsQueryVariables,
      options?: UseQueryOptions<GetWatchlistsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetWatchlistsQuery, TError, TData>(
      variables === undefined ? ['getWatchlists'] : ['getWatchlists', variables],
      fetcher<GetWatchlistsQuery, GetWatchlistsQueryVariables>(client, GetWatchlistsDocument, variables, headers),
      options
    );

useGetWatchlistsQuery.getKey = (variables?: GetWatchlistsQueryVariables) => variables === undefined ? ['getWatchlists'] : ['getWatchlists', variables];
;

export const GetNewWatchlistsDocument = `
    query getNewWatchlists {
  newWatchlists {
    id
    name
    starredCompanies
    createdAt
    updatedAt
    type
  }
}
    `;
export const useGetNewWatchlistsQuery = <
      TData = GetNewWatchlistsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetNewWatchlistsQueryVariables,
      options?: UseQueryOptions<GetNewWatchlistsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetNewWatchlistsQuery, TError, TData>(
      variables === undefined ? ['getNewWatchlists'] : ['getNewWatchlists', variables],
      fetcher<GetNewWatchlistsQuery, GetNewWatchlistsQueryVariables>(client, GetNewWatchlistsDocument, variables, headers),
      options
    );

useGetNewWatchlistsQuery.getKey = (variables?: GetNewWatchlistsQueryVariables) => variables === undefined ? ['getNewWatchlists'] : ['getNewWatchlists', variables];
;

export const GetWatchlistsWithCompaniesDocument = `
    query getWatchlistsWithCompanies {
  newWatchlists {
    id
    name
    starredCompanies
    createdAt
    updatedAt
    type
    companies {
      companyData {
        cashBalance
        cin
        companyCurrency
        dba
        esopHolding
        founderHoldingPercentage
        isPrivate
        companyStage
        hissaCompanyId
        id
        incorporationDate
        industry
        jurisdiction
        latestRaise
        latestRaiseDate
        latestRound
        valuationInCompanyCurrency
        logo
        name
        noOfRounds
        revenue
        sharePrice
        totalFdbShares
        totalFunding
        type
        valuation
        businessDescription
        corporateOfficeAddress
        equityPaidUpCapital
        preferencePaidUpCapital
        equityAuthorizedCapital
        preferenceAuthorizedCapital
        directorDetails
      }
      roundData {
        id
        name
        postMoneyValuation
        roundSize
        roundDate
      }
    }
  }
}
    `;
export const useGetWatchlistsWithCompaniesQuery = <
      TData = GetWatchlistsWithCompaniesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetWatchlistsWithCompaniesQueryVariables,
      options?: UseQueryOptions<GetWatchlistsWithCompaniesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetWatchlistsWithCompaniesQuery, TError, TData>(
      variables === undefined ? ['getWatchlistsWithCompanies'] : ['getWatchlistsWithCompanies', variables],
      fetcher<GetWatchlistsWithCompaniesQuery, GetWatchlistsWithCompaniesQueryVariables>(client, GetWatchlistsWithCompaniesDocument, variables, headers),
      options
    );

useGetWatchlistsWithCompaniesQuery.getKey = (variables?: GetWatchlistsWithCompaniesQueryVariables) => variables === undefined ? ['getWatchlistsWithCompanies'] : ['getWatchlistsWithCompanies', variables];
;

export const GetWatchlistByIdDocument = `
    query getWatchlistById($input: FetchWatchlistInput!) {
  newWatchlists(input: $input) {
    id
    name
    starredCompanies
    createdAt
    updatedAt
    type
    companies {
      companyData {
        cashBalance
        cin
        companyCurrency
        dba
        esopHolding
        founderHoldingPercentage
        isPrivate
        companyStage
        hissaCompanyId
        id
        incorporationDate
        industry
        jurisdiction
        latestRaise
        latestRaiseDate
        latestRound
        valuationInCompanyCurrency
        logo
        name
        noOfRounds
        revenue
        sharePrice
        totalFdbShares
        totalFunding
        type
        valuation
        businessDescription
        corporateOfficeAddress
        equityPaidUpCapital
        preferencePaidUpCapital
        equityAuthorizedCapital
        preferenceAuthorizedCapital
        directorDetails
      }
      roundData {
        id
        name
        postMoneyValuation
        roundSize
        roundDate
      }
      aggregateData {
        moic
        irr
        realizedValue
        noOfInvestments
        totalInvestment
        currentValue
        noOfHoldingCompanies
        totalNoOfCompanies
        currentHoldingPercentage
      }
    }
  }
}
    `;
export const useGetWatchlistByIdQuery = <
      TData = GetWatchlistByIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetWatchlistByIdQueryVariables,
      options?: UseQueryOptions<GetWatchlistByIdQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetWatchlistByIdQuery, TError, TData>(
      ['getWatchlistById', variables],
      fetcher<GetWatchlistByIdQuery, GetWatchlistByIdQueryVariables>(client, GetWatchlistByIdDocument, variables, headers),
      options
    );

useGetWatchlistByIdQuery.getKey = (variables: GetWatchlistByIdQueryVariables) => ['getWatchlistById', variables];
;

export const AddWatchlistDocument = `
    mutation addWatchlist($input: AddWatchlistInput!) {
  addWatchlist(input: $input)
}
    `;
export const useAddWatchlistMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddWatchlistMutation, TError, AddWatchlistMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddWatchlistMutation, TError, AddWatchlistMutationVariables, TContext>(
      ['addWatchlist'],
      (variables?: AddWatchlistMutationVariables) => fetcher<AddWatchlistMutation, AddWatchlistMutationVariables>(client, AddWatchlistDocument, variables, headers)(),
      options
    );
useAddWatchlistMutation.getKey = () => ['addWatchlist'];

export const RemoveWatchlistDocument = `
    mutation removeWatchlist($input: BigInt) {
  removeWatchlist(input: {id: $input})
}
    `;
export const useRemoveWatchlistMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RemoveWatchlistMutation, TError, RemoveWatchlistMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RemoveWatchlistMutation, TError, RemoveWatchlistMutationVariables, TContext>(
      ['removeWatchlist'],
      (variables?: RemoveWatchlistMutationVariables) => fetcher<RemoveWatchlistMutation, RemoveWatchlistMutationVariables>(client, RemoveWatchlistDocument, variables, headers)(),
      options
    );
useRemoveWatchlistMutation.getKey = () => ['removeWatchlist'];

export const GetInvestmentByStageDocument = `
    query getInvestmentByStage($input: InvestorOrCompanyInput) {
  investmentByStage(input: $input) {
    stage
    count
  }
}
    `;
export const useGetInvestmentByStageQuery = <
      TData = GetInvestmentByStageQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetInvestmentByStageQueryVariables,
      options?: UseQueryOptions<GetInvestmentByStageQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetInvestmentByStageQuery, TError, TData>(
      variables === undefined ? ['getInvestmentByStage'] : ['getInvestmentByStage', variables],
      fetcher<GetInvestmentByStageQuery, GetInvestmentByStageQueryVariables>(client, GetInvestmentByStageDocument, variables, headers),
      options
    );

useGetInvestmentByStageQuery.getKey = (variables?: GetInvestmentByStageQueryVariables) => variables === undefined ? ['getInvestmentByStage'] : ['getInvestmentByStage', variables];
;

export const RemoveCompanyDocument = `
    mutation removeCompany($input: RemoveCompanyFromListInput) {
  removeCompanyFromList(input: $input)
}
    `;
export const useRemoveCompanyMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RemoveCompanyMutation, TError, RemoveCompanyMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RemoveCompanyMutation, TError, RemoveCompanyMutationVariables, TContext>(
      ['removeCompany'],
      (variables?: RemoveCompanyMutationVariables) => fetcher<RemoveCompanyMutation, RemoveCompanyMutationVariables>(client, RemoveCompanyDocument, variables, headers)(),
      options
    );
useRemoveCompanyMutation.getKey = () => ['removeCompany'];

export const AddCompanyDocument = `
    mutation addCompany($input: AddCompanyToListInput!) {
  addCompanyToList(input: $input)
}
    `;
export const useAddCompanyMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddCompanyMutation, TError, AddCompanyMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddCompanyMutation, TError, AddCompanyMutationVariables, TContext>(
      ['addCompany'],
      (variables?: AddCompanyMutationVariables) => fetcher<AddCompanyMutation, AddCompanyMutationVariables>(client, AddCompanyDocument, variables, headers)(),
      options
    );
useAddCompanyMutation.getKey = () => ['addCompany'];

export const SearchDocument = `
    query search($input: SearchCompanyInput) {
  searchCompany(input: $input)
}
    `;
export const useSearchQuery = <
      TData = SearchQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: SearchQueryVariables,
      options?: UseQueryOptions<SearchQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<SearchQuery, TError, TData>(
      variables === undefined ? ['search'] : ['search', variables],
      fetcher<SearchQuery, SearchQueryVariables>(client, SearchDocument, variables, headers),
      options
    );

useSearchQuery.getKey = (variables?: SearchQueryVariables) => variables === undefined ? ['search'] : ['search', variables];
;

export const GetCompanyDetailsDocument = `
    query getCompanyDetails($input: FetchCompanyInput!) {
  companies(input: $input) {
    id
    name
    cin
    shareholders
    totalFunding
    totalShares
    sharePrice
    valuation
    latestRaise
    noOfRounds
    industry
    logo
    business
    starred
    currentValuation
    jurisdiction
    currentSharePrice
    companyId
    hissaCompanyId
    currentExchangeRate
    DBA
    incubationDate
    commitmentAmount
    t2CompanyId
    t3CompanyId
  }
}
    `;
export const useGetCompanyDetailsQuery = <
      TData = GetCompanyDetailsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetCompanyDetailsQueryVariables,
      options?: UseQueryOptions<GetCompanyDetailsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetCompanyDetailsQuery, TError, TData>(
      ['getCompanyDetails', variables],
      fetcher<GetCompanyDetailsQuery, GetCompanyDetailsQueryVariables>(client, GetCompanyDetailsDocument, variables, headers),
      options
    );

useGetCompanyDetailsQuery.getKey = (variables: GetCompanyDetailsQueryVariables) => ['getCompanyDetails', variables];
;

export const GetTermsheetsDocument = `
    query getTermsheets {
  termsheets
}
    `;
export const useGetTermsheetsQuery = <
      TData = GetTermsheetsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetTermsheetsQueryVariables,
      options?: UseQueryOptions<GetTermsheetsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetTermsheetsQuery, TError, TData>(
      variables === undefined ? ['getTermsheets'] : ['getTermsheets', variables],
      fetcher<GetTermsheetsQuery, GetTermsheetsQueryVariables>(client, GetTermsheetsDocument, variables, headers),
      options
    );

useGetTermsheetsQuery.getKey = (variables?: GetTermsheetsQueryVariables) => variables === undefined ? ['getTermsheets'] : ['getTermsheets', variables];
;

export const GetShareholdingDetailsByCompanyDocument = `
    query getShareholdingDetailsByCompany($input: FetchCompanyInput!) {
  companies(input: $input) {
    id
    name
    cin
    shareholdingDetails
    exitData {
      investorName
      companyName
      transactionType
      noOfShares
      transactionDate
      roundName
      pricePerShare
      roundIdentifier
      cin
      amount
    }
  }
}
    `;
export const useGetShareholdingDetailsByCompanyQuery = <
      TData = GetShareholdingDetailsByCompanyQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetShareholdingDetailsByCompanyQueryVariables,
      options?: UseQueryOptions<GetShareholdingDetailsByCompanyQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetShareholdingDetailsByCompanyQuery, TError, TData>(
      ['getShareholdingDetailsByCompany', variables],
      fetcher<GetShareholdingDetailsByCompanyQuery, GetShareholdingDetailsByCompanyQueryVariables>(client, GetShareholdingDetailsByCompanyDocument, variables, headers),
      options
    );

useGetShareholdingDetailsByCompanyQuery.getKey = (variables: GetShareholdingDetailsByCompanyQueryVariables) => ['getShareholdingDetailsByCompany', variables];
;

export const GetExitDataInvestorWiseDocument = `
    query getExitDataInvestorWise($input: [BigInt]) {
  exitDataInvestorWise(investorIds: $input) {
    investorName
    companyName
    transactionType
    noOfShares
    transactionDate
    roundName
    pricePerShare
    roundIdentifier
    cin
    amount
    investorId
    companyId
  }
}
    `;
export const useGetExitDataInvestorWiseQuery = <
      TData = GetExitDataInvestorWiseQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetExitDataInvestorWiseQueryVariables,
      options?: UseQueryOptions<GetExitDataInvestorWiseQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetExitDataInvestorWiseQuery, TError, TData>(
      variables === undefined ? ['getExitDataInvestorWise'] : ['getExitDataInvestorWise', variables],
      fetcher<GetExitDataInvestorWiseQuery, GetExitDataInvestorWiseQueryVariables>(client, GetExitDataInvestorWiseDocument, variables, headers),
      options
    );

useGetExitDataInvestorWiseQuery.getKey = (variables?: GetExitDataInvestorWiseQueryVariables) => variables === undefined ? ['getExitDataInvestorWise'] : ['getExitDataInvestorWise', variables];
;

export const AddInvestmentInputDocument = `
    mutation addInvestmentInput($input: AddInvestmentInput) {
  addInvestment(input: $input)
}
    `;
export const useAddInvestmentInputMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddInvestmentInputMutation, TError, AddInvestmentInputMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddInvestmentInputMutation, TError, AddInvestmentInputMutationVariables, TContext>(
      ['addInvestmentInput'],
      (variables?: AddInvestmentInputMutationVariables) => fetcher<AddInvestmentInputMutation, AddInvestmentInputMutationVariables>(client, AddInvestmentInputDocument, variables, headers)(),
      options
    );
useAddInvestmentInputMutation.getKey = () => ['addInvestmentInput'];

export const GetAllInvestmentsDocument = `
    query getAllInvestments {
  allInvestments
}
    `;
export const useGetAllInvestmentsQuery = <
      TData = GetAllInvestmentsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetAllInvestmentsQueryVariables,
      options?: UseQueryOptions<GetAllInvestmentsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetAllInvestmentsQuery, TError, TData>(
      variables === undefined ? ['getAllInvestments'] : ['getAllInvestments', variables],
      fetcher<GetAllInvestmentsQuery, GetAllInvestmentsQueryVariables>(client, GetAllInvestmentsDocument, variables, headers),
      options
    );

useGetAllInvestmentsQuery.getKey = (variables?: GetAllInvestmentsQueryVariables) => variables === undefined ? ['getAllInvestments'] : ['getAllInvestments', variables];
;

export const RemoveInvestmentDocument = `
    mutation removeInvestment($input: RemoveInvestmentInput) {
  removeInvestment(input: $input)
}
    `;
export const useRemoveInvestmentMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RemoveInvestmentMutation, TError, RemoveInvestmentMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RemoveInvestmentMutation, TError, RemoveInvestmentMutationVariables, TContext>(
      ['removeInvestment'],
      (variables?: RemoveInvestmentMutationVariables) => fetcher<RemoveInvestmentMutation, RemoveInvestmentMutationVariables>(client, RemoveInvestmentDocument, variables, headers)(),
      options
    );
useRemoveInvestmentMutation.getKey = () => ['removeInvestment'];

export const GetPortfolioMetricsDocument = `
    query getPortfolioMetrics($input: InvestorOrCompanyInput) {
  portfolioMetrics(input: $input) {
    investorName
    count
    amount
    investorId
  }
}
    `;
export const useGetPortfolioMetricsQuery = <
      TData = GetPortfolioMetricsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetPortfolioMetricsQueryVariables,
      options?: UseQueryOptions<GetPortfolioMetricsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetPortfolioMetricsQuery, TError, TData>(
      variables === undefined ? ['getPortfolioMetrics'] : ['getPortfolioMetrics', variables],
      fetcher<GetPortfolioMetricsQuery, GetPortfolioMetricsQueryVariables>(client, GetPortfolioMetricsDocument, variables, headers),
      options
    );

useGetPortfolioMetricsQuery.getKey = (variables?: GetPortfolioMetricsQueryVariables) => variables === undefined ? ['getPortfolioMetrics'] : ['getPortfolioMetrics', variables];
;

export const GetStarCompaniesDocument = `
    query getStarCompanies($input: QueryStarCompaniesArgsInput) {
  starCompanies(input: $input)
}
    `;
export const useGetStarCompaniesQuery = <
      TData = GetStarCompaniesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetStarCompaniesQueryVariables,
      options?: UseQueryOptions<GetStarCompaniesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetStarCompaniesQuery, TError, TData>(
      variables === undefined ? ['getStarCompanies'] : ['getStarCompanies', variables],
      fetcher<GetStarCompaniesQuery, GetStarCompaniesQueryVariables>(client, GetStarCompaniesDocument, variables, headers),
      options
    );

useGetStarCompaniesQuery.getKey = (variables?: GetStarCompaniesQueryVariables) => variables === undefined ? ['getStarCompanies'] : ['getStarCompanies', variables];
;

export const GetUrlForS3ObjectDocument = `
    query getUrlForS3Object($input: S3ObjectUrl) {
  urlForS3Object(input: $input)
}
    `;
export const useGetUrlForS3ObjectQuery = <
      TData = GetUrlForS3ObjectQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetUrlForS3ObjectQueryVariables,
      options?: UseQueryOptions<GetUrlForS3ObjectQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetUrlForS3ObjectQuery, TError, TData>(
      variables === undefined ? ['getUrlForS3Object'] : ['getUrlForS3Object', variables],
      fetcher<GetUrlForS3ObjectQuery, GetUrlForS3ObjectQueryVariables>(client, GetUrlForS3ObjectDocument, variables, headers),
      options
    );

useGetUrlForS3ObjectQuery.getKey = (variables?: GetUrlForS3ObjectQueryVariables) => variables === undefined ? ['getUrlForS3Object'] : ['getUrlForS3Object', variables];
;

export const GetManualInvestmentDocument = `
    query getManualInvestment($input: FetchInvestmentInput!) {
  investments(input: $input)
}
    `;
export const useGetManualInvestmentQuery = <
      TData = GetManualInvestmentQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetManualInvestmentQueryVariables,
      options?: UseQueryOptions<GetManualInvestmentQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetManualInvestmentQuery, TError, TData>(
      ['getManualInvestment', variables],
      fetcher<GetManualInvestmentQuery, GetManualInvestmentQueryVariables>(client, GetManualInvestmentDocument, variables, headers),
      options
    );

useGetManualInvestmentQuery.getKey = (variables: GetManualInvestmentQueryVariables) => ['getManualInvestment', variables];
;

export const EditInvestmentInputDocument = `
    mutation editInvestmentInput($input: EditInvestmentInput) {
  editInvestment(input: $input)
}
    `;
export const useEditInvestmentInputMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<EditInvestmentInputMutation, TError, EditInvestmentInputMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<EditInvestmentInputMutation, TError, EditInvestmentInputMutationVariables, TContext>(
      ['editInvestmentInput'],
      (variables?: EditInvestmentInputMutationVariables) => fetcher<EditInvestmentInputMutation, EditInvestmentInputMutationVariables>(client, EditInvestmentInputDocument, variables, headers)(),
      options
    );
useEditInvestmentInputMutation.getKey = () => ['editInvestmentInput'];

export const UpdateInvestmentsDocument = `
    mutation updateInvestments($input: UpdateInvestmentsInput) {
  updateInvestments(input: $input)
}
    `;
export const useUpdateInvestmentsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateInvestmentsMutation, TError, UpdateInvestmentsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateInvestmentsMutation, TError, UpdateInvestmentsMutationVariables, TContext>(
      ['updateInvestments'],
      (variables?: UpdateInvestmentsMutationVariables) => fetcher<UpdateInvestmentsMutation, UpdateInvestmentsMutationVariables>(client, UpdateInvestmentsDocument, variables, headers)(),
      options
    );
useUpdateInvestmentsMutation.getKey = () => ['updateInvestments'];

export const GetCompanyDataDocument = `
    query getCompanyData($input: FilesDataInput) {
  data(input: $input)
}
    `;
export const useGetCompanyDataQuery = <
      TData = GetCompanyDataQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetCompanyDataQueryVariables,
      options?: UseQueryOptions<GetCompanyDataQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetCompanyDataQuery, TError, TData>(
      variables === undefined ? ['getCompanyData'] : ['getCompanyData', variables],
      fetcher<GetCompanyDataQuery, GetCompanyDataQueryVariables>(client, GetCompanyDataDocument, variables, headers),
      options
    );

useGetCompanyDataQuery.getKey = (variables?: GetCompanyDataQueryVariables) => variables === undefined ? ['getCompanyData'] : ['getCompanyData', variables];
;

export const UploadFileToCompanyDocument = `
    mutation uploadFileToCompany($input: UploadFile) {
  fileUpload(input: $input)
}
    `;
export const useUploadFileToCompanyMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UploadFileToCompanyMutation, TError, UploadFileToCompanyMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UploadFileToCompanyMutation, TError, UploadFileToCompanyMutationVariables, TContext>(
      ['uploadFileToCompany'],
      (variables?: UploadFileToCompanyMutationVariables) => fetcher<UploadFileToCompanyMutation, UploadFileToCompanyMutationVariables>(client, UploadFileToCompanyDocument, variables, headers)(),
      options
    );
useUploadFileToCompanyMutation.getKey = () => ['uploadFileToCompany'];

export const GetPortfolioEventsDocument = `
    query getPortfolioEvents($input: InvestorOrCompanyInput) {
  portfolioEvents(input: $input) {
    investorId
    companyName
    eventType
    eventDate
  }
}
    `;
export const useGetPortfolioEventsQuery = <
      TData = GetPortfolioEventsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetPortfolioEventsQueryVariables,
      options?: UseQueryOptions<GetPortfolioEventsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetPortfolioEventsQuery, TError, TData>(
      variables === undefined ? ['getPortfolioEvents'] : ['getPortfolioEvents', variables],
      fetcher<GetPortfolioEventsQuery, GetPortfolioEventsQueryVariables>(client, GetPortfolioEventsDocument, variables, headers),
      options
    );

useGetPortfolioEventsQuery.getKey = (variables?: GetPortfolioEventsQueryVariables) => variables === undefined ? ['getPortfolioEvents'] : ['getPortfolioEvents', variables];
;

export const EditWatchlistNameDocument = `
    mutation editWatchlistName($input: EditWatchlistInput!) {
  editWatchlist(input: $input)
}
    `;
export const useEditWatchlistNameMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<EditWatchlistNameMutation, TError, EditWatchlistNameMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<EditWatchlistNameMutation, TError, EditWatchlistNameMutationVariables, TContext>(
      ['editWatchlistName'],
      (variables?: EditWatchlistNameMutationVariables) => fetcher<EditWatchlistNameMutation, EditWatchlistNameMutationVariables>(client, EditWatchlistNameDocument, variables, headers)(),
      options
    );
useEditWatchlistNameMutation.getKey = () => ['editWatchlistName'];

export const UploadBulkInvestmentsDocument = `
    mutation uploadBulkInvestments($up: Upload) {
  addInvestmentBulkUpload(input: {filename: $up})
}
    `;
export const useUploadBulkInvestmentsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UploadBulkInvestmentsMutation, TError, UploadBulkInvestmentsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UploadBulkInvestmentsMutation, TError, UploadBulkInvestmentsMutationVariables, TContext>(
      ['uploadBulkInvestments'],
      (variables?: UploadBulkInvestmentsMutationVariables) => fetcher<UploadBulkInvestmentsMutation, UploadBulkInvestmentsMutationVariables>(client, UploadBulkInvestmentsDocument, variables, headers)(),
      options
    );
useUploadBulkInvestmentsMutation.getKey = () => ['uploadBulkInvestments'];

export const RemoveObjectDocument = `
    mutation removeObject($input: UploadFile) {
  removeObject(input: $input)
}
    `;
export const useRemoveObjectMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RemoveObjectMutation, TError, RemoveObjectMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RemoveObjectMutation, TError, RemoveObjectMutationVariables, TContext>(
      ['removeObject'],
      (variables?: RemoveObjectMutationVariables) => fetcher<RemoveObjectMutation, RemoveObjectMutationVariables>(client, RemoveObjectDocument, variables, headers)(),
      options
    );
useRemoveObjectMutation.getKey = () => ['removeObject'];

export const GetWatchlistHighlightsDocument = `
    query getWatchlistHighlights {
  watchlists {
    id
    name
    highlights {
      eventType
      companyName
    }
  }
}
    `;
export const useGetWatchlistHighlightsQuery = <
      TData = GetWatchlistHighlightsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetWatchlistHighlightsQueryVariables,
      options?: UseQueryOptions<GetWatchlistHighlightsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetWatchlistHighlightsQuery, TError, TData>(
      variables === undefined ? ['getWatchlistHighlights'] : ['getWatchlistHighlights', variables],
      fetcher<GetWatchlistHighlightsQuery, GetWatchlistHighlightsQueryVariables>(client, GetWatchlistHighlightsDocument, variables, headers),
      options
    );

useGetWatchlistHighlightsQuery.getKey = (variables?: GetWatchlistHighlightsQueryVariables) => variables === undefined ? ['getWatchlistHighlights'] : ['getWatchlistHighlights', variables];
;

export const GetDealTemplatesDocument = `
    query getDealTemplates {
  dealTemplates {
    id
    investorId
    name
    sections
    fileURL
    companiesIssuedTo
    creationDate
    lastIssuedDate
    jsonData
    documentType
    accountId
    thumbnailURL
  }
}
    `;
export const useGetDealTemplatesQuery = <
      TData = GetDealTemplatesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetDealTemplatesQueryVariables,
      options?: UseQueryOptions<GetDealTemplatesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetDealTemplatesQuery, TError, TData>(
      variables === undefined ? ['getDealTemplates'] : ['getDealTemplates', variables],
      fetcher<GetDealTemplatesQuery, GetDealTemplatesQueryVariables>(client, GetDealTemplatesDocument, variables, headers),
      options
    );

useGetDealTemplatesQuery.getKey = (variables?: GetDealTemplatesQueryVariables) => variables === undefined ? ['getDealTemplates'] : ['getDealTemplates', variables];
;

export const AddDealTemplateDocument = `
    mutation addDealTemplate($input: AddDealTemplateInput) {
  addDealTemplate(input: $input)
}
    `;
export const useAddDealTemplateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddDealTemplateMutation, TError, AddDealTemplateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddDealTemplateMutation, TError, AddDealTemplateMutationVariables, TContext>(
      ['addDealTemplate'],
      (variables?: AddDealTemplateMutationVariables) => fetcher<AddDealTemplateMutation, AddDealTemplateMutationVariables>(client, AddDealTemplateDocument, variables, headers)(),
      options
    );
useAddDealTemplateMutation.getKey = () => ['addDealTemplate'];

export const AddTagsToDocumentDocument = `
    mutation addTagsToDocument($input: AddTagsToDocumentInput) {
  addTagsToDocument(input: $input)
}
    `;
export const useAddTagsToDocumentMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddTagsToDocumentMutation, TError, AddTagsToDocumentMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddTagsToDocumentMutation, TError, AddTagsToDocumentMutationVariables, TContext>(
      ['addTagsToDocument'],
      (variables?: AddTagsToDocumentMutationVariables) => fetcher<AddTagsToDocumentMutation, AddTagsToDocumentMutationVariables>(client, AddTagsToDocumentDocument, variables, headers)(),
      options
    );
useAddTagsToDocumentMutation.getKey = () => ['addTagsToDocument'];

export const EditDealTemplateDocument = `
    mutation editDealTemplate($input: UpdateDealTemplateInput) {
  updateDealTemplate(input: $input)
}
    `;
export const useEditDealTemplateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<EditDealTemplateMutation, TError, EditDealTemplateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<EditDealTemplateMutation, TError, EditDealTemplateMutationVariables, TContext>(
      ['editDealTemplate'],
      (variables?: EditDealTemplateMutationVariables) => fetcher<EditDealTemplateMutation, EditDealTemplateMutationVariables>(client, EditDealTemplateDocument, variables, headers)(),
      options
    );
useEditDealTemplateMutation.getKey = () => ['editDealTemplate'];

export const DeleteDealTemplateDocument = `
    mutation deleteDealTemplate($input: RemoveDealTemplateInput) {
  removeDealTemplate(input: $input)
}
    `;
export const useDeleteDealTemplateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteDealTemplateMutation, TError, DeleteDealTemplateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteDealTemplateMutation, TError, DeleteDealTemplateMutationVariables, TContext>(
      ['deleteDealTemplate'],
      (variables?: DeleteDealTemplateMutationVariables) => fetcher<DeleteDealTemplateMutation, DeleteDealTemplateMutationVariables>(client, DeleteDealTemplateDocument, variables, headers)(),
      options
    );
useDeleteDealTemplateMutation.getKey = () => ['deleteDealTemplate'];

export const SendNewTermsheetDocument = `
    mutation sendNewTermsheet($input: TermsheetInput, $sendImmediately: Boolean) {
  addTermsheet(input: $input, sendImmediately: $sendImmediately)
}
    `;
export const useSendNewTermsheetMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SendNewTermsheetMutation, TError, SendNewTermsheetMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SendNewTermsheetMutation, TError, SendNewTermsheetMutationVariables, TContext>(
      ['sendNewTermsheet'],
      (variables?: SendNewTermsheetMutationVariables) => fetcher<SendNewTermsheetMutation, SendNewTermsheetMutationVariables>(client, SendNewTermsheetDocument, variables, headers)(),
      options
    );
useSendNewTermsheetMutation.getKey = () => ['sendNewTermsheet'];

export const GetTasksOverviewDocument = `
    query getTasksOverview {
  tasksOverview {
    date
    eventType
    eventStatus
    companyName
    companyId
  }
}
    `;
export const useGetTasksOverviewQuery = <
      TData = GetTasksOverviewQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetTasksOverviewQueryVariables,
      options?: UseQueryOptions<GetTasksOverviewQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetTasksOverviewQuery, TError, TData>(
      variables === undefined ? ['getTasksOverview'] : ['getTasksOverview', variables],
      fetcher<GetTasksOverviewQuery, GetTasksOverviewQueryVariables>(client, GetTasksOverviewDocument, variables, headers),
      options
    );

useGetTasksOverviewQuery.getKey = (variables?: GetTasksOverviewQueryVariables) => variables === undefined ? ['getTasksOverview'] : ['getTasksOverview', variables];
;

export const GetCurrencyExchangeRateDocument = `
    mutation getCurrencyExchangeRate($input: CurrencyExchangeInput) {
  getCurrencyExchangeRate(input: $input) {
    currencyName
    currencyCode
    currencyRate
    updatedAt
  }
}
    `;
export const useGetCurrencyExchangeRateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<GetCurrencyExchangeRateMutation, TError, GetCurrencyExchangeRateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<GetCurrencyExchangeRateMutation, TError, GetCurrencyExchangeRateMutationVariables, TContext>(
      ['getCurrencyExchangeRate'],
      (variables?: GetCurrencyExchangeRateMutationVariables) => fetcher<GetCurrencyExchangeRateMutation, GetCurrencyExchangeRateMutationVariables>(client, GetCurrencyExchangeRateDocument, variables, headers)(),
      options
    );
useGetCurrencyExchangeRateMutation.getKey = () => ['getCurrencyExchangeRate'];

export const UploadLinksDocument = `
    mutation uploadLinks($input: AddLinkInput) {
  addDocumentLink(input: $input)
}
    `;
export const useUploadLinksMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UploadLinksMutation, TError, UploadLinksMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UploadLinksMutation, TError, UploadLinksMutationVariables, TContext>(
      ['uploadLinks'],
      (variables?: UploadLinksMutationVariables) => fetcher<UploadLinksMutation, UploadLinksMutationVariables>(client, UploadLinksDocument, variables, headers)(),
      options
    );
useUploadLinksMutation.getKey = () => ['uploadLinks'];

export const DeleteLinksDocument = `
    mutation deleteLinks($input: RemoveLinkInput) {
  removeDocumentLink(input: $input)
}
    `;
export const useDeleteLinksMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteLinksMutation, TError, DeleteLinksMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteLinksMutation, TError, DeleteLinksMutationVariables, TContext>(
      ['deleteLinks'],
      (variables?: DeleteLinksMutationVariables) => fetcher<DeleteLinksMutation, DeleteLinksMutationVariables>(client, DeleteLinksDocument, variables, headers)(),
      options
    );
useDeleteLinksMutation.getKey = () => ['deleteLinks'];

export const AddBeneficiaryDocument = `
    mutation addBeneficiary($input: AddBeneficiaryInput) {
  addBeneficiary(input: $input)
}
    `;
export const useAddBeneficiaryMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddBeneficiaryMutation, TError, AddBeneficiaryMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddBeneficiaryMutation, TError, AddBeneficiaryMutationVariables, TContext>(
      ['addBeneficiary'],
      (variables?: AddBeneficiaryMutationVariables) => fetcher<AddBeneficiaryMutation, AddBeneficiaryMutationVariables>(client, AddBeneficiaryDocument, variables, headers)(),
      options
    );
useAddBeneficiaryMutation.getKey = () => ['addBeneficiary'];

export const GetAllClassificationsDocument = `
    query getAllClassifications {
  classifications
}
    `;
export const useGetAllClassificationsQuery = <
      TData = GetAllClassificationsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetAllClassificationsQueryVariables,
      options?: UseQueryOptions<GetAllClassificationsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetAllClassificationsQuery, TError, TData>(
      variables === undefined ? ['getAllClassifications'] : ['getAllClassifications', variables],
      fetcher<GetAllClassificationsQuery, GetAllClassificationsQueryVariables>(client, GetAllClassificationsDocument, variables, headers),
      options
    );

useGetAllClassificationsQuery.getKey = (variables?: GetAllClassificationsQueryVariables) => variables === undefined ? ['getAllClassifications'] : ['getAllClassifications', variables];
;

export const GetClassificationDocument = `
    query getClassification($input: GetGroupInput) {
  classification(input: $input)
}
    `;
export const useGetClassificationQuery = <
      TData = GetClassificationQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetClassificationQueryVariables,
      options?: UseQueryOptions<GetClassificationQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetClassificationQuery, TError, TData>(
      variables === undefined ? ['getClassification'] : ['getClassification', variables],
      fetcher<GetClassificationQuery, GetClassificationQueryVariables>(client, GetClassificationDocument, variables, headers),
      options
    );

useGetClassificationQuery.getKey = (variables?: GetClassificationQueryVariables) => variables === undefined ? ['getClassification'] : ['getClassification', variables];
;

export const AddClassificationDocument = `
    mutation addClassification($input: AddGroupInput) {
  addClassification(input: $input)
}
    `;
export const useAddClassificationMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddClassificationMutation, TError, AddClassificationMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddClassificationMutation, TError, AddClassificationMutationVariables, TContext>(
      ['addClassification'],
      (variables?: AddClassificationMutationVariables) => fetcher<AddClassificationMutation, AddClassificationMutationVariables>(client, AddClassificationDocument, variables, headers)(),
      options
    );
useAddClassificationMutation.getKey = () => ['addClassification'];

export const EditClassificationDocument = `
    mutation editClassification($input: UpdateGroupInput) {
  editClassification(input: $input)
}
    `;
export const useEditClassificationMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<EditClassificationMutation, TError, EditClassificationMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<EditClassificationMutation, TError, EditClassificationMutationVariables, TContext>(
      ['editClassification'],
      (variables?: EditClassificationMutationVariables) => fetcher<EditClassificationMutation, EditClassificationMutationVariables>(client, EditClassificationDocument, variables, headers)(),
      options
    );
useEditClassificationMutation.getKey = () => ['editClassification'];

export const RemoveClassificationDocument = `
    mutation removeClassification($input: RemoveGroupInput) {
  removeClassification(input: $input)
}
    `;
export const useRemoveClassificationMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RemoveClassificationMutation, TError, RemoveClassificationMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RemoveClassificationMutation, TError, RemoveClassificationMutationVariables, TContext>(
      ['removeClassification'],
      (variables?: RemoveClassificationMutationVariables) => fetcher<RemoveClassificationMutation, RemoveClassificationMutationVariables>(client, RemoveClassificationDocument, variables, headers)(),
      options
    );
useRemoveClassificationMutation.getKey = () => ['removeClassification'];

export const AddCompaniesToClassificationDocument = `
    mutation addCompaniesToClassification($input: AddCompaniesToGroupInput) {
  addCompaniesToClassification(input: $input)
}
    `;
export const useAddCompaniesToClassificationMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddCompaniesToClassificationMutation, TError, AddCompaniesToClassificationMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddCompaniesToClassificationMutation, TError, AddCompaniesToClassificationMutationVariables, TContext>(
      ['addCompaniesToClassification'],
      (variables?: AddCompaniesToClassificationMutationVariables) => fetcher<AddCompaniesToClassificationMutation, AddCompaniesToClassificationMutationVariables>(client, AddCompaniesToClassificationDocument, variables, headers)(),
      options
    );
useAddCompaniesToClassificationMutation.getKey = () => ['addCompaniesToClassification'];

export const RemoveCompaniesFromClassificationDocument = `
    mutation removeCompaniesFromClassification($input: AddCompaniesToGroupInput) {
  removeCompaniesFromClassification(input: $input)
}
    `;
export const useRemoveCompaniesFromClassificationMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RemoveCompaniesFromClassificationMutation, TError, RemoveCompaniesFromClassificationMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RemoveCompaniesFromClassificationMutation, TError, RemoveCompaniesFromClassificationMutationVariables, TContext>(
      ['removeCompaniesFromClassification'],
      (variables?: RemoveCompaniesFromClassificationMutationVariables) => fetcher<RemoveCompaniesFromClassificationMutation, RemoveCompaniesFromClassificationMutationVariables>(client, RemoveCompaniesFromClassificationDocument, variables, headers)(),
      options
    );
useRemoveCompaniesFromClassificationMutation.getKey = () => ['removeCompaniesFromClassification'];

export const ManualShareholdingDetailsDocument = `
    query manualShareholdingDetails($input: FetchCompanyInput) {
  companies(input: $input) {
    shareholdingDetails
  }
}
    `;
export const useManualShareholdingDetailsQuery = <
      TData = ManualShareholdingDetailsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: ManualShareholdingDetailsQueryVariables,
      options?: UseQueryOptions<ManualShareholdingDetailsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ManualShareholdingDetailsQuery, TError, TData>(
      variables === undefined ? ['manualShareholdingDetails'] : ['manualShareholdingDetails', variables],
      fetcher<ManualShareholdingDetailsQuery, ManualShareholdingDetailsQueryVariables>(client, ManualShareholdingDetailsDocument, variables, headers),
      options
    );

useManualShareholdingDetailsQuery.getKey = (variables?: ManualShareholdingDetailsQueryVariables) => variables === undefined ? ['manualShareholdingDetails'] : ['manualShareholdingDetails', variables];
;

export const BeneficiariesDocument = `
    query beneficiaries {
  beneficiaries
}
    `;
export const useBeneficiariesQuery = <
      TData = BeneficiariesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: BeneficiariesQueryVariables,
      options?: UseQueryOptions<BeneficiariesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<BeneficiariesQuery, TError, TData>(
      variables === undefined ? ['beneficiaries'] : ['beneficiaries', variables],
      fetcher<BeneficiariesQuery, BeneficiariesQueryVariables>(client, BeneficiariesDocument, variables, headers),
      options
    );

useBeneficiariesQuery.getKey = (variables?: BeneficiariesQueryVariables) => variables === undefined ? ['beneficiaries'] : ['beneficiaries', variables];
;

export const AddExitManualInvestmentDocument = `
    mutation addExitManualInvestment($input: AddExitManualInvestment) {
  addExitManualInvestment(input: $input)
}
    `;
export const useAddExitManualInvestmentMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddExitManualInvestmentMutation, TError, AddExitManualInvestmentMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddExitManualInvestmentMutation, TError, AddExitManualInvestmentMutationVariables, TContext>(
      ['addExitManualInvestment'],
      (variables?: AddExitManualInvestmentMutationVariables) => fetcher<AddExitManualInvestmentMutation, AddExitManualInvestmentMutationVariables>(client, AddExitManualInvestmentDocument, variables, headers)(),
      options
    );
useAddExitManualInvestmentMutation.getKey = () => ['addExitManualInvestment'];

export const UpdateExitManualInvestmentDocument = `
    mutation updateExitManualInvestment($input: UpdateExitManualInvestment) {
  updateExitManualInvestment(input: $input)
}
    `;
export const useUpdateExitManualInvestmentMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateExitManualInvestmentMutation, TError, UpdateExitManualInvestmentMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateExitManualInvestmentMutation, TError, UpdateExitManualInvestmentMutationVariables, TContext>(
      ['updateExitManualInvestment'],
      (variables?: UpdateExitManualInvestmentMutationVariables) => fetcher<UpdateExitManualInvestmentMutation, UpdateExitManualInvestmentMutationVariables>(client, UpdateExitManualInvestmentDocument, variables, headers)(),
      options
    );
useUpdateExitManualInvestmentMutation.getKey = () => ['updateExitManualInvestment'];

export const DeleteExitManualInvestmentDocument = `
    mutation deleteExitManualInvestment($input: RemoveExitManualInvestment) {
  removeExitManualInvestment(input: $input)
}
    `;
export const useDeleteExitManualInvestmentMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteExitManualInvestmentMutation, TError, DeleteExitManualInvestmentMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteExitManualInvestmentMutation, TError, DeleteExitManualInvestmentMutationVariables, TContext>(
      ['deleteExitManualInvestment'],
      (variables?: DeleteExitManualInvestmentMutationVariables) => fetcher<DeleteExitManualInvestmentMutation, DeleteExitManualInvestmentMutationVariables>(client, DeleteExitManualInvestmentDocument, variables, headers)(),
      options
    );
useDeleteExitManualInvestmentMutation.getKey = () => ['deleteExitManualInvestment'];

export const RemoveBeneficiaryDocument = `
    mutation removeBeneficiary($input: RemoveInvestmentInput) {
  removeInvestment(input: $input)
}
    `;
export const useRemoveBeneficiaryMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RemoveBeneficiaryMutation, TError, RemoveBeneficiaryMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RemoveBeneficiaryMutation, TError, RemoveBeneficiaryMutationVariables, TContext>(
      ['removeBeneficiary'],
      (variables?: RemoveBeneficiaryMutationVariables) => fetcher<RemoveBeneficiaryMutation, RemoveBeneficiaryMutationVariables>(client, RemoveBeneficiaryDocument, variables, headers)(),
      options
    );
useRemoveBeneficiaryMutation.getKey = () => ['removeBeneficiary'];

export const EmailTermsheetDocument = `
    mutation emailTermsheet($input: EmailTermsheetInput) {
  emailTermsheet(input: $input)
}
    `;
export const useEmailTermsheetMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<EmailTermsheetMutation, TError, EmailTermsheetMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<EmailTermsheetMutation, TError, EmailTermsheetMutationVariables, TContext>(
      ['emailTermsheet'],
      (variables?: EmailTermsheetMutationVariables) => fetcher<EmailTermsheetMutation, EmailTermsheetMutationVariables>(client, EmailTermsheetDocument, variables, headers)(),
      options
    );
useEmailTermsheetMutation.getKey = () => ['emailTermsheet'];

export const AllInvestorsDocument = `
    query allInvestors($input: GetAllInvestorsInput) {
  getAllInvestors(input: $input)
}
    `;
export const useAllInvestorsQuery = <
      TData = AllInvestorsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: AllInvestorsQueryVariables,
      options?: UseQueryOptions<AllInvestorsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<AllInvestorsQuery, TError, TData>(
      variables === undefined ? ['allInvestors'] : ['allInvestors', variables],
      fetcher<AllInvestorsQuery, AllInvestorsQueryVariables>(client, AllInvestorsDocument, variables, headers),
      options
    );

useAllInvestorsQuery.getKey = (variables?: AllInvestorsQueryVariables) => variables === undefined ? ['allInvestors'] : ['allInvestors', variables];
;

export const AddUserToInvestorDocument = `
    mutation addUserToInvestor($input: AddAnotherUserToAccountInput) {
  addAnotherUserToAccount(input: $input)
}
    `;
export const useAddUserToInvestorMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddUserToInvestorMutation, TError, AddUserToInvestorMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddUserToInvestorMutation, TError, AddUserToInvestorMutationVariables, TContext>(
      ['addUserToInvestor'],
      (variables?: AddUserToInvestorMutationVariables) => fetcher<AddUserToInvestorMutation, AddUserToInvestorMutationVariables>(client, AddUserToInvestorDocument, variables, headers)(),
      options
    );
useAddUserToInvestorMutation.getKey = () => ['addUserToInvestor'];

export const AddAccountToUserDocument = `
    mutation addAccountToUser($input: AddAccountInput) {
  addAccountToUser(input: $input)
}
    `;
export const useAddAccountToUserMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddAccountToUserMutation, TError, AddAccountToUserMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddAccountToUserMutation, TError, AddAccountToUserMutationVariables, TContext>(
      ['addAccountToUser'],
      (variables?: AddAccountToUserMutationVariables) => fetcher<AddAccountToUserMutation, AddAccountToUserMutationVariables>(client, AddAccountToUserDocument, variables, headers)(),
      options
    );
useAddAccountToUserMutation.getKey = () => ['addAccountToUser'];

export const AllAccountOfUserDocument = `
    query AllAccountOfUser {
  getAllAccountOfUser
}
    `;
export const useAllAccountOfUserQuery = <
      TData = AllAccountOfUserQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: AllAccountOfUserQueryVariables,
      options?: UseQueryOptions<AllAccountOfUserQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<AllAccountOfUserQuery, TError, TData>(
      variables === undefined ? ['AllAccountOfUser'] : ['AllAccountOfUser', variables],
      fetcher<AllAccountOfUserQuery, AllAccountOfUserQueryVariables>(client, AllAccountOfUserDocument, variables, headers),
      options
    );

useAllAccountOfUserQuery.getKey = (variables?: AllAccountOfUserQueryVariables) => variables === undefined ? ['AllAccountOfUser'] : ['AllAccountOfUser', variables];
;

export const AddInvestorDocument = `
    mutation AddInvestor($input: AddInvestorInput!) {
  addInvestor(input: $input)
}
    `;
export const useAddInvestorMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddInvestorMutation, TError, AddInvestorMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddInvestorMutation, TError, AddInvestorMutationVariables, TContext>(
      ['AddInvestor'],
      (variables?: AddInvestorMutationVariables) => fetcher<AddInvestorMutation, AddInvestorMutationVariables>(client, AddInvestorDocument, variables, headers)(),
      options
    );
useAddInvestorMutation.getKey = () => ['AddInvestor'];

export const AddIndirectInvestmentDocument = `
    mutation addIndirectInvestment($input: AddIndirectInvestmentInput) {
  addIndirectInvestment(input: $input)
}
    `;
export const useAddIndirectInvestmentMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddIndirectInvestmentMutation, TError, AddIndirectInvestmentMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddIndirectInvestmentMutation, TError, AddIndirectInvestmentMutationVariables, TContext>(
      ['addIndirectInvestment'],
      (variables?: AddIndirectInvestmentMutationVariables) => fetcher<AddIndirectInvestmentMutation, AddIndirectInvestmentMutationVariables>(client, AddIndirectInvestmentDocument, variables, headers)(),
      options
    );
useAddIndirectInvestmentMutation.getKey = () => ['addIndirectInvestment'];

export const GetIndirectCompaniesDocument = `
    query getIndirectCompanies($input: FetchCompanyInput) {
  indirectCompanies(input: $input)
}
    `;
export const useGetIndirectCompaniesQuery = <
      TData = GetIndirectCompaniesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetIndirectCompaniesQueryVariables,
      options?: UseQueryOptions<GetIndirectCompaniesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetIndirectCompaniesQuery, TError, TData>(
      variables === undefined ? ['getIndirectCompanies'] : ['getIndirectCompanies', variables],
      fetcher<GetIndirectCompaniesQuery, GetIndirectCompaniesQueryVariables>(client, GetIndirectCompaniesDocument, variables, headers),
      options
    );

useGetIndirectCompaniesQuery.getKey = (variables?: GetIndirectCompaniesQueryVariables) => variables === undefined ? ['getIndirectCompanies'] : ['getIndirectCompanies', variables];
;

export const DeleteIndirectInvestmentDocument = `
    mutation deleteIndirectInvestment($input: RemoveIndirectInvestmentInput) {
  deleteIndirectInvestment(input: $input)
}
    `;
export const useDeleteIndirectInvestmentMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteIndirectInvestmentMutation, TError, DeleteIndirectInvestmentMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteIndirectInvestmentMutation, TError, DeleteIndirectInvestmentMutationVariables, TContext>(
      ['deleteIndirectInvestment'],
      (variables?: DeleteIndirectInvestmentMutationVariables) => fetcher<DeleteIndirectInvestmentMutation, DeleteIndirectInvestmentMutationVariables>(client, DeleteIndirectInvestmentDocument, variables, headers)(),
      options
    );
useDeleteIndirectInvestmentMutation.getKey = () => ['deleteIndirectInvestment'];

export const EditIndirectInvestmentDocument = `
    mutation editIndirectInvestment($input: EditIndirectInvestmentInput) {
  editIndirectInvestment(input: $input)
}
    `;
export const useEditIndirectInvestmentMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<EditIndirectInvestmentMutation, TError, EditIndirectInvestmentMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<EditIndirectInvestmentMutation, TError, EditIndirectInvestmentMutationVariables, TContext>(
      ['editIndirectInvestment'],
      (variables?: EditIndirectInvestmentMutationVariables) => fetcher<EditIndirectInvestmentMutation, EditIndirectInvestmentMutationVariables>(client, EditIndirectInvestmentDocument, variables, headers)(),
      options
    );
useEditIndirectInvestmentMutation.getKey = () => ['editIndirectInvestment'];

export const EditIndirectCompanyDetailsDocument = `
    mutation editIndirectCompanyDetails($input: EditIndirectCompanyDetailsInput) {
  editIndirectCompanyDetails(input: $input)
}
    `;
export const useEditIndirectCompanyDetailsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<EditIndirectCompanyDetailsMutation, TError, EditIndirectCompanyDetailsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<EditIndirectCompanyDetailsMutation, TError, EditIndirectCompanyDetailsMutationVariables, TContext>(
      ['editIndirectCompanyDetails'],
      (variables?: EditIndirectCompanyDetailsMutationVariables) => fetcher<EditIndirectCompanyDetailsMutation, EditIndirectCompanyDetailsMutationVariables>(client, EditIndirectCompanyDetailsDocument, variables, headers)(),
      options
    );
useEditIndirectCompanyDetailsMutation.getKey = () => ['editIndirectCompanyDetails'];

export const GetAllInvestorComapniesDocument = `
    query getAllInvestorComapnies($input: FetchAllCompaniesInput) {
  allInvestorCompanies(input: $input)
}
    `;
export const useGetAllInvestorComapniesQuery = <
      TData = GetAllInvestorComapniesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetAllInvestorComapniesQueryVariables,
      options?: UseQueryOptions<GetAllInvestorComapniesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetAllInvestorComapniesQuery, TError, TData>(
      variables === undefined ? ['getAllInvestorComapnies'] : ['getAllInvestorComapnies', variables],
      fetcher<GetAllInvestorComapniesQuery, GetAllInvestorComapniesQueryVariables>(client, GetAllInvestorComapniesDocument, variables, headers),
      options
    );

useGetAllInvestorComapniesQuery.getKey = (variables?: GetAllInvestorComapniesQueryVariables) => variables === undefined ? ['getAllInvestorComapnies'] : ['getAllInvestorComapnies', variables];
;

export const EditFmvDocument = `
    mutation editFMV($input: EditFmvInput) {
  editFMV(input: $input)
}
    `;
export const useEditFmvMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<EditFmvMutation, TError, EditFmvMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<EditFmvMutation, TError, EditFmvMutationVariables, TContext>(
      ['editFMV'],
      (variables?: EditFmvMutationVariables) => fetcher<EditFmvMutation, EditFmvMutationVariables>(client, EditFmvDocument, variables, headers)(),
      options
    );
useEditFmvMutation.getKey = () => ['editFMV'];

export const GetEeMetricsDocument = `
    query getEEMetrics {
  eeMetrics
}
    `;
export const useGetEeMetricsQuery = <
      TData = GetEeMetricsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetEeMetricsQueryVariables,
      options?: UseQueryOptions<GetEeMetricsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetEeMetricsQuery, TError, TData>(
      variables === undefined ? ['getEEMetrics'] : ['getEEMetrics', variables],
      fetcher<GetEeMetricsQuery, GetEeMetricsQueryVariables>(client, GetEeMetricsDocument, variables, headers),
      options
    );

useGetEeMetricsQuery.getKey = (variables?: GetEeMetricsQueryVariables) => variables === undefined ? ['getEEMetrics'] : ['getEEMetrics', variables];
;

export const AddEeMetricDocument = `
    mutation addEEMetric($input: AddEEMetricInput) {
  addEEMetric(input: $input)
}
    `;
export const useAddEeMetricMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddEeMetricMutation, TError, AddEeMetricMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddEeMetricMutation, TError, AddEeMetricMutationVariables, TContext>(
      ['addEEMetric'],
      (variables?: AddEeMetricMutationVariables) => fetcher<AddEeMetricMutation, AddEeMetricMutationVariables>(client, AddEeMetricDocument, variables, headers)(),
      options
    );
useAddEeMetricMutation.getKey = () => ['addEEMetric'];

export const EditEeMetricDocument = `
    mutation editEEMetric($input: EditEEMetricInput) {
  editEEMetric(input: $input)
}
    `;
export const useEditEeMetricMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<EditEeMetricMutation, TError, EditEeMetricMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<EditEeMetricMutation, TError, EditEeMetricMutationVariables, TContext>(
      ['editEEMetric'],
      (variables?: EditEeMetricMutationVariables) => fetcher<EditEeMetricMutation, EditEeMetricMutationVariables>(client, EditEeMetricDocument, variables, headers)(),
      options
    );
useEditEeMetricMutation.getKey = () => ['editEEMetric'];

export const RemoveEeMetricDocument = `
    mutation removeEEMetric($input: RemoveEEMetricInput) {
  removeEEMetric(input: $input)
}
    `;
export const useRemoveEeMetricMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RemoveEeMetricMutation, TError, RemoveEeMetricMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RemoveEeMetricMutation, TError, RemoveEeMetricMutationVariables, TContext>(
      ['removeEEMetric'],
      (variables?: RemoveEeMetricMutationVariables) => fetcher<RemoveEeMetricMutation, RemoveEeMetricMutationVariables>(client, RemoveEeMetricDocument, variables, headers)(),
      options
    );
useRemoveEeMetricMutation.getKey = () => ['removeEEMetric'];

export const GetEeCompanyMetricsDocument = `
    query getEECompanyMetrics {
  eeCompanyMetrics
}
    `;
export const useGetEeCompanyMetricsQuery = <
      TData = GetEeCompanyMetricsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetEeCompanyMetricsQueryVariables,
      options?: UseQueryOptions<GetEeCompanyMetricsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetEeCompanyMetricsQuery, TError, TData>(
      variables === undefined ? ['getEECompanyMetrics'] : ['getEECompanyMetrics', variables],
      fetcher<GetEeCompanyMetricsQuery, GetEeCompanyMetricsQueryVariables>(client, GetEeCompanyMetricsDocument, variables, headers),
      options
    );

useGetEeCompanyMetricsQuery.getKey = (variables?: GetEeCompanyMetricsQueryVariables) => variables === undefined ? ['getEECompanyMetrics'] : ['getEECompanyMetrics', variables];
;

export const AddEeCompanyMetricDocument = `
    mutation addEECompanyMetric($input: AddEECompanyMetricInput) {
  addEECompanyMetric(input: $input)
}
    `;
export const useAddEeCompanyMetricMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddEeCompanyMetricMutation, TError, AddEeCompanyMetricMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddEeCompanyMetricMutation, TError, AddEeCompanyMetricMutationVariables, TContext>(
      ['addEECompanyMetric'],
      (variables?: AddEeCompanyMetricMutationVariables) => fetcher<AddEeCompanyMetricMutation, AddEeCompanyMetricMutationVariables>(client, AddEeCompanyMetricDocument, variables, headers)(),
      options
    );
useAddEeCompanyMetricMutation.getKey = () => ['addEECompanyMetric'];

export const EditEeCompanyMetricDocument = `
    mutation editEECompanyMetric($input: EditEECompanyMetricInput) {
  editEECompanyMetric(input: $input)
}
    `;
export const useEditEeCompanyMetricMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<EditEeCompanyMetricMutation, TError, EditEeCompanyMetricMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<EditEeCompanyMetricMutation, TError, EditEeCompanyMetricMutationVariables, TContext>(
      ['editEECompanyMetric'],
      (variables?: EditEeCompanyMetricMutationVariables) => fetcher<EditEeCompanyMetricMutation, EditEeCompanyMetricMutationVariables>(client, EditEeCompanyMetricDocument, variables, headers)(),
      options
    );
useEditEeCompanyMetricMutation.getKey = () => ['editEECompanyMetric'];

export const RemoveEeCompanyMetricDocument = `
    mutation removeEECompanyMetric($input: RemoveEECompanyMetricInput) {
  removeEECompanyMetric(input: $input)
}
    `;
export const useRemoveEeCompanyMetricMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RemoveEeCompanyMetricMutation, TError, RemoveEeCompanyMetricMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RemoveEeCompanyMetricMutation, TError, RemoveEeCompanyMetricMutationVariables, TContext>(
      ['removeEECompanyMetric'],
      (variables?: RemoveEeCompanyMetricMutationVariables) => fetcher<RemoveEeCompanyMetricMutation, RemoveEeCompanyMetricMutationVariables>(client, RemoveEeCompanyMetricDocument, variables, headers)(),
      options
    );
useRemoveEeCompanyMetricMutation.getKey = () => ['removeEECompanyMetric'];

export const GetEeFiltersDocument = `
    query getEEFilters {
  eeFilters
}
    `;
export const useGetEeFiltersQuery = <
      TData = GetEeFiltersQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetEeFiltersQueryVariables,
      options?: UseQueryOptions<GetEeFiltersQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetEeFiltersQuery, TError, TData>(
      variables === undefined ? ['getEEFilters'] : ['getEEFilters', variables],
      fetcher<GetEeFiltersQuery, GetEeFiltersQueryVariables>(client, GetEeFiltersDocument, variables, headers),
      options
    );

useGetEeFiltersQuery.getKey = (variables?: GetEeFiltersQueryVariables) => variables === undefined ? ['getEEFilters'] : ['getEEFilters', variables];
;

export const AddEeFilterDocument = `
    mutation addEEFilter($input: AddEEFilterInput) {
  addEEFilter(input: $input)
}
    `;
export const useAddEeFilterMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddEeFilterMutation, TError, AddEeFilterMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddEeFilterMutation, TError, AddEeFilterMutationVariables, TContext>(
      ['addEEFilter'],
      (variables?: AddEeFilterMutationVariables) => fetcher<AddEeFilterMutation, AddEeFilterMutationVariables>(client, AddEeFilterDocument, variables, headers)(),
      options
    );
useAddEeFilterMutation.getKey = () => ['addEEFilter'];

export const EditEeFilterDocument = `
    mutation editEEFilter($input: EditEEFilterInput) {
  editEEFilter(input: $input)
}
    `;
export const useEditEeFilterMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<EditEeFilterMutation, TError, EditEeFilterMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<EditEeFilterMutation, TError, EditEeFilterMutationVariables, TContext>(
      ['editEEFilter'],
      (variables?: EditEeFilterMutationVariables) => fetcher<EditEeFilterMutation, EditEeFilterMutationVariables>(client, EditEeFilterDocument, variables, headers)(),
      options
    );
useEditEeFilterMutation.getKey = () => ['editEEFilter'];

export const RemoveEeFilterDocument = `
    mutation removeEEFilter($input: RemoveEEFilterInput) {
  removeEEFilter(input: $input)
}
    `;
export const useRemoveEeFilterMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RemoveEeFilterMutation, TError, RemoveEeFilterMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RemoveEeFilterMutation, TError, RemoveEeFilterMutationVariables, TContext>(
      ['removeEEFilter'],
      (variables?: RemoveEeFilterMutationVariables) => fetcher<RemoveEeFilterMutation, RemoveEeFilterMutationVariables>(client, RemoveEeFilterDocument, variables, headers)(),
      options
    );
useRemoveEeFilterMutation.getKey = () => ['removeEEFilter'];

export const GetEeThemesDocument = `
    query getEEThemes {
  eeThemes
}
    `;
export const useGetEeThemesQuery = <
      TData = GetEeThemesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetEeThemesQueryVariables,
      options?: UseQueryOptions<GetEeThemesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetEeThemesQuery, TError, TData>(
      variables === undefined ? ['getEEThemes'] : ['getEEThemes', variables],
      fetcher<GetEeThemesQuery, GetEeThemesQueryVariables>(client, GetEeThemesDocument, variables, headers),
      options
    );

useGetEeThemesQuery.getKey = (variables?: GetEeThemesQueryVariables) => variables === undefined ? ['getEEThemes'] : ['getEEThemes', variables];
;

export const AddEeThemeDocument = `
    mutation addEETheme($input: AddEEThemeInput) {
  addEETheme(input: $input)
}
    `;
export const useAddEeThemeMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddEeThemeMutation, TError, AddEeThemeMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddEeThemeMutation, TError, AddEeThemeMutationVariables, TContext>(
      ['addEETheme'],
      (variables?: AddEeThemeMutationVariables) => fetcher<AddEeThemeMutation, AddEeThemeMutationVariables>(client, AddEeThemeDocument, variables, headers)(),
      options
    );
useAddEeThemeMutation.getKey = () => ['addEETheme'];

export const EditEeThemeDocument = `
    mutation editEETheme($input: EditEEThemeInput) {
  editEETheme(input: $input)
}
    `;
export const useEditEeThemeMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<EditEeThemeMutation, TError, EditEeThemeMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<EditEeThemeMutation, TError, EditEeThemeMutationVariables, TContext>(
      ['editEETheme'],
      (variables?: EditEeThemeMutationVariables) => fetcher<EditEeThemeMutation, EditEeThemeMutationVariables>(client, EditEeThemeDocument, variables, headers)(),
      options
    );
useEditEeThemeMutation.getKey = () => ['editEETheme'];

export const RemoveEeThemeDocument = `
    mutation removeEETheme($input: RemoveEEThemeInput) {
  removeEETheme(input: $input)
}
    `;
export const useRemoveEeThemeMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RemoveEeThemeMutation, TError, RemoveEeThemeMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RemoveEeThemeMutation, TError, RemoveEeThemeMutationVariables, TContext>(
      ['removeEETheme'],
      (variables?: RemoveEeThemeMutationVariables) => fetcher<RemoveEeThemeMutation, RemoveEeThemeMutationVariables>(client, RemoveEeThemeDocument, variables, headers)(),
      options
    );
useRemoveEeThemeMutation.getKey = () => ['removeEETheme'];

export const RemoveEeThemeFilterDocument = `
    mutation removeEEThemeFilter($input: RemoveEEThemeFilterInput) {
  removeEEThemeFilter(input: $input)
}
    `;
export const useRemoveEeThemeFilterMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RemoveEeThemeFilterMutation, TError, RemoveEeThemeFilterMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RemoveEeThemeFilterMutation, TError, RemoveEeThemeFilterMutationVariables, TContext>(
      ['removeEEThemeFilter'],
      (variables?: RemoveEeThemeFilterMutationVariables) => fetcher<RemoveEeThemeFilterMutation, RemoveEeThemeFilterMutationVariables>(client, RemoveEeThemeFilterDocument, variables, headers)(),
      options
    );
useRemoveEeThemeFilterMutation.getKey = () => ['removeEEThemeFilter'];

export const GetEeInvestsDocument = `
    query getEEInvests {
  eeInvests
}
    `;
export const useGetEeInvestsQuery = <
      TData = GetEeInvestsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetEeInvestsQueryVariables,
      options?: UseQueryOptions<GetEeInvestsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetEeInvestsQuery, TError, TData>(
      variables === undefined ? ['getEEInvests'] : ['getEEInvests', variables],
      fetcher<GetEeInvestsQuery, GetEeInvestsQueryVariables>(client, GetEeInvestsDocument, variables, headers),
      options
    );

useGetEeInvestsQuery.getKey = (variables?: GetEeInvestsQueryVariables) => variables === undefined ? ['getEEInvests'] : ['getEEInvests', variables];
;

export const GetEePortfoliosDocument = `
    query getEEPortfolios {
  eePortfolios
}
    `;
export const useGetEePortfoliosQuery = <
      TData = GetEePortfoliosQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetEePortfoliosQueryVariables,
      options?: UseQueryOptions<GetEePortfoliosQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetEePortfoliosQuery, TError, TData>(
      variables === undefined ? ['getEEPortfolios'] : ['getEEPortfolios', variables],
      fetcher<GetEePortfoliosQuery, GetEePortfoliosQueryVariables>(client, GetEePortfoliosDocument, variables, headers),
      options
    );

useGetEePortfoliosQuery.getKey = (variables?: GetEePortfoliosQueryVariables) => variables === undefined ? ['getEEPortfolios'] : ['getEEPortfolios', variables];
;

export const AddEePortfolioDocument = `
    mutation addEEPortfolio($input: AddEEPortfolioInput) {
  addEEPortfolio(input: $input)
}
    `;
export const useAddEePortfolioMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddEePortfolioMutation, TError, AddEePortfolioMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddEePortfolioMutation, TError, AddEePortfolioMutationVariables, TContext>(
      ['addEEPortfolio'],
      (variables?: AddEePortfolioMutationVariables) => fetcher<AddEePortfolioMutation, AddEePortfolioMutationVariables>(client, AddEePortfolioDocument, variables, headers)(),
      options
    );
useAddEePortfolioMutation.getKey = () => ['addEEPortfolio'];

export const EditEePortfolioDocument = `
    mutation editEEPortfolio($input: EditEEPortfolioInput) {
  editEEPortfolio(input: $input)
}
    `;
export const useEditEePortfolioMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<EditEePortfolioMutation, TError, EditEePortfolioMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<EditEePortfolioMutation, TError, EditEePortfolioMutationVariables, TContext>(
      ['editEEPortfolio'],
      (variables?: EditEePortfolioMutationVariables) => fetcher<EditEePortfolioMutation, EditEePortfolioMutationVariables>(client, EditEePortfolioDocument, variables, headers)(),
      options
    );
useEditEePortfolioMutation.getKey = () => ['editEEPortfolio'];

export const RemoveEePortfolioDocument = `
    mutation removeEEPortfolio($input: RemoveEEPortfolioInput) {
  removeEEPortfolio(input: $input)
}
    `;
export const useRemoveEePortfolioMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RemoveEePortfolioMutation, TError, RemoveEePortfolioMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RemoveEePortfolioMutation, TError, RemoveEePortfolioMutationVariables, TContext>(
      ['removeEEPortfolio'],
      (variables?: RemoveEePortfolioMutationVariables) => fetcher<RemoveEePortfolioMutation, RemoveEePortfolioMutationVariables>(client, RemoveEePortfolioDocument, variables, headers)(),
      options
    );
useRemoveEePortfolioMutation.getKey = () => ['removeEEPortfolio'];

export const AddTagsToInvestmentDocument = `
    mutation addTagsToInvestment($input: AddTagsToInvestmentInput) {
  addTagsToInvestment(input: $input)
}
    `;
export const useAddTagsToInvestmentMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddTagsToInvestmentMutation, TError, AddTagsToInvestmentMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddTagsToInvestmentMutation, TError, AddTagsToInvestmentMutationVariables, TContext>(
      ['addTagsToInvestment'],
      (variables?: AddTagsToInvestmentMutationVariables) => fetcher<AddTagsToInvestmentMutation, AddTagsToInvestmentMutationVariables>(client, AddTagsToInvestmentDocument, variables, headers)(),
      options
    );
useAddTagsToInvestmentMutation.getKey = () => ['addTagsToInvestment'];

export const EditTransactionDocument = `
    mutation editTransaction($input: EditTransactionInput) {
  editTransaction(input: $input)
}
    `;
export const useEditTransactionMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<EditTransactionMutation, TError, EditTransactionMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<EditTransactionMutation, TError, EditTransactionMutationVariables, TContext>(
      ['editTransaction'],
      (variables?: EditTransactionMutationVariables) => fetcher<EditTransactionMutation, EditTransactionMutationVariables>(client, EditTransactionDocument, variables, headers)(),
      options
    );
useEditTransactionMutation.getKey = () => ['editTransaction'];

export const AddValuationDetailsDocument = `
    mutation addValuationDetails($input: AddValuationDetailsInput) {
  addValuationDetails(input: $input)
}
    `;
export const useAddValuationDetailsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddValuationDetailsMutation, TError, AddValuationDetailsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddValuationDetailsMutation, TError, AddValuationDetailsMutationVariables, TContext>(
      ['addValuationDetails'],
      (variables?: AddValuationDetailsMutationVariables) => fetcher<AddValuationDetailsMutation, AddValuationDetailsMutationVariables>(client, AddValuationDetailsDocument, variables, headers)(),
      options
    );
useAddValuationDetailsMutation.getKey = () => ['addValuationDetails'];

export const GetAllValuationOfCompanyDocument = `
    query getAllValuationOfCompany($input: ValuationDetailsInput) {
  getAllValuationOfCompany(input: $input)
}
    `;
export const useGetAllValuationOfCompanyQuery = <
      TData = GetAllValuationOfCompanyQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetAllValuationOfCompanyQueryVariables,
      options?: UseQueryOptions<GetAllValuationOfCompanyQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetAllValuationOfCompanyQuery, TError, TData>(
      variables === undefined ? ['getAllValuationOfCompany'] : ['getAllValuationOfCompany', variables],
      fetcher<GetAllValuationOfCompanyQuery, GetAllValuationOfCompanyQueryVariables>(client, GetAllValuationOfCompanyDocument, variables, headers),
      options
    );

useGetAllValuationOfCompanyQuery.getKey = (variables?: GetAllValuationOfCompanyQueryVariables) => variables === undefined ? ['getAllValuationOfCompany'] : ['getAllValuationOfCompany', variables];
;

export const EditValuationDetailsDocument = `
    mutation editValuationDetails($input: EditValuationDetailsInput) {
  editValuationDetails(input: $input)
}
    `;
export const useEditValuationDetailsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<EditValuationDetailsMutation, TError, EditValuationDetailsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<EditValuationDetailsMutation, TError, EditValuationDetailsMutationVariables, TContext>(
      ['editValuationDetails'],
      (variables?: EditValuationDetailsMutationVariables) => fetcher<EditValuationDetailsMutation, EditValuationDetailsMutationVariables>(client, EditValuationDetailsDocument, variables, headers)(),
      options
    );
useEditValuationDetailsMutation.getKey = () => ['editValuationDetails'];

export const DeleteValuationDetailsDocument = `
    mutation deleteValuationDetails($input: DeleteValuationDetailsInput) {
  deleteValuationDetails(input: $input)
}
    `;
export const useDeleteValuationDetailsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteValuationDetailsMutation, TError, DeleteValuationDetailsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteValuationDetailsMutation, TError, DeleteValuationDetailsMutationVariables, TContext>(
      ['deleteValuationDetails'],
      (variables?: DeleteValuationDetailsMutationVariables) => fetcher<DeleteValuationDetailsMutation, DeleteValuationDetailsMutationVariables>(client, DeleteValuationDetailsDocument, variables, headers)(),
      options
    );
useDeleteValuationDetailsMutation.getKey = () => ['deleteValuationDetails'];

export const UploadType2CaptableDocument = `
    mutation uploadType2Captable($up: Upload) {
  uploadCompanyOverview(input: {filename: $up})
}
    `;
export const useUploadType2CaptableMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UploadType2CaptableMutation, TError, UploadType2CaptableMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UploadType2CaptableMutation, TError, UploadType2CaptableMutationVariables, TContext>(
      ['uploadType2Captable'],
      (variables?: UploadType2CaptableMutationVariables) => fetcher<UploadType2CaptableMutation, UploadType2CaptableMutationVariables>(client, UploadType2CaptableDocument, variables, headers)(),
      options
    );
useUploadType2CaptableMutation.getKey = () => ['uploadType2Captable'];

export const UploadType3CaptableDocument = `
    mutation uploadType3Captable($up: Upload) {
  uploadCompanyCaptable(input: {filename: $up})
}
    `;
export const useUploadType3CaptableMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UploadType3CaptableMutation, TError, UploadType3CaptableMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UploadType3CaptableMutation, TError, UploadType3CaptableMutationVariables, TContext>(
      ['uploadType3Captable'],
      (variables?: UploadType3CaptableMutationVariables) => fetcher<UploadType3CaptableMutation, UploadType3CaptableMutationVariables>(client, UploadType3CaptableDocument, variables, headers)(),
      options
    );
useUploadType3CaptableMutation.getKey = () => ['uploadType3Captable'];

export const SetDefaultValuationDocument = `
    mutation setDefaultValuation($input: SetDefaultValuationInput) {
  setDefaultValuation(input: $input)
}
    `;
export const useSetDefaultValuationMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SetDefaultValuationMutation, TError, SetDefaultValuationMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SetDefaultValuationMutation, TError, SetDefaultValuationMutationVariables, TContext>(
      ['setDefaultValuation'],
      (variables?: SetDefaultValuationMutationVariables) => fetcher<SetDefaultValuationMutation, SetDefaultValuationMutationVariables>(client, SetDefaultValuationDocument, variables, headers)(),
      options
    );
useSetDefaultValuationMutation.getKey = () => ['setDefaultValuation'];

export const GetTemplateDocumentDocument = `
    query getTemplateDocument($input: TemplateInput) {
  getTermsheetTemplate(input: $input)
}
    `;
export const useGetTemplateDocumentQuery = <
      TData = GetTemplateDocumentQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetTemplateDocumentQueryVariables,
      options?: UseQueryOptions<GetTemplateDocumentQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetTemplateDocumentQuery, TError, TData>(
      variables === undefined ? ['getTemplateDocument'] : ['getTemplateDocument', variables],
      fetcher<GetTemplateDocumentQuery, GetTemplateDocumentQueryVariables>(client, GetTemplateDocumentDocument, variables, headers),
      options
    );

useGetTemplateDocumentQuery.getKey = (variables?: GetTemplateDocumentQueryVariables) => variables === undefined ? ['getTemplateDocument'] : ['getTemplateDocument', variables];
;

export const EditTemplateDocumentDocument = `
    mutation editTemplateDocument($input: EditTermsheetTemplate) {
  editTermsheetTemplate(input: $input)
}
    `;
export const useEditTemplateDocumentMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<EditTemplateDocumentMutation, TError, EditTemplateDocumentMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<EditTemplateDocumentMutation, TError, EditTemplateDocumentMutationVariables, TContext>(
      ['editTemplateDocument'],
      (variables?: EditTemplateDocumentMutationVariables) => fetcher<EditTemplateDocumentMutation, EditTemplateDocumentMutationVariables>(client, EditTemplateDocumentDocument, variables, headers)(),
      options
    );
useEditTemplateDocumentMutation.getKey = () => ['editTemplateDocument'];

export const GetS3UrlForTermsheetDocument = `
    query getS3UrlForTermsheet($input: FetchUrlPathInput) {
  getTermsheetUrlPath(input: $input) {
    urlPath
    presignedUrl
    presignedDocUrl
    docUrlPath
  }
}
    `;
export const useGetS3UrlForTermsheetQuery = <
      TData = GetS3UrlForTermsheetQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetS3UrlForTermsheetQueryVariables,
      options?: UseQueryOptions<GetS3UrlForTermsheetQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetS3UrlForTermsheetQuery, TError, TData>(
      variables === undefined ? ['getS3UrlForTermsheet'] : ['getS3UrlForTermsheet', variables],
      fetcher<GetS3UrlForTermsheetQuery, GetS3UrlForTermsheetQueryVariables>(client, GetS3UrlForTermsheetDocument, variables, headers),
      options
    );

useGetS3UrlForTermsheetQuery.getKey = (variables?: GetS3UrlForTermsheetQueryVariables) => variables === undefined ? ['getS3UrlForTermsheet'] : ['getS3UrlForTermsheet', variables];
;

export const InsertSignatureDocument = `
    mutation insertSignature($input: AddSignatureInput) {
  addSignature(input: $input)
}
    `;
export const useInsertSignatureMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<InsertSignatureMutation, TError, InsertSignatureMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<InsertSignatureMutation, TError, InsertSignatureMutationVariables, TContext>(
      ['insertSignature'],
      (variables?: InsertSignatureMutationVariables) => fetcher<InsertSignatureMutation, InsertSignatureMutationVariables>(client, InsertSignatureDocument, variables, headers)(),
      options
    );
useInsertSignatureMutation.getKey = () => ['insertSignature'];

export const DocxToPdfDocument = `
    mutation docxToPdf($input: DocxToPdfInput) {
  docxToPdfConverter(input: $input)
}
    `;
export const useDocxToPdfMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DocxToPdfMutation, TError, DocxToPdfMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DocxToPdfMutation, TError, DocxToPdfMutationVariables, TContext>(
      ['docxToPdf'],
      (variables?: DocxToPdfMutationVariables) => fetcher<DocxToPdfMutation, DocxToPdfMutationVariables>(client, DocxToPdfDocument, variables, headers)(),
      options
    );
useDocxToPdfMutation.getKey = () => ['docxToPdf'];

export const AddMultipleInvestorsToUserDocument = `
    mutation addMultipleInvestorsToUser($input: AddUserToMultipleInvestorsInput) {
  addUserToMultipleInvestors(input: $input)
}
    `;
export const useAddMultipleInvestorsToUserMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddMultipleInvestorsToUserMutation, TError, AddMultipleInvestorsToUserMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddMultipleInvestorsToUserMutation, TError, AddMultipleInvestorsToUserMutationVariables, TContext>(
      ['addMultipleInvestorsToUser'],
      (variables?: AddMultipleInvestorsToUserMutationVariables) => fetcher<AddMultipleInvestorsToUserMutation, AddMultipleInvestorsToUserMutationVariables>(client, AddMultipleInvestorsToUserDocument, variables, headers)(),
      options
    );
useAddMultipleInvestorsToUserMutation.getKey = () => ['addMultipleInvestorsToUser'];

export const GetAllTransactionsDocument = `
    query getAllTransactions {
  allTransactions {
    companyData {
      type
      id
      hissaCompanyId
      name
      cin
      companyCurrency
      totalFunding
      sharePrice
      valuation
      totalFdbShares
      latestRaise
      latestRaiseDate
      noOfRounds
      industry
      logo
      dba
      isPrivate
      companyStage
      founderHoldingPercentage
      latestRound
      incorporationDate
      jurisdiction
      revenue
      cashBalance
      valuationInCompanyCurrency
      esopHolding
      tags
      businessDescription
      corporateOfficeAddress
      equityPaidUpCapital
      preferencePaidUpCapital
      equityAuthorizedCapital
      preferenceAuthorizedCapital
      directorDetails
      companyMetadata {
        key
        value
      }
    }
    transactionData {
      hissTransactionId
      id
      companyType
      investorName
      investorId
      transactionType
      round
      noOfShares
      sharePrice
      roundIdentifier
      amount
      transactionDate
      currency
      exchangeRate
      companySharePrice
      investorsData {
        name
        exited
        fdbShares
        fdbHoldingPercentage
        currentValue
      }
      transactionFdbShares
      securitySubType
      notes
      metadata
    }
    investorData {
      id
      name
      exited
      fdbShares
      fdbHoldingPercentage
      currentValue
    }
    indirectTransactionData {
      id
      investorId
      investorName
      hissTransactionId
      unitType
      documents {
        id
        name
        key
        tags
        size
        isTransaction
        investmentId
        indirectInvestmentId
      }
      transactionDate
      noOfUnits
      currentNav
      transactionAmount
      drawDown
      setupFee
      indirectVehicleID
      indirectVehicleName
      currentNavDate
      transactionNav
      currentValue
      notes
      metadata
      transactionCurrency
      exchangeRate
    }
    roundData {
      id
      name
      postMoneyValuation
      roundSize
      roundDate
    }
  }
}
    `;
export const useGetAllTransactionsQuery = <
      TData = GetAllTransactionsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetAllTransactionsQueryVariables,
      options?: UseQueryOptions<GetAllTransactionsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetAllTransactionsQuery, TError, TData>(
      variables === undefined ? ['getAllTransactions'] : ['getAllTransactions', variables],
      fetcher<GetAllTransactionsQuery, GetAllTransactionsQueryVariables>(client, GetAllTransactionsDocument, variables, headers),
      options
    );

useGetAllTransactionsQuery.getKey = (variables?: GetAllTransactionsQueryVariables) => variables === undefined ? ['getAllTransactions'] : ['getAllTransactions', variables];
;

export const GetCompanyWiseDataDocument = `
    query getCompanyWiseData($input: CompanyDataInput) {
  getCompanyData(input: $input) {
    companyData {
      type
      id
      hissaCompanyId
      name
      cin
      companyCurrency
      totalFunding
      sharePrice
      valuation
      totalFdbShares
      valuationInCompanyCurrency
      latestRaise
      latestRaiseDate
      noOfRounds
      industry
      logo
      dba
      isPrivate
      companyStage
      founderHoldingPercentage
      latestRound
      incorporationDate
      jurisdiction
      revenue
      cashBalance
      esopHolding
      tags
      businessDescription
      corporateOfficeAddress
      directorDetails
      companyMetadata {
        key
        value
      }
      liquidationPreference {
        securityClassId
        securityType
        securityClassName
        rank
        investmentMultiple
        investment
        lpValue
        isParriPassu
        isParticipation
        participationCap
      }
      taskManagerProjects {
        id
        name
        description
        startDate
        endDate
        companyId
        companyName
      }
      equityPaidUpCapital
      preferencePaidUpCapital
      equityAuthorizedCapital
      preferenceAuthorizedCapital
      shareholders {
        name
        investedAmount
        percentage
        noOfShares
        type
        companyInvestorId
        shareCertificates {
          certificateId
          certificateUrl
          certificateName
          securityType
          securityClass
          round
          numberOfShares
          demat
          pricePerShare
          amountInvested
          currentValue
          securityClassId
          roundDetails
          fdbShares
          remarks
          ranges
        }
      }
      securities {
        securityType
        noOfShares
        noOfClassess
        holding
        parValue
        capitalValue
      }
      financialData {
        data {
          cin
          companyId
          companyIsPrivate
          data
          id
          isPrivate
          misData
          name
          publicCompanyName
          s3Url
          timeline
          timelineType
          updatedDate
          year
        }
      }
    }
    transactionData {
      hissTransactionId
      id
      companyType
      investorName
      investorId
      transactionType
      round
      noOfShares
      sharePrice
      roundIdentifier
      amount
      transactionDate
      currency
      exchangeRate
      companySharePrice
      investorsData {
        name
        exited
        fdbShares
        fdbHoldingPercentage
        currentValue
      }
      transactionFdbShares
      transactionValuation
      securitySubType
      tags
      notes
      metadata
      shareDistinctiveRange
      documents {
        id
        name
        key
        tags
        size
        isTransaction
        investmentId
        indirectInvestmentId
      }
    }
    investorData {
      id
      name
      exited
      fdbShares
      fdbHoldingPercentage
      currentValue
    }
    indirectTransactionData {
      id
      investorId
      investorName
      hissTransactionId
      unitType
      documents {
        id
        name
        key
        tags
        size
        isTransaction
        investmentId
        indirectInvestmentId
      }
      transactionDate
      noOfUnits
      currentNav
      transactionAmount
      drawDown
      setupFee
      indirectVehicleID
      indirectVehicleName
      currentNavDate
      transactionNav
      currentValue
      transactionCurrency
      exchangeRate
      tags
      notes
      metadata
    }
    valuationDetailsData {
      id
      valuationName
      valuationDate
      valuationType
      sharePricePerReport
      sharePriceBookValue
      valuatorName
      methodology
      tags
      sharePrice
      currency
      isDefault
      fileUrl
    }
    roundData {
      id
      name
      postMoneyValuation
      roundSize
      roundDate
    }
  }
}
    `;
export const useGetCompanyWiseDataQuery = <
      TData = GetCompanyWiseDataQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetCompanyWiseDataQueryVariables,
      options?: UseQueryOptions<GetCompanyWiseDataQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetCompanyWiseDataQuery, TError, TData>(
      variables === undefined ? ['getCompanyWiseData'] : ['getCompanyWiseData', variables],
      fetcher<GetCompanyWiseDataQuery, GetCompanyWiseDataQueryVariables>(client, GetCompanyWiseDataDocument, variables, headers),
      options
    );

useGetCompanyWiseDataQuery.getKey = (variables?: GetCompanyWiseDataQueryVariables) => variables === undefined ? ['getCompanyWiseData'] : ['getCompanyWiseData', variables];
;

export const AddUserCurrencyDocument = `
    mutation addUserCurrency($input: AddUserCurrencyInput) {
  addUserCurrency(input: $input) {
    userId
    userEmailId
    userCurrency
  }
}
    `;
export const useAddUserCurrencyMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddUserCurrencyMutation, TError, AddUserCurrencyMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddUserCurrencyMutation, TError, AddUserCurrencyMutationVariables, TContext>(
      ['addUserCurrency'],
      (variables?: AddUserCurrencyMutationVariables) => fetcher<AddUserCurrencyMutation, AddUserCurrencyMutationVariables>(client, AddUserCurrencyDocument, variables, headers)(),
      options
    );
useAddUserCurrencyMutation.getKey = () => ['addUserCurrency'];

export const GetUserCurrencyDocument = `
    query getUserCurrency {
  getUserCurrency
}
    `;
export const useGetUserCurrencyQuery = <
      TData = GetUserCurrencyQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetUserCurrencyQueryVariables,
      options?: UseQueryOptions<GetUserCurrencyQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetUserCurrencyQuery, TError, TData>(
      variables === undefined ? ['getUserCurrency'] : ['getUserCurrency', variables],
      fetcher<GetUserCurrencyQuery, GetUserCurrencyQueryVariables>(client, GetUserCurrencyDocument, variables, headers),
      options
    );

useGetUserCurrencyQuery.getKey = (variables?: GetUserCurrencyQueryVariables) => variables === undefined ? ['getUserCurrency'] : ['getUserCurrency', variables];
;

export const GetGlobalCompaniesDocument = `
    query getGlobalCompanies {
  globalCompaniesSearch {
    id
    name
    cin
    valuation
    companyCurrency
    jurisdiction
    dba
    isPrivate
    companyStage
    valuationDate
    sharePrice
    type
    investorName
  }
}
    `;
export const useGetGlobalCompaniesQuery = <
      TData = GetGlobalCompaniesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetGlobalCompaniesQueryVariables,
      options?: UseQueryOptions<GetGlobalCompaniesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetGlobalCompaniesQuery, TError, TData>(
      variables === undefined ? ['getGlobalCompanies'] : ['getGlobalCompanies', variables],
      fetcher<GetGlobalCompaniesQuery, GetGlobalCompaniesQueryVariables>(client, GetGlobalCompaniesDocument, variables, headers),
      options
    );

useGetGlobalCompaniesQuery.getKey = (variables?: GetGlobalCompaniesQueryVariables) => variables === undefined ? ['getGlobalCompanies'] : ['getGlobalCompanies', variables];
;

export const AddOrRemoveStarredCompaniesDocument = `
    mutation AddOrRemoveStarredCompanies($input: StarCompanyInput) {
  upsertStarCompanyToWatchlist(input: $input) {
    companyName
    companyId
    watchlistId
  }
}
    `;
export const useAddOrRemoveStarredCompaniesMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddOrRemoveStarredCompaniesMutation, TError, AddOrRemoveStarredCompaniesMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddOrRemoveStarredCompaniesMutation, TError, AddOrRemoveStarredCompaniesMutationVariables, TContext>(
      ['AddOrRemoveStarredCompanies'],
      (variables?: AddOrRemoveStarredCompaniesMutationVariables) => fetcher<AddOrRemoveStarredCompaniesMutation, AddOrRemoveStarredCompaniesMutationVariables>(client, AddOrRemoveStarredCompaniesDocument, variables, headers)(),
      options
    );
useAddOrRemoveStarredCompaniesMutation.getKey = () => ['AddOrRemoveStarredCompanies'];

export const AddRecentCompaniesDocument = `
    mutation AddRecentCompanies($input: RecentCompanyInput) {
  addUserRecentCompany(input: $input) {
    name
    type
    hissaCompanyId
    id
    logo
    dba
    visitedDateTime
  }
}
    `;
export const useAddRecentCompaniesMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddRecentCompaniesMutation, TError, AddRecentCompaniesMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddRecentCompaniesMutation, TError, AddRecentCompaniesMutationVariables, TContext>(
      ['AddRecentCompanies'],
      (variables?: AddRecentCompaniesMutationVariables) => fetcher<AddRecentCompaniesMutation, AddRecentCompaniesMutationVariables>(client, AddRecentCompaniesDocument, variables, headers)(),
      options
    );
useAddRecentCompaniesMutation.getKey = () => ['AddRecentCompanies'];

export const RemoveRecentCompanyDocument = `
    mutation RemoveRecentCompany($input: [RecentCompanyInput]) {
  removeUserRecentCompany(input: $input) {
    name
    type
    hissaCompanyId
    id
    logo
    dba
    visitedDateTime
  }
}
    `;
export const useRemoveRecentCompanyMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RemoveRecentCompanyMutation, TError, RemoveRecentCompanyMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RemoveRecentCompanyMutation, TError, RemoveRecentCompanyMutationVariables, TContext>(
      ['RemoveRecentCompany'],
      (variables?: RemoveRecentCompanyMutationVariables) => fetcher<RemoveRecentCompanyMutation, RemoveRecentCompanyMutationVariables>(client, RemoveRecentCompanyDocument, variables, headers)(),
      options
    );
useRemoveRecentCompanyMutation.getKey = () => ['RemoveRecentCompany'];

export const GetRecentCompaniesDocument = `
    query getRecentCompanies {
  getUserRecentCompanies {
    name
    type
    hissaCompanyId
    id
    logo
    dba
    visitedDateTime
  }
}
    `;
export const useGetRecentCompaniesQuery = <
      TData = GetRecentCompaniesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetRecentCompaniesQueryVariables,
      options?: UseQueryOptions<GetRecentCompaniesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetRecentCompaniesQuery, TError, TData>(
      variables === undefined ? ['getRecentCompanies'] : ['getRecentCompanies', variables],
      fetcher<GetRecentCompaniesQuery, GetRecentCompaniesQueryVariables>(client, GetRecentCompaniesDocument, variables, headers),
      options
    );

useGetRecentCompaniesQuery.getKey = (variables?: GetRecentCompaniesQueryVariables) => variables === undefined ? ['getRecentCompanies'] : ['getRecentCompanies', variables];
;

export const AddIndirectTransactionDocument = `
    mutation AddIndirectTransaction($input: AddIndirectTransactionsInput) {
  addIndirectTransaction(input: $input) {
    companyId
    investorId
    noOfUnits
    unitType
    investmentDate
    noOfUnits
    currentNav
    investedAmount
    drawDown
    setupFee
    indirectVehicleID
    investmentNav
    currentNavDate
  }
}
    `;
export const useAddIndirectTransactionMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddIndirectTransactionMutation, TError, AddIndirectTransactionMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddIndirectTransactionMutation, TError, AddIndirectTransactionMutationVariables, TContext>(
      ['AddIndirectTransaction'],
      (variables?: AddIndirectTransactionMutationVariables) => fetcher<AddIndirectTransactionMutation, AddIndirectTransactionMutationVariables>(client, AddIndirectTransactionDocument, variables, headers)(),
      options
    );
useAddIndirectTransactionMutation.getKey = () => ['AddIndirectTransaction'];

export const AddDirectTransactionDocument = `
    mutation AddDirectTransaction($input: AddTransactionInput) {
  addTransaction(input: $input) {
    companyId
    currency
    investorId
    exchangeRate
    investmentDate
    noOfShares
    investedAmount
    sharePrice
    roundName
    shareDistinctiveRange
  }
}
    `;
export const useAddDirectTransactionMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddDirectTransactionMutation, TError, AddDirectTransactionMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddDirectTransactionMutation, TError, AddDirectTransactionMutationVariables, TContext>(
      ['AddDirectTransaction'],
      (variables?: AddDirectTransactionMutationVariables) => fetcher<AddDirectTransactionMutation, AddDirectTransactionMutationVariables>(client, AddDirectTransactionDocument, variables, headers)(),
      options
    );
useAddDirectTransactionMutation.getKey = () => ['AddDirectTransaction'];

export const AddTagsToCompanyDocument = `
    mutation AddTagsToCompany($input: AddTagsToCompanyInput) {
  addTagsToCompany(input: $input)
}
    `;
export const useAddTagsToCompanyMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddTagsToCompanyMutation, TError, AddTagsToCompanyMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddTagsToCompanyMutation, TError, AddTagsToCompanyMutationVariables, TContext>(
      ['AddTagsToCompany'],
      (variables?: AddTagsToCompanyMutationVariables) => fetcher<AddTagsToCompanyMutation, AddTagsToCompanyMutationVariables>(client, AddTagsToCompanyDocument, variables, headers)(),
      options
    );
useAddTagsToCompanyMutation.getKey = () => ['AddTagsToCompany'];

export const AddTagsToTransactionDocument = `
    mutation AddTagsToTransaction($input: AddTagsToTransactionInput) {
  addTagsToTransaction(input: $input)
}
    `;
export const useAddTagsToTransactionMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddTagsToTransactionMutation, TError, AddTagsToTransactionMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddTagsToTransactionMutation, TError, AddTagsToTransactionMutationVariables, TContext>(
      ['AddTagsToTransaction'],
      (variables?: AddTagsToTransactionMutationVariables) => fetcher<AddTagsToTransactionMutation, AddTagsToTransactionMutationVariables>(client, AddTagsToTransactionDocument, variables, headers)(),
      options
    );
useAddTagsToTransactionMutation.getKey = () => ['AddTagsToTransaction'];

export const RemoveTransactionDocument = `
    mutation RemoveTransaction($input: RemoveTransactionInput) {
  removeTransaction(input: $input) {
    id
    companyId
    investorId
  }
}
    `;
export const useRemoveTransactionMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RemoveTransactionMutation, TError, RemoveTransactionMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RemoveTransactionMutation, TError, RemoveTransactionMutationVariables, TContext>(
      ['RemoveTransaction'],
      (variables?: RemoveTransactionMutationVariables) => fetcher<RemoveTransactionMutation, RemoveTransactionMutationVariables>(client, RemoveTransactionDocument, variables, headers)(),
      options
    );
useRemoveTransactionMutation.getKey = () => ['RemoveTransaction'];

export const RemoveIndirectTransactionDocument = `
    mutation RemoveIndirectTransaction($input: RemoveTransactionInput) {
  removeIndirectTransaction(input: $input) {
    id
    companyId
    investorId
  }
}
    `;
export const useRemoveIndirectTransactionMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RemoveIndirectTransactionMutation, TError, RemoveIndirectTransactionMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RemoveIndirectTransactionMutation, TError, RemoveIndirectTransactionMutationVariables, TContext>(
      ['RemoveIndirectTransaction'],
      (variables?: RemoveIndirectTransactionMutationVariables) => fetcher<RemoveIndirectTransactionMutation, RemoveIndirectTransactionMutationVariables>(client, RemoveIndirectTransactionDocument, variables, headers)(),
      options
    );
useRemoveIndirectTransactionMutation.getKey = () => ['RemoveIndirectTransaction'];

export const SyncHissaCompaniesDocument = `
    mutation syncHissaCompanies($input: BigInt) {
  syncHissaCompaniesForInvestor(investorId: $input) {
    companyId
    companyName
  }
}
    `;
export const useSyncHissaCompaniesMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SyncHissaCompaniesMutation, TError, SyncHissaCompaniesMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SyncHissaCompaniesMutation, TError, SyncHissaCompaniesMutationVariables, TContext>(
      ['syncHissaCompanies'],
      (variables?: SyncHissaCompaniesMutationVariables) => fetcher<SyncHissaCompaniesMutation, SyncHissaCompaniesMutationVariables>(client, SyncHissaCompaniesDocument, variables, headers)(),
      options
    );
useSyncHissaCompaniesMutation.getKey = () => ['syncHissaCompanies'];

export const GetNewHissaCompaniesDocument = `
    query getNewHissaCompanies($input: BigInt) {
  getNewHissaCompaniesForInvestor(investorId: $input) {
    companyId
    companyName
  }
}
    `;
export const useGetNewHissaCompaniesQuery = <
      TData = GetNewHissaCompaniesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetNewHissaCompaniesQueryVariables,
      options?: UseQueryOptions<GetNewHissaCompaniesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetNewHissaCompaniesQuery, TError, TData>(
      variables === undefined ? ['getNewHissaCompanies'] : ['getNewHissaCompanies', variables],
      fetcher<GetNewHissaCompaniesQuery, GetNewHissaCompaniesQueryVariables>(client, GetNewHissaCompaniesDocument, variables, headers),
      options
    );

useGetNewHissaCompaniesQuery.getKey = (variables?: GetNewHissaCompaniesQueryVariables) => variables === undefined ? ['getNewHissaCompanies'] : ['getNewHissaCompanies', variables];
;

export const EditDirectTransactionDocument = `
    mutation editDirectTransaction($input: EditDirectTransactionInput) {
  editDirectTransaction(input: $input) {
    companyId
    currency
    investorId
    exchangeRate
    investmentDate
    noOfShares
    investedAmount
    sharePrice
    roundName
    shareDistinctiveRange
  }
}
    `;
export const useEditDirectTransactionMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<EditDirectTransactionMutation, TError, EditDirectTransactionMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<EditDirectTransactionMutation, TError, EditDirectTransactionMutationVariables, TContext>(
      ['editDirectTransaction'],
      (variables?: EditDirectTransactionMutationVariables) => fetcher<EditDirectTransactionMutation, EditDirectTransactionMutationVariables>(client, EditDirectTransactionDocument, variables, headers)(),
      options
    );
useEditDirectTransactionMutation.getKey = () => ['editDirectTransaction'];

export const EditIndirectTransactionDocument = `
    mutation EditIndirectTransaction($input: EditIndirectTransactionsInput) {
  editIndirectTransaction(input: $input) {
    companyId
    investorId
    noOfUnits
    unitType
    investmentDate
    noOfUnits
    currentNav
    investedAmount
    drawDown
    setupFee
    indirectVehicleID
    investmentNav
    currentNavDate
  }
}
    `;
export const useEditIndirectTransactionMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<EditIndirectTransactionMutation, TError, EditIndirectTransactionMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<EditIndirectTransactionMutation, TError, EditIndirectTransactionMutationVariables, TContext>(
      ['EditIndirectTransaction'],
      (variables?: EditIndirectTransactionMutationVariables) => fetcher<EditIndirectTransactionMutation, EditIndirectTransactionMutationVariables>(client, EditIndirectTransactionDocument, variables, headers)(),
      options
    );
useEditIndirectTransactionMutation.getKey = () => ['EditIndirectTransaction'];

export const UpdateCompanyDetailsDocument = `
    mutation UpdateCompanyDetails($input: UpdateCompanyDetailsInput) {
  updateCompanyDetails(input: $input)
}
    `;
export const useUpdateCompanyDetailsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateCompanyDetailsMutation, TError, UpdateCompanyDetailsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateCompanyDetailsMutation, TError, UpdateCompanyDetailsMutationVariables, TContext>(
      ['UpdateCompanyDetails'],
      (variables?: UpdateCompanyDetailsMutationVariables) => fetcher<UpdateCompanyDetailsMutation, UpdateCompanyDetailsMutationVariables>(client, UpdateCompanyDetailsDocument, variables, headers)(),
      options
    );
useUpdateCompanyDetailsMutation.getKey = () => ['UpdateCompanyDetails'];

export const SaveInvestmentModellingDocument = `
    mutation saveInvestmentModelling($input: SaveInvestmentModellingDetailsInput) {
  saveInvestmentModellingDetails(input: $input) {
    modellingDataId
  }
}
    `;
export const useSaveInvestmentModellingMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SaveInvestmentModellingMutation, TError, SaveInvestmentModellingMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SaveInvestmentModellingMutation, TError, SaveInvestmentModellingMutationVariables, TContext>(
      ['saveInvestmentModelling'],
      (variables?: SaveInvestmentModellingMutationVariables) => fetcher<SaveInvestmentModellingMutation, SaveInvestmentModellingMutationVariables>(client, SaveInvestmentModellingDocument, variables, headers)(),
      options
    );
useSaveInvestmentModellingMutation.getKey = () => ['saveInvestmentModelling'];

export const GetInvestmentModellingDocument = `
    query getInvestmentModelling($input: GetInvestmentModellingDetailsInput) {
  getInvestmentModellingDetails(input: $input) {
    modellingDataId
    investmentModellingDetails {
      numberOfRounds
      currentInvestmentDetails {
        roundName
        dilution
        valuation
        investment
        holdingPercentage
        date
        roundSize
        revenue
        exitHere
        isDeleted
        currentValue
      }
      tableDetails {
        roundName
        dilution
        valuation
        investment
        holdingPercentage
        date
        roundSize
        revenue
        exitHere
        isDeleted
        currentValue
      }
      finalHoldingPercentage
      heatMap
      companyFdbShares
      finalInvestmentAmount
      nonPriceRoundHeatMap
      valuationCap
      finalCurrentValue
    }
  }
}
    `;
export const useGetInvestmentModellingQuery = <
      TData = GetInvestmentModellingQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetInvestmentModellingQueryVariables,
      options?: UseQueryOptions<GetInvestmentModellingQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetInvestmentModellingQuery, TError, TData>(
      variables === undefined ? ['getInvestmentModelling'] : ['getInvestmentModelling', variables],
      fetcher<GetInvestmentModellingQuery, GetInvestmentModellingQueryVariables>(client, GetInvestmentModellingDocument, variables, headers),
      options
    );

useGetInvestmentModellingQuery.getKey = (variables?: GetInvestmentModellingQueryVariables) => variables === undefined ? ['getInvestmentModelling'] : ['getInvestmentModelling', variables];
;

export const AddAccountAccessDocument = `
    mutation AddAccountAccess($input: AddAccountAccessInput) {
  AddAccountAccess(input: $input)
}
    `;
export const useAddAccountAccessMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddAccountAccessMutation, TError, AddAccountAccessMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddAccountAccessMutation, TError, AddAccountAccessMutationVariables, TContext>(
      ['AddAccountAccess'],
      (variables?: AddAccountAccessMutationVariables) => fetcher<AddAccountAccessMutation, AddAccountAccessMutationVariables>(client, AddAccountAccessDocument, variables, headers)(),
      options
    );
useAddAccountAccessMutation.getKey = () => ['AddAccountAccess'];

export const CheckIsRequestSentDocument = `
    query checkIsRequestSent {
  checkIsRequestSent {
    id
    userId
    isEmailSent
    message
  }
}
    `;
export const useCheckIsRequestSentQuery = <
      TData = CheckIsRequestSentQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: CheckIsRequestSentQueryVariables,
      options?: UseQueryOptions<CheckIsRequestSentQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CheckIsRequestSentQuery, TError, TData>(
      variables === undefined ? ['checkIsRequestSent'] : ['checkIsRequestSent', variables],
      fetcher<CheckIsRequestSentQuery, CheckIsRequestSentQueryVariables>(client, CheckIsRequestSentDocument, variables, headers),
      options
    );

useCheckIsRequestSentQuery.getKey = (variables?: CheckIsRequestSentQueryVariables) => variables === undefined ? ['checkIsRequestSent'] : ['checkIsRequestSent', variables];
;

export const GetInvestorIrrTransactionsDocument = `
    query getInvestorIrrTransactions($input: CompanyDataInput) {
  getInvestorTransactions(input: $input) {
    amount
    date
  }
}
    `;
export const useGetInvestorIrrTransactionsQuery = <
      TData = GetInvestorIrrTransactionsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetInvestorIrrTransactionsQueryVariables,
      options?: UseQueryOptions<GetInvestorIrrTransactionsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetInvestorIrrTransactionsQuery, TError, TData>(
      variables === undefined ? ['getInvestorIrrTransactions'] : ['getInvestorIrrTransactions', variables],
      fetcher<GetInvestorIrrTransactionsQuery, GetInvestorIrrTransactionsQueryVariables>(client, GetInvestorIrrTransactionsDocument, variables, headers),
      options
    );

useGetInvestorIrrTransactionsQuery.getKey = (variables?: GetInvestorIrrTransactionsQueryVariables) => variables === undefined ? ['getInvestorIrrTransactions'] : ['getInvestorIrrTransactions', variables];
;

export const GetCompanyLatestReportDocument = `
    query getCompanyLatestReport($input: CompanyDataInput) {
  getCompanyLatestReport(input: $input) {
    companyName
    reportId
    reportName
    tags
    reportDate
    fileUrl
    timeline
    data {
      groupName
      items {
        subGroupItem
        type
        data {
          projected
          actual
        }
      }
    }
  }
}
    `;
export const useGetCompanyLatestReportQuery = <
      TData = GetCompanyLatestReportQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetCompanyLatestReportQueryVariables,
      options?: UseQueryOptions<GetCompanyLatestReportQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetCompanyLatestReportQuery, TError, TData>(
      variables === undefined ? ['getCompanyLatestReport'] : ['getCompanyLatestReport', variables],
      fetcher<GetCompanyLatestReportQuery, GetCompanyLatestReportQueryVariables>(client, GetCompanyLatestReportDocument, variables, headers),
      options
    );

useGetCompanyLatestReportQuery.getKey = (variables?: GetCompanyLatestReportQueryVariables) => variables === undefined ? ['getCompanyLatestReport'] : ['getCompanyLatestReport', variables];
;

export const SendTermsheetToCaptableDocument = `
    mutation sendTermsheetToCaptable($input: FetchTermsheetInput) {
  sendTermsheetToCaptable(input: $input)
}
    `;
export const useSendTermsheetToCaptableMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SendTermsheetToCaptableMutation, TError, SendTermsheetToCaptableMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SendTermsheetToCaptableMutation, TError, SendTermsheetToCaptableMutationVariables, TContext>(
      ['sendTermsheetToCaptable'],
      (variables?: SendTermsheetToCaptableMutationVariables) => fetcher<SendTermsheetToCaptableMutation, SendTermsheetToCaptableMutationVariables>(client, SendTermsheetToCaptableDocument, variables, headers)(),
      options
    );
useSendTermsheetToCaptableMutation.getKey = () => ['sendTermsheetToCaptable'];

export const GetInvestorRoundModellingDocument = `
    query getInvestorRoundModelling($input: InvestorRoundModellingInput) {
  getInvestorRoundModellingDetails(input: $input) {
    id
    preHoldingFdbShares
    postHoldingFdbShares
    preHoldingFdbPercentage
    postHoldingFdbPercentage
    amountInvestedInRound
    shareholderName
    shareholderType
  }
}
    `;
export const useGetInvestorRoundModellingQuery = <
      TData = GetInvestorRoundModellingQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetInvestorRoundModellingQueryVariables,
      options?: UseQueryOptions<GetInvestorRoundModellingQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetInvestorRoundModellingQuery, TError, TData>(
      variables === undefined ? ['getInvestorRoundModelling'] : ['getInvestorRoundModelling', variables],
      fetcher<GetInvestorRoundModellingQuery, GetInvestorRoundModellingQueryVariables>(client, GetInvestorRoundModellingDocument, variables, headers),
      options
    );

useGetInvestorRoundModellingQuery.getKey = (variables?: GetInvestorRoundModellingQueryVariables) => variables === undefined ? ['getInvestorRoundModelling'] : ['getInvestorRoundModelling', variables];
;

export const GetInvestorRoundModellingDataDocument = `
    query getInvestorRoundModellingData($input: GetInvestorModellingInput) {
  getSavedInvestorRoundModellingDetails(input: $input) {
    id
    accountId
    investmentModellingData
    hissaCompanyId
    name
  }
}
    `;
export const useGetInvestorRoundModellingDataQuery = <
      TData = GetInvestorRoundModellingDataQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetInvestorRoundModellingDataQueryVariables,
      options?: UseQueryOptions<GetInvestorRoundModellingDataQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetInvestorRoundModellingDataQuery, TError, TData>(
      variables === undefined ? ['getInvestorRoundModellingData'] : ['getInvestorRoundModellingData', variables],
      fetcher<GetInvestorRoundModellingDataQuery, GetInvestorRoundModellingDataQueryVariables>(client, GetInvestorRoundModellingDataDocument, variables, headers),
      options
    );

useGetInvestorRoundModellingDataQuery.getKey = (variables?: GetInvestorRoundModellingDataQueryVariables) => variables === undefined ? ['getInvestorRoundModellingData'] : ['getInvestorRoundModellingData', variables];
;

export const GetAllInvestorRoundModellingDataDocument = `
    query getAllInvestorRoundModellingData($input: GetInvestorModellingInput) {
  getAllInvestorRoundModelling(input: $input) {
    id
    accountId
    investmentModellingData
    hissaCompanyId
    name
  }
}
    `;
export const useGetAllInvestorRoundModellingDataQuery = <
      TData = GetAllInvestorRoundModellingDataQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetAllInvestorRoundModellingDataQueryVariables,
      options?: UseQueryOptions<GetAllInvestorRoundModellingDataQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetAllInvestorRoundModellingDataQuery, TError, TData>(
      variables === undefined ? ['getAllInvestorRoundModellingData'] : ['getAllInvestorRoundModellingData', variables],
      fetcher<GetAllInvestorRoundModellingDataQuery, GetAllInvestorRoundModellingDataQueryVariables>(client, GetAllInvestorRoundModellingDataDocument, variables, headers),
      options
    );

useGetAllInvestorRoundModellingDataQuery.getKey = (variables?: GetAllInvestorRoundModellingDataQueryVariables) => variables === undefined ? ['getAllInvestorRoundModellingData'] : ['getAllInvestorRoundModellingData', variables];
;

export const SaveInvestorRoundModellingDataDocument = `
    mutation saveInvestorRoundModellingData($input: SaveInvestorModellingInput) {
  saveInvestorRoundModellingDetails(input: $input) {
    investorModellingDetails
    hissaCompanyId
    name
    id
  }
}
    `;
export const useSaveInvestorRoundModellingDataMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SaveInvestorRoundModellingDataMutation, TError, SaveInvestorRoundModellingDataMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SaveInvestorRoundModellingDataMutation, TError, SaveInvestorRoundModellingDataMutationVariables, TContext>(
      ['saveInvestorRoundModellingData'],
      (variables?: SaveInvestorRoundModellingDataMutationVariables) => fetcher<SaveInvestorRoundModellingDataMutation, SaveInvestorRoundModellingDataMutationVariables>(client, SaveInvestorRoundModellingDataDocument, variables, headers)(),
      options
    );
useSaveInvestorRoundModellingDataMutation.getKey = () => ['saveInvestorRoundModellingData'];

export const DeleteInvestorRoundModellingDataDocument = `
    mutation deleteInvestorRoundModellingData($input: RemoveInvestorModellingInput) {
  deleteInvestorRoundModellingDetails(input: $input)
}
    `;
export const useDeleteInvestorRoundModellingDataMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteInvestorRoundModellingDataMutation, TError, DeleteInvestorRoundModellingDataMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteInvestorRoundModellingDataMutation, TError, DeleteInvestorRoundModellingDataMutationVariables, TContext>(
      ['deleteInvestorRoundModellingData'],
      (variables?: DeleteInvestorRoundModellingDataMutationVariables) => fetcher<DeleteInvestorRoundModellingDataMutation, DeleteInvestorRoundModellingDataMutationVariables>(client, DeleteInvestorRoundModellingDataDocument, variables, headers)(),
      options
    );
useDeleteInvestorRoundModellingDataMutation.getKey = () => ['deleteInvestorRoundModellingData'];

export const AddReportsToCompanyDocument = `
    mutation addReportsToCompany($input: AddMisReportInput) {
  addCompanyMisReport(input: $input) {
    id
    name
  }
}
    `;
export const useAddReportsToCompanyMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddReportsToCompanyMutation, TError, AddReportsToCompanyMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddReportsToCompanyMutation, TError, AddReportsToCompanyMutationVariables, TContext>(
      ['addReportsToCompany'],
      (variables?: AddReportsToCompanyMutationVariables) => fetcher<AddReportsToCompanyMutation, AddReportsToCompanyMutationVariables>(client, AddReportsToCompanyDocument, variables, headers)(),
      options
    );
useAddReportsToCompanyMutation.getKey = () => ['addReportsToCompany'];

export const GetCompanyMisReportsDocument = `
    query getCompanyMisReports($input: CompanyDataInput) {
  getCompanyMisReports(input: $input) {
    id
    name
    tags
    fileUrl
    createdAt
    updatedAt
    reportDate
  }
}
    `;
export const useGetCompanyMisReportsQuery = <
      TData = GetCompanyMisReportsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetCompanyMisReportsQueryVariables,
      options?: UseQueryOptions<GetCompanyMisReportsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetCompanyMisReportsQuery, TError, TData>(
      variables === undefined ? ['getCompanyMisReports'] : ['getCompanyMisReports', variables],
      fetcher<GetCompanyMisReportsQuery, GetCompanyMisReportsQueryVariables>(client, GetCompanyMisReportsDocument, variables, headers),
      options
    );

useGetCompanyMisReportsQuery.getKey = (variables?: GetCompanyMisReportsQueryVariables) => variables === undefined ? ['getCompanyMisReports'] : ['getCompanyMisReports', variables];
;

export const DeleteCompanyReportsDocument = `
    mutation deleteCompanyReports($input: DeleteMisReportInput) {
  deleteCompanyMisReport(input: $input) {
    id
    name
  }
}
    `;
export const useDeleteCompanyReportsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteCompanyReportsMutation, TError, DeleteCompanyReportsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteCompanyReportsMutation, TError, DeleteCompanyReportsMutationVariables, TContext>(
      ['deleteCompanyReports'],
      (variables?: DeleteCompanyReportsMutationVariables) => fetcher<DeleteCompanyReportsMutation, DeleteCompanyReportsMutationVariables>(client, DeleteCompanyReportsDocument, variables, headers)(),
      options
    );
useDeleteCompanyReportsMutation.getKey = () => ['deleteCompanyReports'];

export const GetCompanyReportByIdDocument = `
    query getCompanyReportById($input: DeleteMisReportInput) {
  getCompanyMisReportById(input: $input) {
    companyName
    reportId
    reportName
    tags
    reportDate
    fileUrl
    timeline
    data {
      groupName
      items {
        subGroupItem
        type
        data {
          projected
          actual
        }
      }
    }
  }
}
    `;
export const useGetCompanyReportByIdQuery = <
      TData = GetCompanyReportByIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetCompanyReportByIdQueryVariables,
      options?: UseQueryOptions<GetCompanyReportByIdQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetCompanyReportByIdQuery, TError, TData>(
      variables === undefined ? ['getCompanyReportById'] : ['getCompanyReportById', variables],
      fetcher<GetCompanyReportByIdQuery, GetCompanyReportByIdQueryVariables>(client, GetCompanyReportByIdDocument, variables, headers),
      options
    );

useGetCompanyReportByIdQuery.getKey = (variables?: GetCompanyReportByIdQueryVariables) => variables === undefined ? ['getCompanyReportById'] : ['getCompanyReportById', variables];
;

export const GetDocumentSignIdDocument = `
    query getDocumentSignId($input: DocumentSignIdInput) {
  getDocumentSignId(input: $input)
}
    `;
export const useGetDocumentSignIdQuery = <
      TData = GetDocumentSignIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetDocumentSignIdQueryVariables,
      options?: UseQueryOptions<GetDocumentSignIdQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetDocumentSignIdQuery, TError, TData>(
      variables === undefined ? ['getDocumentSignId'] : ['getDocumentSignId', variables],
      fetcher<GetDocumentSignIdQuery, GetDocumentSignIdQueryVariables>(client, GetDocumentSignIdDocument, variables, headers),
      options
    );

useGetDocumentSignIdQuery.getKey = (variables?: GetDocumentSignIdQueryVariables) => variables === undefined ? ['getDocumentSignId'] : ['getDocumentSignId', variables];
;

export const EditReportsOfCompanyDocument = `
    mutation editReportsOfCompany($input: EditMisReportInput) {
  editCompanyMisReport(input: $input) {
    id
    name
  }
}
    `;
export const useEditReportsOfCompanyMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<EditReportsOfCompanyMutation, TError, EditReportsOfCompanyMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<EditReportsOfCompanyMutation, TError, EditReportsOfCompanyMutationVariables, TContext>(
      ['editReportsOfCompany'],
      (variables?: EditReportsOfCompanyMutationVariables) => fetcher<EditReportsOfCompanyMutation, EditReportsOfCompanyMutationVariables>(client, EditReportsOfCompanyDocument, variables, headers)(),
      options
    );
useEditReportsOfCompanyMutation.getKey = () => ['editReportsOfCompany'];

export const UploadPrivateCaptableDocument = `
    mutation uploadPrivateCaptable($input: PrivateCaptableInput) {
  createPrivateCaptable(input: $input) {
    id
    cin
    companyName
    hissaCompanyId
    companyType
    fileUrl
  }
}
    `;
export const useUploadPrivateCaptableMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UploadPrivateCaptableMutation, TError, UploadPrivateCaptableMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UploadPrivateCaptableMutation, TError, UploadPrivateCaptableMutationVariables, TContext>(
      ['uploadPrivateCaptable'],
      (variables?: UploadPrivateCaptableMutationVariables) => fetcher<UploadPrivateCaptableMutation, UploadPrivateCaptableMutationVariables>(client, UploadPrivateCaptableDocument, variables, headers)(),
      options
    );
useUploadPrivateCaptableMutation.getKey = () => ['uploadPrivateCaptable'];

export const GetAllPrivateCaptablesDocument = `
    query getAllPrivateCaptables {
  getAllPrivateCaptables {
    id
    cin
    companyName
    hissaCompanyId
    companyType
    fileUrl
  }
}
    `;
export const useGetAllPrivateCaptablesQuery = <
      TData = GetAllPrivateCaptablesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetAllPrivateCaptablesQueryVariables,
      options?: UseQueryOptions<GetAllPrivateCaptablesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetAllPrivateCaptablesQuery, TError, TData>(
      variables === undefined ? ['getAllPrivateCaptables'] : ['getAllPrivateCaptables', variables],
      fetcher<GetAllPrivateCaptablesQuery, GetAllPrivateCaptablesQueryVariables>(client, GetAllPrivateCaptablesDocument, variables, headers),
      options
    );

useGetAllPrivateCaptablesQuery.getKey = (variables?: GetAllPrivateCaptablesQueryVariables) => variables === undefined ? ['getAllPrivateCaptables'] : ['getAllPrivateCaptables', variables];
;

export const DeletePrivateCaptableDocument = `
    mutation deletePrivateCaptable($input: DeletePrivateCaptableInput) {
  deletePrivateCaptables(input: $input)
}
    `;
export const useDeletePrivateCaptableMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeletePrivateCaptableMutation, TError, DeletePrivateCaptableMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeletePrivateCaptableMutation, TError, DeletePrivateCaptableMutationVariables, TContext>(
      ['deletePrivateCaptable'],
      (variables?: DeletePrivateCaptableMutationVariables) => fetcher<DeletePrivateCaptableMutation, DeletePrivateCaptableMutationVariables>(client, DeletePrivateCaptableDocument, variables, headers)(),
      options
    );
useDeletePrivateCaptableMutation.getKey = () => ['deletePrivateCaptable'];

export const GetAllDynamicTableDataDocument = `
    query getAllDynamicTableData {
  getDynamicTableData {
    id
    userId
    name
    description
    tableData
    chartData
    fileUrl
    googleSheetLink
    fileName
    isPublished
  }
}
    `;
export const useGetAllDynamicTableDataQuery = <
      TData = GetAllDynamicTableDataQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetAllDynamicTableDataQueryVariables,
      options?: UseQueryOptions<GetAllDynamicTableDataQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetAllDynamicTableDataQuery, TError, TData>(
      variables === undefined ? ['getAllDynamicTableData'] : ['getAllDynamicTableData', variables],
      fetcher<GetAllDynamicTableDataQuery, GetAllDynamicTableDataQueryVariables>(client, GetAllDynamicTableDataDocument, variables, headers),
      options
    );

useGetAllDynamicTableDataQuery.getKey = (variables?: GetAllDynamicTableDataQueryVariables) => variables === undefined ? ['getAllDynamicTableData'] : ['getAllDynamicTableData', variables];
;

export const AddDynamicTableDataDocument = `
    mutation addDynamicTableData($input: DynamicTableDataInput) {
  createDynamicTableData(input: $input) {
    id
    userId
    name
    description
    tableData
    chartData
    fileUrl
  }
}
    `;
export const useAddDynamicTableDataMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddDynamicTableDataMutation, TError, AddDynamicTableDataMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddDynamicTableDataMutation, TError, AddDynamicTableDataMutationVariables, TContext>(
      ['addDynamicTableData'],
      (variables?: AddDynamicTableDataMutationVariables) => fetcher<AddDynamicTableDataMutation, AddDynamicTableDataMutationVariables>(client, AddDynamicTableDataDocument, variables, headers)(),
      options
    );
useAddDynamicTableDataMutation.getKey = () => ['addDynamicTableData'];

export const DeleteDynamicTableDataDocument = `
    mutation deleteDynamicTableData($input: DeleteDynamicTableInput) {
  deleteDynamicTableData(input: $input)
}
    `;
export const useDeleteDynamicTableDataMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteDynamicTableDataMutation, TError, DeleteDynamicTableDataMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteDynamicTableDataMutation, TError, DeleteDynamicTableDataMutationVariables, TContext>(
      ['deleteDynamicTableData'],
      (variables?: DeleteDynamicTableDataMutationVariables) => fetcher<DeleteDynamicTableDataMutation, DeleteDynamicTableDataMutationVariables>(client, DeleteDynamicTableDataDocument, variables, headers)(),
      options
    );
useDeleteDynamicTableDataMutation.getKey = () => ['deleteDynamicTableData'];

export const DeleteExitModelDataDocument = `
    mutation deleteExitModelData($input: RemoveExitModelInput) {
  removeExitModellingDetails(input: $input)
}
    `;
export const useDeleteExitModelDataMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteExitModelDataMutation, TError, DeleteExitModelDataMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteExitModelDataMutation, TError, DeleteExitModelDataMutationVariables, TContext>(
      ['deleteExitModelData'],
      (variables?: DeleteExitModelDataMutationVariables) => fetcher<DeleteExitModelDataMutation, DeleteExitModelDataMutationVariables>(client, DeleteExitModelDataDocument, variables, headers)(),
      options
    );
useDeleteExitModelDataMutation.getKey = () => ['deleteExitModelData'];

export const GetAllExitModellingDocument = `
    query getAllExitModelling($input: GetInvestmentModellingDetailsInput) {
  getAllExitModellingDetails(input: $input) {
    modellingDataId
    modelName
    investmentModellingDetails {
      numberOfRounds
      currentInvestmentDetails {
        roundName
        dilution
        valuation
        investment
        holdingPercentage
        date
        roundSize
        revenue
        exitHere
        isDeleted
        currentValue
      }
      tableDetails {
        roundName
        dilution
        valuation
        investment
        holdingPercentage
        date
        roundSize
        revenue
        exitHere
        isDeleted
        currentValue
      }
      finalHoldingPercentage
      heatMap
      companyFdbShares
      finalInvestmentAmount
      nonPriceRoundHeatMap
      valuationCap
      finalCurrentValue
    }
  }
}
    `;
export const useGetAllExitModellingQuery = <
      TData = GetAllExitModellingQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetAllExitModellingQueryVariables,
      options?: UseQueryOptions<GetAllExitModellingQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetAllExitModellingQuery, TError, TData>(
      variables === undefined ? ['getAllExitModelling'] : ['getAllExitModelling', variables],
      fetcher<GetAllExitModellingQuery, GetAllExitModellingQueryVariables>(client, GetAllExitModellingDocument, variables, headers),
      options
    );

useGetAllExitModellingQuery.getKey = (variables?: GetAllExitModellingQueryVariables) => variables === undefined ? ['getAllExitModelling'] : ['getAllExitModelling', variables];
;

export const AddNewHissaCompaniesForInvestorDocument = `
    mutation addNewHissaCompaniesForInvestor($input: SyncInvestorCompaniesInput) {
  addNewHissaCompaniesForInvestor(input: $input) {
    companyId
    companyName
  }
}
    `;
export const useAddNewHissaCompaniesForInvestorMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddNewHissaCompaniesForInvestorMutation, TError, AddNewHissaCompaniesForInvestorMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddNewHissaCompaniesForInvestorMutation, TError, AddNewHissaCompaniesForInvestorMutationVariables, TContext>(
      ['addNewHissaCompaniesForInvestor'],
      (variables?: AddNewHissaCompaniesForInvestorMutationVariables) => fetcher<AddNewHissaCompaniesForInvestorMutation, AddNewHissaCompaniesForInvestorMutationVariables>(client, AddNewHissaCompaniesForInvestorDocument, variables, headers)(),
      options
    );
useAddNewHissaCompaniesForInvestorMutation.getKey = () => ['addNewHissaCompaniesForInvestor'];

export const RemoveExistingCompaniesDocument = `
    mutation removeExistingCompanies($input: SyncInvestorCompaniesInput) {
  removeExistingCompanies(input: $input) {
    companyId
    companyName
    companyType
  }
}
    `;
export const useRemoveExistingCompaniesMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RemoveExistingCompaniesMutation, TError, RemoveExistingCompaniesMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RemoveExistingCompaniesMutation, TError, RemoveExistingCompaniesMutationVariables, TContext>(
      ['removeExistingCompanies'],
      (variables?: RemoveExistingCompaniesMutationVariables) => fetcher<RemoveExistingCompaniesMutation, RemoveExistingCompaniesMutationVariables>(client, RemoveExistingCompaniesDocument, variables, headers)(),
      options
    );
useRemoveExistingCompaniesMutation.getKey = () => ['removeExistingCompanies'];

export const GetExistingHissaCompaniesDocument = `
    query getExistingHissaCompanies($input: BigInt) {
  getExistingCompaniesForInvestor(investorId: $input) {
    companyId
    companyName
    companyType
  }
}
    `;
export const useGetExistingHissaCompaniesQuery = <
      TData = GetExistingHissaCompaniesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetExistingHissaCompaniesQueryVariables,
      options?: UseQueryOptions<GetExistingHissaCompaniesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetExistingHissaCompaniesQuery, TError, TData>(
      variables === undefined ? ['getExistingHissaCompanies'] : ['getExistingHissaCompanies', variables],
      fetcher<GetExistingHissaCompaniesQuery, GetExistingHissaCompaniesQueryVariables>(client, GetExistingHissaCompaniesDocument, variables, headers),
      options
    );

useGetExistingHissaCompaniesQuery.getKey = (variables?: GetExistingHissaCompaniesQueryVariables) => variables === undefined ? ['getExistingHissaCompanies'] : ['getExistingHissaCompanies', variables];
;

export const RemoveInvestorFromAccountDocument = `
    mutation removeInvestorFromAccount($input: InvestorRemoveInput) {
  removeInvestor(input: $input)
}
    `;
export const useRemoveInvestorFromAccountMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RemoveInvestorFromAccountMutation, TError, RemoveInvestorFromAccountMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RemoveInvestorFromAccountMutation, TError, RemoveInvestorFromAccountMutationVariables, TContext>(
      ['removeInvestorFromAccount'],
      (variables?: RemoveInvestorFromAccountMutationVariables) => fetcher<RemoveInvestorFromAccountMutation, RemoveInvestorFromAccountMutationVariables>(client, RemoveInvestorFromAccountDocument, variables, headers)(),
      options
    );
useRemoveInvestorFromAccountMutation.getKey = () => ['removeInvestorFromAccount'];

export const ReGenerateCertificateDocument = `
    query reGenerateCertificate($input: GenerateCertificateType) {
  getReGeneratedCertificate(input: $input)
}
    `;
export const useReGenerateCertificateQuery = <
      TData = ReGenerateCertificateQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: ReGenerateCertificateQueryVariables,
      options?: UseQueryOptions<ReGenerateCertificateQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ReGenerateCertificateQuery, TError, TData>(
      variables === undefined ? ['reGenerateCertificate'] : ['reGenerateCertificate', variables],
      fetcher<ReGenerateCertificateQuery, ReGenerateCertificateQueryVariables>(client, ReGenerateCertificateDocument, variables, headers),
      options
    );

useReGenerateCertificateQuery.getKey = (variables?: ReGenerateCertificateQueryVariables) => variables === undefined ? ['reGenerateCertificate'] : ['reGenerateCertificate', variables];
;

export const GetGrantsDocument = `
    query getGrants {
  grants {
    grantId
    userId
    companyName
    grantDate
    grantType
    numberGranted
    exercisePriceOrSarValue
    expiryDate
    status
    createdAt
    updatedAt
    cancelledAt
    cancellationReason
    salePrice
    metadata
    vestedOptions
    companyFMV
    companyCurrency
    fmvDate
    notes
    planName
    expiryNumber
    expiryUnitType
    numberExercised
    companyFmvinUserCurrency
    strikePriceinUserCurrency
    vestingSchedules {
      vestingScheduleId
      grantId
      scheduleType
      cliffDurationMonths
      vestingFrequency
      totalVestingDurationMonths
      performanceCriteria
      createdAt
      updatedAt
      vestedOptions
      vestingTemplateName
      metadata
    }
  }
}
    `;
export const useGetGrantsQuery = <
      TData = GetGrantsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetGrantsQueryVariables,
      options?: UseQueryOptions<GetGrantsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetGrantsQuery, TError, TData>(
      variables === undefined ? ['getGrants'] : ['getGrants', variables],
      fetcher<GetGrantsQuery, GetGrantsQueryVariables>(client, GetGrantsDocument, variables, headers),
      options
    );

useGetGrantsQuery.getKey = (variables?: GetGrantsQueryVariables) => variables === undefined ? ['getGrants'] : ['getGrants', variables];
;

export const GetGrantDocument = `
    query getGrant($input: BigInt!) {
  grant(grantId: $input) {
    grantId
    userId
    companyName
    grantDate
    grantType
    numberGranted
    exercisePriceOrSarValue
    expiryDate
    status
    createdAt
    updatedAt
    cancelledAt
    cancellationReason
    metadata
    salePrice
    vestedOptions
    companyFMV
    companyCurrency
    fmvDate
    notes
    numberExercised
    planName
    expiryNumber
    planName
    expiryNumber
    expiryUnitType
    vestingSchedules {
      vestingScheduleId
      grantId
      scheduleType
      cliffDurationMonths
      vestingFrequency
      vestedOptions
      totalVestingDurationMonths
      performanceCriteria
      createdAt
      updatedAt
      vestingTemplateName
      metadata
      vestingMilestones {
        vestingMilestoneId
        vestingScheduleId
        milestoneDate
        percentageToVest
        numberToVest
        isAchieved
        achievedDate
        createdAt
        updatedAt
        metadata
      }
    }
  }
}
    `;
export const useGetGrantQuery = <
      TData = GetGrantQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetGrantQueryVariables,
      options?: UseQueryOptions<GetGrantQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetGrantQuery, TError, TData>(
      ['getGrant', variables],
      fetcher<GetGrantQuery, GetGrantQueryVariables>(client, GetGrantDocument, variables, headers),
      options
    );

useGetGrantQuery.getKey = (variables: GetGrantQueryVariables) => ['getGrant', variables];
;

export const CreateGrantDocument = `
    mutation createGrant($input: CreateGrantInput!) {
  createGrant(input: $input) {
    grantId
    userId
    companyName
    grantDate
    grantType
    numberGranted
    status
    metadata
    vestedOptions
    companyFMV
    companyCurrency
    expiryNumber
    expiryUnitType
    planName
    vestingSchedules {
      vestingScheduleId
      grantId
      scheduleType
      cliffDurationMonths
      vestingFrequency
      totalVestingDurationMonths
      performanceCriteria
      createdAt
      updatedAt
      vestedOptions
      vestingTemplateName
      metadata
      vestingMilestones {
        vestingMilestoneId
        vestingScheduleId
        milestoneDate
        percentageToVest
        numberToVest
        isAchieved
        achievedDate
        createdAt
        updatedAt
        metadata
      }
    }
  }
}
    `;
export const useCreateGrantMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateGrantMutation, TError, CreateGrantMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateGrantMutation, TError, CreateGrantMutationVariables, TContext>(
      ['createGrant'],
      (variables?: CreateGrantMutationVariables) => fetcher<CreateGrantMutation, CreateGrantMutationVariables>(client, CreateGrantDocument, variables, headers)(),
      options
    );
useCreateGrantMutation.getKey = () => ['createGrant'];

export const UpdateGrantDocument = `
    mutation updateGrant($input: UpdateGrantInput!) {
  updateGrant(input: $input) {
    grantId
    userId
    companyName
    grantDate
    grantType
    numberGranted
    status
    companyFMV
    companyCurrency
    vestedOptions
    planName
    expiryNumber
    metadata
  }
}
    `;
export const useUpdateGrantMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateGrantMutation, TError, UpdateGrantMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateGrantMutation, TError, UpdateGrantMutationVariables, TContext>(
      ['updateGrant'],
      (variables?: UpdateGrantMutationVariables) => fetcher<UpdateGrantMutation, UpdateGrantMutationVariables>(client, UpdateGrantDocument, variables, headers)(),
      options
    );
useUpdateGrantMutation.getKey = () => ['updateGrant'];

export const CancelGrantDocument = `
    mutation cancelGrant($input: CancelGrantInput!) {
  cancelGrant(input: $input) {
    grantId
    cancellationReason
    cancelledAt
  }
}
    `;
export const useCancelGrantMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CancelGrantMutation, TError, CancelGrantMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CancelGrantMutation, TError, CancelGrantMutationVariables, TContext>(
      ['cancelGrant'],
      (variables?: CancelGrantMutationVariables) => fetcher<CancelGrantMutation, CancelGrantMutationVariables>(client, CancelGrantDocument, variables, headers)(),
      options
    );
useCancelGrantMutation.getKey = () => ['cancelGrant'];

export const DeleteGrantDocument = `
    mutation deleteGrant($grantId: BigInt!) {
  deleteGrant(grantId: $grantId)
}
    `;
export const useDeleteGrantMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteGrantMutation, TError, DeleteGrantMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteGrantMutation, TError, DeleteGrantMutationVariables, TContext>(
      ['deleteGrant'],
      (variables?: DeleteGrantMutationVariables) => fetcher<DeleteGrantMutation, DeleteGrantMutationVariables>(client, DeleteGrantDocument, variables, headers)(),
      options
    );
useDeleteGrantMutation.getKey = () => ['deleteGrant'];

export const UploadGrantDataDocument = `
    mutation uploadGrantData($input: GrantUploadInput!) {
  uploadGrantData(input: $input)
}
    `;
export const useUploadGrantDataMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UploadGrantDataMutation, TError, UploadGrantDataMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UploadGrantDataMutation, TError, UploadGrantDataMutationVariables, TContext>(
      ['uploadGrantData'],
      (variables?: UploadGrantDataMutationVariables) => fetcher<UploadGrantDataMutation, UploadGrantDataMutationVariables>(client, UploadGrantDataDocument, variables, headers)(),
      options
    );
useUploadGrantDataMutation.getKey = () => ['uploadGrantData'];

export const CreateVestingScheduleDocument = `
    mutation createVestingSchedule($input: CreateVestingScheduleInput!) {
  createVestingSchedule(input: $input) {
    vestingScheduleId
    grantId
    scheduleType
    cliffDurationMonths
    vestingFrequency
    totalVestingDurationMonths
    performanceCriteria
    metadata
    createdAt
    updatedAt
    planName
    vestingTemplateName
    vestedOptions
  }
}
    `;
export const useCreateVestingScheduleMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateVestingScheduleMutation, TError, CreateVestingScheduleMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateVestingScheduleMutation, TError, CreateVestingScheduleMutationVariables, TContext>(
      ['createVestingSchedule'],
      (variables?: CreateVestingScheduleMutationVariables) => fetcher<CreateVestingScheduleMutation, CreateVestingScheduleMutationVariables>(client, CreateVestingScheduleDocument, variables, headers)(),
      options
    );
useCreateVestingScheduleMutation.getKey = () => ['createVestingSchedule'];

export const UpdateVestingScheduleDocument = `
    mutation updateVestingSchedule($input: UpdateVestingScheduleInput!) {
  updateVestingSchedule(input: $input) {
    vestingScheduleId
    grantId
    scheduleType
    cliffDurationMonths
    vestingFrequency
    totalVestingDurationMonths
    performanceCriteria
    planName
    metadata
    vestingTemplateName
    vestedOptions
    updatedAt
  }
}
    `;
export const useUpdateVestingScheduleMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateVestingScheduleMutation, TError, UpdateVestingScheduleMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateVestingScheduleMutation, TError, UpdateVestingScheduleMutationVariables, TContext>(
      ['updateVestingSchedule'],
      (variables?: UpdateVestingScheduleMutationVariables) => fetcher<UpdateVestingScheduleMutation, UpdateVestingScheduleMutationVariables>(client, UpdateVestingScheduleDocument, variables, headers)(),
      options
    );
useUpdateVestingScheduleMutation.getKey = () => ['updateVestingSchedule'];

export const GetPortfolioOverviewReportDocument = `
    query getPortfolioOverviewReport {
  portfolioOverviewReport
}
    `;
export const useGetPortfolioOverviewReportQuery = <
      TData = GetPortfolioOverviewReportQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetPortfolioOverviewReportQueryVariables,
      options?: UseQueryOptions<GetPortfolioOverviewReportQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetPortfolioOverviewReportQuery, TError, TData>(
      variables === undefined ? ['getPortfolioOverviewReport'] : ['getPortfolioOverviewReport', variables],
      fetcher<GetPortfolioOverviewReportQuery, GetPortfolioOverviewReportQueryVariables>(client, GetPortfolioOverviewReportDocument, variables, headers),
      options
    );

useGetPortfolioOverviewReportQuery.getKey = (variables?: GetPortfolioOverviewReportQueryVariables) => variables === undefined ? ['getPortfolioOverviewReport'] : ['getPortfolioOverviewReport', variables];
;

export const GetCompanyWiseReportDocument = `
    query getCompanyWiseReport($input: [CompanyDataInput]) {
  companyWiseReport(input: $input)
}
    `;
export const useGetCompanyWiseReportQuery = <
      TData = GetCompanyWiseReportQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetCompanyWiseReportQueryVariables,
      options?: UseQueryOptions<GetCompanyWiseReportQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetCompanyWiseReportQuery, TError, TData>(
      variables === undefined ? ['getCompanyWiseReport'] : ['getCompanyWiseReport', variables],
      fetcher<GetCompanyWiseReportQuery, GetCompanyWiseReportQueryVariables>(client, GetCompanyWiseReportDocument, variables, headers),
      options
    );

useGetCompanyWiseReportQuery.getKey = (variables?: GetCompanyWiseReportQueryVariables) => variables === undefined ? ['getCompanyWiseReport'] : ['getCompanyWiseReport', variables];
;

export const GetAllFundsOfUserDocument = `
    query GetAllFundsOfUser($input: BigInt) {
  getAllFundsOfUser(userId: $input)
}
    `;
export const useGetAllFundsOfUserQuery = <
      TData = GetAllFundsOfUserQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetAllFundsOfUserQueryVariables,
      options?: UseQueryOptions<GetAllFundsOfUserQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetAllFundsOfUserQuery, TError, TData>(
      variables === undefined ? ['GetAllFundsOfUser'] : ['GetAllFundsOfUser', variables],
      fetcher<GetAllFundsOfUserQuery, GetAllFundsOfUserQueryVariables>(client, GetAllFundsOfUserDocument, variables, headers),
      options
    );

useGetAllFundsOfUserQuery.getKey = (variables?: GetAllFundsOfUserQueryVariables) => variables === undefined ? ['GetAllFundsOfUser'] : ['GetAllFundsOfUser', variables];
;

export const GetAllUsersOfAccountDocument = `
    query GetAllUsersOfAccount {
  getAllUsersOfAccount {
    id
    name
    emailId
    type
    accountId
    isAccountAdmin
    role
  }
}
    `;
export const useGetAllUsersOfAccountQuery = <
      TData = GetAllUsersOfAccountQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetAllUsersOfAccountQueryVariables,
      options?: UseQueryOptions<GetAllUsersOfAccountQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetAllUsersOfAccountQuery, TError, TData>(
      variables === undefined ? ['GetAllUsersOfAccount'] : ['GetAllUsersOfAccount', variables],
      fetcher<GetAllUsersOfAccountQuery, GetAllUsersOfAccountQueryVariables>(client, GetAllUsersOfAccountDocument, variables, headers),
      options
    );

useGetAllUsersOfAccountQuery.getKey = (variables?: GetAllUsersOfAccountQueryVariables) => variables === undefined ? ['GetAllUsersOfAccount'] : ['GetAllUsersOfAccount', variables];
;

export const UpdateRoleOfInvestorDocument = `
    mutation UpdateRoleOfInvestor($input: UpdateRoleOfInvestorInput) {
  updateRoleOfInvestor(input: $input)
}
    `;
export const useUpdateRoleOfInvestorMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateRoleOfInvestorMutation, TError, UpdateRoleOfInvestorMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateRoleOfInvestorMutation, TError, UpdateRoleOfInvestorMutationVariables, TContext>(
      ['UpdateRoleOfInvestor'],
      (variables?: UpdateRoleOfInvestorMutationVariables) => fetcher<UpdateRoleOfInvestorMutation, UpdateRoleOfInvestorMutationVariables>(client, UpdateRoleOfInvestorDocument, variables, headers)(),
      options
    );
useUpdateRoleOfInvestorMutation.getKey = () => ['UpdateRoleOfInvestor'];

export const RemoveCompaniesOfInvestorDocument = `
    mutation RemoveCompaniesOfInvestor($input: RemoveInvestorCompaniesInput) {
  removeCompaniesOfInvestor(input: $input) {
    companyType
    companyId
    companyName
  }
}
    `;
export const useRemoveCompaniesOfInvestorMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RemoveCompaniesOfInvestorMutation, TError, RemoveCompaniesOfInvestorMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RemoveCompaniesOfInvestorMutation, TError, RemoveCompaniesOfInvestorMutationVariables, TContext>(
      ['RemoveCompaniesOfInvestor'],
      (variables?: RemoveCompaniesOfInvestorMutationVariables) => fetcher<RemoveCompaniesOfInvestorMutation, RemoveCompaniesOfInvestorMutationVariables>(client, RemoveCompaniesOfInvestorDocument, variables, headers)(),
      options
    );
useRemoveCompaniesOfInvestorMutation.getKey = () => ['RemoveCompaniesOfInvestor'];

export const RemoveInvestorOfUserDocument = `
    mutation RemoveInvestorOfUser($input: RemoveInvestorOfUserInput!) {
  removeInvestorOfUser(input: $input)
}
    `;
export const useRemoveInvestorOfUserMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RemoveInvestorOfUserMutation, TError, RemoveInvestorOfUserMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RemoveInvestorOfUserMutation, TError, RemoveInvestorOfUserMutationVariables, TContext>(
      ['RemoveInvestorOfUser'],
      (variables?: RemoveInvestorOfUserMutationVariables) => fetcher<RemoveInvestorOfUserMutation, RemoveInvestorOfUserMutationVariables>(client, RemoveInvestorOfUserDocument, variables, headers)(),
      options
    );
useRemoveInvestorOfUserMutation.getKey = () => ['RemoveInvestorOfUser'];

export const RemoveUserFromAccountDocument = `
    mutation RemoveUserFromAccount($input: BigInt!) {
  removeUserFromAccount(userId: $input)
}
    `;
export const useRemoveUserFromAccountMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RemoveUserFromAccountMutation, TError, RemoveUserFromAccountMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RemoveUserFromAccountMutation, TError, RemoveUserFromAccountMutationVariables, TContext>(
      ['RemoveUserFromAccount'],
      (variables?: RemoveUserFromAccountMutationVariables) => fetcher<RemoveUserFromAccountMutation, RemoveUserFromAccountMutationVariables>(client, RemoveUserFromAccountDocument, variables, headers)(),
      options
    );
useRemoveUserFromAccountMutation.getKey = () => ['RemoveUserFromAccount'];

export const GetExistingCompaniesOfInvestorDocument = `
    query getExistingCompaniesOfInvestor($input: RemoveInvestorOfUserInput) {
  getCompaniesOfOtherInvestor(input: $input) {
    companyId
    companyName
    companyType
  }
}
    `;
export const useGetExistingCompaniesOfInvestorQuery = <
      TData = GetExistingCompaniesOfInvestorQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetExistingCompaniesOfInvestorQueryVariables,
      options?: UseQueryOptions<GetExistingCompaniesOfInvestorQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetExistingCompaniesOfInvestorQuery, TError, TData>(
      variables === undefined ? ['getExistingCompaniesOfInvestor'] : ['getExistingCompaniesOfInvestor', variables],
      fetcher<GetExistingCompaniesOfInvestorQuery, GetExistingCompaniesOfInvestorQueryVariables>(client, GetExistingCompaniesOfInvestorDocument, variables, headers),
      options
    );

useGetExistingCompaniesOfInvestorQuery.getKey = (variables?: GetExistingCompaniesOfInvestorQueryVariables) => variables === undefined ? ['getExistingCompaniesOfInvestor'] : ['getExistingCompaniesOfInvestor', variables];
;

export const InvalidateAllCacheDocument = `
    mutation InvalidateAllCache {
  invalidateAllCache {
    success
    message
    keysCleared
  }
}
    `;
export const useInvalidateAllCacheMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<InvalidateAllCacheMutation, TError, InvalidateAllCacheMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<InvalidateAllCacheMutation, TError, InvalidateAllCacheMutationVariables, TContext>(
      ['InvalidateAllCache'],
      (variables?: InvalidateAllCacheMutationVariables) => fetcher<InvalidateAllCacheMutation, InvalidateAllCacheMutationVariables>(client, InvalidateAllCacheDocument, variables, headers)(),
      options
    );
useInvalidateAllCacheMutation.getKey = () => ['InvalidateAllCache'];

export const GetAllDynamicTableFilterDocument = `
    query GetAllDynamicTableFilter($input: GetAllDynamicFilterInput) {
  getAllDynamicTableFilter(input: $input) {
    id
    tableId
    filterName
    filterState
    tableName
  }
}
    `;
export const useGetAllDynamicTableFilterQuery = <
      TData = GetAllDynamicTableFilterQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetAllDynamicTableFilterQueryVariables,
      options?: UseQueryOptions<GetAllDynamicTableFilterQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetAllDynamicTableFilterQuery, TError, TData>(
      variables === undefined ? ['GetAllDynamicTableFilter'] : ['GetAllDynamicTableFilter', variables],
      fetcher<GetAllDynamicTableFilterQuery, GetAllDynamicTableFilterQueryVariables>(client, GetAllDynamicTableFilterDocument, variables, headers),
      options
    );

useGetAllDynamicTableFilterQuery.getKey = (variables?: GetAllDynamicTableFilterQueryVariables) => variables === undefined ? ['GetAllDynamicTableFilter'] : ['GetAllDynamicTableFilter', variables];
;

export const CreateDynamicTableFilterDocument = `
    mutation CreateDynamicTableFilter($input: DynamicTableFilterInput) {
  createDynamicTableFilter(input: $input)
}
    `;
export const useCreateDynamicTableFilterMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateDynamicTableFilterMutation, TError, CreateDynamicTableFilterMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateDynamicTableFilterMutation, TError, CreateDynamicTableFilterMutationVariables, TContext>(
      ['CreateDynamicTableFilter'],
      (variables?: CreateDynamicTableFilterMutationVariables) => fetcher<CreateDynamicTableFilterMutation, CreateDynamicTableFilterMutationVariables>(client, CreateDynamicTableFilterDocument, variables, headers)(),
      options
    );
useCreateDynamicTableFilterMutation.getKey = () => ['CreateDynamicTableFilter'];

export const RemoveDynamicTableFilterDocument = `
    mutation RemoveDynamicTableFilter($input: GetDynamicFilterInput) {
  removeDynamicTableFilter(input: $input)
}
    `;
export const useRemoveDynamicTableFilterMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RemoveDynamicTableFilterMutation, TError, RemoveDynamicTableFilterMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RemoveDynamicTableFilterMutation, TError, RemoveDynamicTableFilterMutationVariables, TContext>(
      ['RemoveDynamicTableFilter'],
      (variables?: RemoveDynamicTableFilterMutationVariables) => fetcher<RemoveDynamicTableFilterMutation, RemoveDynamicTableFilterMutationVariables>(client, RemoveDynamicTableFilterDocument, variables, headers)(),
      options
    );
useRemoveDynamicTableFilterMutation.getKey = () => ['RemoveDynamicTableFilter'];

export const SetDynamicTablePublicAccessDocument = `
    mutation SetDynamicTablePublicAccess($input: DynamicTablePublicAccessInput) {
  setDynamicTablePublicAccess(input: $input)
}
    `;
export const useSetDynamicTablePublicAccessMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SetDynamicTablePublicAccessMutation, TError, SetDynamicTablePublicAccessMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SetDynamicTablePublicAccessMutation, TError, SetDynamicTablePublicAccessMutationVariables, TContext>(
      ['SetDynamicTablePublicAccess'],
      (variables?: SetDynamicTablePublicAccessMutationVariables) => fetcher<SetDynamicTablePublicAccessMutation, SetDynamicTablePublicAccessMutationVariables>(client, SetDynamicTablePublicAccessDocument, variables, headers)(),
      options
    );
useSetDynamicTablePublicAccessMutation.getKey = () => ['SetDynamicTablePublicAccess'];

export const AddInvestorToUserDocument = `
    mutation AddInvestorToUser($input: AddInvestorToUserInput!) {
  addInvestorToUser(input: $input) {
    id
    name
  }
}
    `;
export const useAddInvestorToUserMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddInvestorToUserMutation, TError, AddInvestorToUserMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddInvestorToUserMutation, TError, AddInvestorToUserMutationVariables, TContext>(
      ['AddInvestorToUser'],
      (variables?: AddInvestorToUserMutationVariables) => fetcher<AddInvestorToUserMutation, AddInvestorToUserMutationVariables>(client, AddInvestorToUserDocument, variables, headers)(),
      options
    );
useAddInvestorToUserMutation.getKey = () => ['AddInvestorToUser'];

export const AddMultipleInvestorToMultipleUserDocument = `
    mutation AddMultipleInvestorToMultipleUser($input: AddMultipleInvestorToMultipleUserInput) {
  addMultipleInvestorsToMultipleUsers(input: $input)
}
    `;
export const useAddMultipleInvestorToMultipleUserMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddMultipleInvestorToMultipleUserMutation, TError, AddMultipleInvestorToMultipleUserMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddMultipleInvestorToMultipleUserMutation, TError, AddMultipleInvestorToMultipleUserMutationVariables, TContext>(
      ['AddMultipleInvestorToMultipleUser'],
      (variables?: AddMultipleInvestorToMultipleUserMutationVariables) => fetcher<AddMultipleInvestorToMultipleUserMutation, AddMultipleInvestorToMultipleUserMutationVariables>(client, AddMultipleInvestorToMultipleUserDocument, variables, headers)(),
      options
    );
useAddMultipleInvestorToMultipleUserMutation.getKey = () => ['AddMultipleInvestorToMultipleUser'];

export const AddEoiDocument = `
    mutation addEoi($input: EoiInput!) {
  addEoi(input: $input) {
    id
    companyId
    companyName
    companyCin
    hissaCompanyId
    offerDetails
    esopFinancing
    notes
    companyType
    offerType
    comments
  }
}
    `;
export const useAddEoiMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddEoiMutation, TError, AddEoiMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddEoiMutation, TError, AddEoiMutationVariables, TContext>(
      ['addEoi'],
      (variables?: AddEoiMutationVariables) => fetcher<AddEoiMutation, AddEoiMutationVariables>(client, AddEoiDocument, variables, headers)(),
      options
    );
useAddEoiMutation.getKey = () => ['addEoi'];

export const GetEoiForAllUsersDocument = `
    query getEoiForAllUsers {
  getEoiForAllUsers {
    id
    companyId
    companyName
    companyCin
    hissaCompanyId
    offerDetails
    esopFinancing
    notes
    companyType
    offerType
    comments
    createdAt
  }
}
    `;
export const useGetEoiForAllUsersQuery = <
      TData = GetEoiForAllUsersQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetEoiForAllUsersQueryVariables,
      options?: UseQueryOptions<GetEoiForAllUsersQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetEoiForAllUsersQuery, TError, TData>(
      variables === undefined ? ['getEoiForAllUsers'] : ['getEoiForAllUsers', variables],
      fetcher<GetEoiForAllUsersQuery, GetEoiForAllUsersQueryVariables>(client, GetEoiForAllUsersDocument, variables, headers),
      options
    );

useGetEoiForAllUsersQuery.getKey = (variables?: GetEoiForAllUsersQueryVariables) => variables === undefined ? ['getEoiForAllUsers'] : ['getEoiForAllUsers', variables];
;

export const SyncGoogleSheetToS3Document = `
    mutation syncGoogleSheetToS3($input: SyncGoogleSheetInput!) {
  syncGoogleSheetToS3(input: $input)
}
    `;
export const useSyncGoogleSheetToS3Mutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SyncGoogleSheetToS3Mutation, TError, SyncGoogleSheetToS3MutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SyncGoogleSheetToS3Mutation, TError, SyncGoogleSheetToS3MutationVariables, TContext>(
      ['syncGoogleSheetToS3'],
      (variables?: SyncGoogleSheetToS3MutationVariables) => fetcher<SyncGoogleSheetToS3Mutation, SyncGoogleSheetToS3MutationVariables>(client, SyncGoogleSheetToS3Document, variables, headers)(),
      options
    );
useSyncGoogleSheetToS3Mutation.getKey = () => ['syncGoogleSheetToS3'];

export const SwitchAccountDocument = `
    mutation switchAccount($input: SwitchAccountInput!) {
  switchAccount(input: $input)
}
    `;
export const useSwitchAccountMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SwitchAccountMutation, TError, SwitchAccountMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SwitchAccountMutation, TError, SwitchAccountMutationVariables, TContext>(
      ['switchAccount'],
      (variables?: SwitchAccountMutationVariables) => fetcher<SwitchAccountMutation, SwitchAccountMutationVariables>(client, SwitchAccountDocument, variables, headers)(),
      options
    );
useSwitchAccountMutation.getKey = () => ['switchAccount'];
